var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __reflectGet = Reflect.get;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __superGet = (cls, obj, key) => __reflectGet(__getProtoOf(cls), key, obj);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// node_modules/uri-js/dist/es5/uri.all.js
var require_uri_all = __commonJS({
  "node_modules/uri-js/dist/es5/uri.all.js"(exports, module) {
    (function(global, factory) {
      typeof exports === "object" && typeof module !== "undefined" ? factory(exports) : typeof define === "function" && define.amd ? define(["exports"], factory) : factory(global.URI = global.URI || {});
    })(exports, function(exports2) {
      "use strict";
      function merge() {
        for (var _len = arguments.length, sets = Array(_len), _key = 0; _key < _len; _key++) {
          sets[_key] = arguments[_key];
        }
        if (sets.length > 1) {
          sets[0] = sets[0].slice(0, -1);
          var xl = sets.length - 1;
          for (var x = 1; x < xl; ++x) {
            sets[x] = sets[x].slice(1, -1);
          }
          sets[xl] = sets[xl].slice(1);
          return sets.join("");
        } else {
          return sets[0];
        }
      }
      function subexp(str) {
        return "(?:" + str + ")";
      }
      function typeOf(o) {
        return o === void 0 ? "undefined" : o === null ? "null" : Object.prototype.toString.call(o).split(" ").pop().split("]").shift().toLowerCase();
      }
      function toUpperCase(str) {
        return str.toUpperCase();
      }
      function toArray(obj) {
        return obj !== void 0 && obj !== null ? obj instanceof Array ? obj : typeof obj.length !== "number" || obj.split || obj.setInterval || obj.call ? [obj] : Array.prototype.slice.call(obj) : [];
      }
      function assign(target, source) {
        var obj = target;
        if (source) {
          for (var key in source) {
            obj[key] = source[key];
          }
        }
        return obj;
      }
      function buildExps(isIRI2) {
        var ALPHA$$ = "[A-Za-z]", CR$ = "[\\x0D]", DIGIT$$ = "[0-9]", DQUOTE$$ = "[\\x22]", HEXDIG$$2 = merge(DIGIT$$, "[A-Fa-f]"), LF$$ = "[\\x0A]", SP$$ = "[\\x20]", PCT_ENCODED$2 = subexp(subexp("%[EFef]" + HEXDIG$$2 + "%" + HEXDIG$$2 + HEXDIG$$2 + "%" + HEXDIG$$2 + HEXDIG$$2) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$2 + "%" + HEXDIG$$2 + HEXDIG$$2) + "|" + subexp("%" + HEXDIG$$2 + HEXDIG$$2)), GEN_DELIMS$$ = "[\\:\\/\\?\\#\\[\\]\\@]", SUB_DELIMS$$ = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]", RESERVED$$ = merge(GEN_DELIMS$$, SUB_DELIMS$$), UCSCHAR$$ = isIRI2 ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]", IPRIVATE$$ = isIRI2 ? "[\\uE000-\\uF8FF]" : "[]", UNRESERVED$$2 = merge(ALPHA$$, DIGIT$$, "[\\-\\.\\_\\~]", UCSCHAR$$), SCHEME$ = subexp(ALPHA$$ + merge(ALPHA$$, DIGIT$$, "[\\+\\-\\.]") + "*"), USERINFO$ = subexp(subexp(PCT_ENCODED$2 + "|" + merge(UNRESERVED$$2, SUB_DELIMS$$, "[\\:]")) + "*"), DEC_OCTET$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("[1-9]" + DIGIT$$) + "|" + DIGIT$$), DEC_OCTET_RELAXED$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("0?[1-9]" + DIGIT$$) + "|0?0?" + DIGIT$$), IPV4ADDRESS$ = subexp(DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$), H16$ = subexp(HEXDIG$$2 + "{1,4}"), LS32$ = subexp(subexp(H16$ + "\\:" + H16$) + "|" + IPV4ADDRESS$), IPV6ADDRESS1$ = subexp(subexp(H16$ + "\\:") + "{6}" + LS32$), IPV6ADDRESS2$ = subexp("\\:\\:" + subexp(H16$ + "\\:") + "{5}" + LS32$), IPV6ADDRESS3$ = subexp(subexp(H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{4}" + LS32$), IPV6ADDRESS4$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,1}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{3}" + LS32$), IPV6ADDRESS5$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,2}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{2}" + LS32$), IPV6ADDRESS6$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,3}" + H16$) + "?\\:\\:" + H16$ + "\\:" + LS32$), IPV6ADDRESS7$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,4}" + H16$) + "?\\:\\:" + LS32$), IPV6ADDRESS8$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,5}" + H16$) + "?\\:\\:" + H16$), IPV6ADDRESS9$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,6}" + H16$) + "?\\:\\:"), IPV6ADDRESS$ = subexp([IPV6ADDRESS1$, IPV6ADDRESS2$, IPV6ADDRESS3$, IPV6ADDRESS4$, IPV6ADDRESS5$, IPV6ADDRESS6$, IPV6ADDRESS7$, IPV6ADDRESS8$, IPV6ADDRESS9$].join("|")), ZONEID$ = subexp(subexp(UNRESERVED$$2 + "|" + PCT_ENCODED$2) + "+"), IPV6ADDRZ$ = subexp(IPV6ADDRESS$ + "\\%25" + ZONEID$), IPV6ADDRZ_RELAXED$ = subexp(IPV6ADDRESS$ + subexp("\\%25|\\%(?!" + HEXDIG$$2 + "{2})") + ZONEID$), IPVFUTURE$ = subexp("[vV]" + HEXDIG$$2 + "+\\." + merge(UNRESERVED$$2, SUB_DELIMS$$, "[\\:]") + "+"), IP_LITERAL$ = subexp("\\[" + subexp(IPV6ADDRZ_RELAXED$ + "|" + IPV6ADDRESS$ + "|" + IPVFUTURE$) + "\\]"), REG_NAME$ = subexp(subexp(PCT_ENCODED$2 + "|" + merge(UNRESERVED$$2, SUB_DELIMS$$)) + "*"), HOST$ = subexp(IP_LITERAL$ + "|" + IPV4ADDRESS$ + "(?!" + REG_NAME$ + ")|" + REG_NAME$), PORT$ = subexp(DIGIT$$ + "*"), AUTHORITY$ = subexp(subexp(USERINFO$ + "@") + "?" + HOST$ + subexp("\\:" + PORT$) + "?"), PCHAR$ = subexp(PCT_ENCODED$2 + "|" + merge(UNRESERVED$$2, SUB_DELIMS$$, "[\\:\\@]")), SEGMENT$ = subexp(PCHAR$ + "*"), SEGMENT_NZ$ = subexp(PCHAR$ + "+"), SEGMENT_NZ_NC$ = subexp(subexp(PCT_ENCODED$2 + "|" + merge(UNRESERVED$$2, SUB_DELIMS$$, "[\\@]")) + "+"), PATH_ABEMPTY$ = subexp(subexp("\\/" + SEGMENT$) + "*"), PATH_ABSOLUTE$ = subexp("\\/" + subexp(SEGMENT_NZ$ + PATH_ABEMPTY$) + "?"), PATH_NOSCHEME$ = subexp(SEGMENT_NZ_NC$ + PATH_ABEMPTY$), PATH_ROOTLESS$ = subexp(SEGMENT_NZ$ + PATH_ABEMPTY$), PATH_EMPTY$ = "(?!" + PCHAR$ + ")", PATH$ = subexp(PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$), QUERY$ = subexp(subexp(PCHAR$ + "|" + merge("[\\/\\?]", IPRIVATE$$)) + "*"), FRAGMENT$ = subexp(subexp(PCHAR$ + "|[\\/\\?]") + "*"), HIER_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$), URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"), RELATIVE_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$), RELATIVE$ = subexp(RELATIVE_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"), URI_REFERENCE$ = subexp(URI$ + "|" + RELATIVE$), ABSOLUTE_URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?"), GENERIC_REF$ = "^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", RELATIVE_REF$ = "^(){0}" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", ABSOLUTE_REF$ = "^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?$", SAMEDOC_REF$ = "^" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", AUTHORITY_REF$ = "^" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?$";
        return {
          NOT_SCHEME: new RegExp(merge("[^]", ALPHA$$, DIGIT$$, "[\\+\\-\\.]"), "g"),
          NOT_USERINFO: new RegExp(merge("[^\\%\\:]", UNRESERVED$$2, SUB_DELIMS$$), "g"),
          NOT_HOST: new RegExp(merge("[^\\%\\[\\]\\:]", UNRESERVED$$2, SUB_DELIMS$$), "g"),
          NOT_PATH: new RegExp(merge("[^\\%\\/\\:\\@]", UNRESERVED$$2, SUB_DELIMS$$), "g"),
          NOT_PATH_NOSCHEME: new RegExp(merge("[^\\%\\/\\@]", UNRESERVED$$2, SUB_DELIMS$$), "g"),
          NOT_QUERY: new RegExp(merge("[^\\%]", UNRESERVED$$2, SUB_DELIMS$$, "[\\:\\@\\/\\?]", IPRIVATE$$), "g"),
          NOT_FRAGMENT: new RegExp(merge("[^\\%]", UNRESERVED$$2, SUB_DELIMS$$, "[\\:\\@\\/\\?]"), "g"),
          ESCAPE: new RegExp(merge("[^]", UNRESERVED$$2, SUB_DELIMS$$), "g"),
          UNRESERVED: new RegExp(UNRESERVED$$2, "g"),
          OTHER_CHARS: new RegExp(merge("[^\\%]", UNRESERVED$$2, RESERVED$$), "g"),
          PCT_ENCODED: new RegExp(PCT_ENCODED$2, "g"),
          IPV4ADDRESS: new RegExp("^(" + IPV4ADDRESS$ + ")$"),
          IPV6ADDRESS: new RegExp("^\\[?(" + IPV6ADDRESS$ + ")" + subexp(subexp("\\%25|\\%(?!" + HEXDIG$$2 + "{2})") + "(" + ZONEID$ + ")") + "?\\]?$")
          //RFC 6874, with relaxed parsing rules
        };
      }
      var URI_PROTOCOL = buildExps(false);
      var IRI_PROTOCOL = buildExps(true);
      var slicedToArray = function() {
        function sliceIterator(arr, i) {
          var _arr = [];
          var _n = true;
          var _d = false;
          var _e = void 0;
          try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);
              if (i && _arr.length === i)
                break;
            }
          } catch (err) {
            _d = true;
            _e = err;
          } finally {
            try {
              if (!_n && _i["return"])
                _i["return"]();
            } finally {
              if (_d)
                throw _e;
            }
          }
          return _arr;
        }
        return function(arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();
      var toConsumableArray = function(arr) {
        if (Array.isArray(arr)) {
          for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++)
            arr2[i] = arr[i];
          return arr2;
        } else {
          return Array.from(arr);
        }
      };
      var maxInt = 2147483647;
      var base = 36;
      var tMin = 1;
      var tMax = 26;
      var skew = 38;
      var damp = 700;
      var initialBias = 72;
      var initialN = 128;
      var delimiter = "-";
      var regexPunycode = /^xn--/;
      var regexNonASCII = /[^\0-\x7E]/;
      var regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g;
      var errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
      };
      var baseMinusTMin = base - tMin;
      var floor = Math.floor;
      var stringFromCharCode = String.fromCharCode;
      function error$1(type) {
        throw new RangeError(errors[type]);
      }
      function map(array, fn) {
        var result = [];
        var length2 = array.length;
        while (length2--) {
          result[length2] = fn(array[length2]);
        }
        return result;
      }
      function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
          result = parts[0] + "@";
          string = parts[1];
        }
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
      }
      function ucs2decode(string) {
        var output = [];
        var counter = 0;
        var length2 = string.length;
        while (counter < length2) {
          var value = string.charCodeAt(counter++);
          if (value >= 55296 && value <= 56319 && counter < length2) {
            var extra = string.charCodeAt(counter++);
            if ((extra & 64512) == 56320) {
              output.push(((value & 1023) << 10) + (extra & 1023) + 65536);
            } else {
              output.push(value);
              counter--;
            }
          } else {
            output.push(value);
          }
        }
        return output;
      }
      var ucs2encode = function ucs2encode2(array) {
        return String.fromCodePoint.apply(String, toConsumableArray(array));
      };
      var basicToDigit = function basicToDigit2(codePoint) {
        if (codePoint - 48 < 10) {
          return codePoint - 22;
        }
        if (codePoint - 65 < 26) {
          return codePoint - 65;
        }
        if (codePoint - 97 < 26) {
          return codePoint - 97;
        }
        return base;
      };
      var digitToBasic = function digitToBasic2(digit, flag) {
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
      };
      var adapt = function adapt2(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for (
          ;
          /* no initialization */
          delta > baseMinusTMin * tMax >> 1;
          k += base
        ) {
          delta = floor(delta / baseMinusTMin);
        }
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
      };
      var decode = function decode2(input) {
        var output = [];
        var inputLength = input.length;
        var i = 0;
        var n = initialN;
        var bias = initialBias;
        var basic = input.lastIndexOf(delimiter);
        if (basic < 0) {
          basic = 0;
        }
        for (var j = 0; j < basic; ++j) {
          if (input.charCodeAt(j) >= 128) {
            error$1("not-basic");
          }
          output.push(input.charCodeAt(j));
        }
        for (var index = basic > 0 ? basic + 1 : 0; index < inputLength; ) {
          var oldi = i;
          for (
            var w = 1, k = base;
            ;
            /* no condition */
            k += base
          ) {
            if (index >= inputLength) {
              error$1("invalid-input");
            }
            var digit = basicToDigit(input.charCodeAt(index++));
            if (digit >= base || digit > floor((maxInt - i) / w)) {
              error$1("overflow");
            }
            i += digit * w;
            var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
            if (digit < t) {
              break;
            }
            var baseMinusT = base - t;
            if (w > floor(maxInt / baseMinusT)) {
              error$1("overflow");
            }
            w *= baseMinusT;
          }
          var out = output.length + 1;
          bias = adapt(i - oldi, out, oldi == 0);
          if (floor(i / out) > maxInt - n) {
            error$1("overflow");
          }
          n += floor(i / out);
          i %= out;
          output.splice(i++, 0, n);
        }
        return String.fromCodePoint.apply(String, output);
      };
      var encode = function encode2(input) {
        var output = [];
        input = ucs2decode(input);
        var inputLength = input.length;
        var n = initialN;
        var delta = 0;
        var bias = initialBias;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = void 0;
        try {
          for (var _iterator = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _currentValue2 = _step.value;
            if (_currentValue2 < 128) {
              output.push(stringFromCharCode(_currentValue2));
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
        var basicLength = output.length;
        var handledCPCount = basicLength;
        if (basicLength) {
          output.push(delimiter);
        }
        while (handledCPCount < inputLength) {
          var m = maxInt;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = void 0;
          try {
            for (var _iterator2 = input[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var currentValue = _step2.value;
              if (currentValue >= n && currentValue < m) {
                m = currentValue;
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
          var handledCPCountPlusOne = handledCPCount + 1;
          if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
            error$1("overflow");
          }
          delta += (m - n) * handledCPCountPlusOne;
          n = m;
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = void 0;
          try {
            for (var _iterator3 = input[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var _currentValue = _step3.value;
              if (_currentValue < n && ++delta > maxInt) {
                error$1("overflow");
              }
              if (_currentValue == n) {
                var q = delta;
                for (
                  var k = base;
                  ;
                  /* no condition */
                  k += base
                ) {
                  var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                  if (q < t) {
                    break;
                  }
                  var qMinusT = q - t;
                  var baseMinusT = base - t;
                  output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                  q = floor(qMinusT / baseMinusT);
                }
                output.push(stringFromCharCode(digitToBasic(q, 0)));
                bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                delta = 0;
                ++handledCPCount;
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
          ++delta;
          ++n;
        }
        return output.join("");
      };
      var toUnicode = function toUnicode2(input) {
        return mapDomain(input, function(string) {
          return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
      };
      var toASCII = function toASCII2(input) {
        return mapDomain(input, function(string) {
          return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
      };
      var punycode = {
        /**
         * A string representing the current Punycode.js version number.
         * @memberOf punycode
         * @type String
         */
        "version": "2.1.0",
        /**
         * An object of methods to convert from JavaScript's internal character
         * representation (UCS-2) to Unicode code points, and back.
         * @see <https://mathiasbynens.be/notes/javascript-encoding>
         * @memberOf punycode
         * @type Object
         */
        "ucs2": {
          "decode": ucs2decode,
          "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
      };
      var SCHEMES = {};
      function pctEncChar(chr) {
        var c = chr.charCodeAt(0);
        var e = void 0;
        if (c < 16)
          e = "%0" + c.toString(16).toUpperCase();
        else if (c < 128)
          e = "%" + c.toString(16).toUpperCase();
        else if (c < 2048)
          e = "%" + (c >> 6 | 192).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();
        else
          e = "%" + (c >> 12 | 224).toString(16).toUpperCase() + "%" + (c >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();
        return e;
      }
      function pctDecChars(str) {
        var newStr = "";
        var i = 0;
        var il = str.length;
        while (i < il) {
          var c = parseInt(str.substr(i + 1, 2), 16);
          if (c < 128) {
            newStr += String.fromCharCode(c);
            i += 3;
          } else if (c >= 194 && c < 224) {
            if (il - i >= 6) {
              var c2 = parseInt(str.substr(i + 4, 2), 16);
              newStr += String.fromCharCode((c & 31) << 6 | c2 & 63);
            } else {
              newStr += str.substr(i, 6);
            }
            i += 6;
          } else if (c >= 224) {
            if (il - i >= 9) {
              var _c = parseInt(str.substr(i + 4, 2), 16);
              var c3 = parseInt(str.substr(i + 7, 2), 16);
              newStr += String.fromCharCode((c & 15) << 12 | (_c & 63) << 6 | c3 & 63);
            } else {
              newStr += str.substr(i, 9);
            }
            i += 9;
          } else {
            newStr += str.substr(i, 3);
            i += 3;
          }
        }
        return newStr;
      }
      function _normalizeComponentEncoding(components, protocol) {
        function decodeUnreserved2(str) {
          var decStr = pctDecChars(str);
          return !decStr.match(protocol.UNRESERVED) ? str : decStr;
        }
        if (components.scheme)
          components.scheme = String(components.scheme).replace(protocol.PCT_ENCODED, decodeUnreserved2).toLowerCase().replace(protocol.NOT_SCHEME, "");
        if (components.userinfo !== void 0)
          components.userinfo = String(components.userinfo).replace(protocol.PCT_ENCODED, decodeUnreserved2).replace(protocol.NOT_USERINFO, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.host !== void 0)
          components.host = String(components.host).replace(protocol.PCT_ENCODED, decodeUnreserved2).toLowerCase().replace(protocol.NOT_HOST, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.path !== void 0)
          components.path = String(components.path).replace(protocol.PCT_ENCODED, decodeUnreserved2).replace(components.scheme ? protocol.NOT_PATH : protocol.NOT_PATH_NOSCHEME, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.query !== void 0)
          components.query = String(components.query).replace(protocol.PCT_ENCODED, decodeUnreserved2).replace(protocol.NOT_QUERY, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.fragment !== void 0)
          components.fragment = String(components.fragment).replace(protocol.PCT_ENCODED, decodeUnreserved2).replace(protocol.NOT_FRAGMENT, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        return components;
      }
      function _stripLeadingZeros(str) {
        return str.replace(/^0*(.*)/, "$1") || "0";
      }
      function _normalizeIPv4(host, protocol) {
        var matches = host.match(protocol.IPV4ADDRESS) || [];
        var _matches = slicedToArray(matches, 2), address = _matches[1];
        if (address) {
          return address.split(".").map(_stripLeadingZeros).join(".");
        } else {
          return host;
        }
      }
      function _normalizeIPv6(host, protocol) {
        var matches = host.match(protocol.IPV6ADDRESS) || [];
        var _matches2 = slicedToArray(matches, 3), address = _matches2[1], zone = _matches2[2];
        if (address) {
          var _address$toLowerCase$ = address.toLowerCase().split("::").reverse(), _address$toLowerCase$2 = slicedToArray(_address$toLowerCase$, 2), last = _address$toLowerCase$2[0], first = _address$toLowerCase$2[1];
          var firstFields = first ? first.split(":").map(_stripLeadingZeros) : [];
          var lastFields = last.split(":").map(_stripLeadingZeros);
          var isLastFieldIPv4Address = protocol.IPV4ADDRESS.test(lastFields[lastFields.length - 1]);
          var fieldCount = isLastFieldIPv4Address ? 7 : 8;
          var lastFieldsStart = lastFields.length - fieldCount;
          var fields = Array(fieldCount);
          for (var x = 0; x < fieldCount; ++x) {
            fields[x] = firstFields[x] || lastFields[lastFieldsStart + x] || "";
          }
          if (isLastFieldIPv4Address) {
            fields[fieldCount - 1] = _normalizeIPv4(fields[fieldCount - 1], protocol);
          }
          var allZeroFields = fields.reduce(function(acc, field, index) {
            if (!field || field === "0") {
              var lastLongest = acc[acc.length - 1];
              if (lastLongest && lastLongest.index + lastLongest.length === index) {
                lastLongest.length++;
              } else {
                acc.push({ index, length: 1 });
              }
            }
            return acc;
          }, []);
          var longestZeroFields = allZeroFields.sort(function(a, b) {
            return b.length - a.length;
          })[0];
          var newHost = void 0;
          if (longestZeroFields && longestZeroFields.length > 1) {
            var newFirst = fields.slice(0, longestZeroFields.index);
            var newLast = fields.slice(longestZeroFields.index + longestZeroFields.length);
            newHost = newFirst.join(":") + "::" + newLast.join(":");
          } else {
            newHost = fields.join(":");
          }
          if (zone) {
            newHost += "%" + zone;
          }
          return newHost;
        } else {
          return host;
        }
      }
      var URI_PARSE = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i;
      var NO_MATCH_IS_UNDEFINED = "".match(/(){0}/)[1] === void 0;
      function parse3(uriString) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var components = {};
        var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
        if (options.reference === "suffix")
          uriString = (options.scheme ? options.scheme + ":" : "") + "//" + uriString;
        var matches = uriString.match(URI_PARSE);
        if (matches) {
          if (NO_MATCH_IS_UNDEFINED) {
            components.scheme = matches[1];
            components.userinfo = matches[3];
            components.host = matches[4];
            components.port = parseInt(matches[5], 10);
            components.path = matches[6] || "";
            components.query = matches[7];
            components.fragment = matches[8];
            if (isNaN(components.port)) {
              components.port = matches[5];
            }
          } else {
            components.scheme = matches[1] || void 0;
            components.userinfo = uriString.indexOf("@") !== -1 ? matches[3] : void 0;
            components.host = uriString.indexOf("//") !== -1 ? matches[4] : void 0;
            components.port = parseInt(matches[5], 10);
            components.path = matches[6] || "";
            components.query = uriString.indexOf("?") !== -1 ? matches[7] : void 0;
            components.fragment = uriString.indexOf("#") !== -1 ? matches[8] : void 0;
            if (isNaN(components.port)) {
              components.port = uriString.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? matches[4] : void 0;
            }
          }
          if (components.host) {
            components.host = _normalizeIPv6(_normalizeIPv4(components.host, protocol), protocol);
          }
          if (components.scheme === void 0 && components.userinfo === void 0 && components.host === void 0 && components.port === void 0 && !components.path && components.query === void 0) {
            components.reference = "same-document";
          } else if (components.scheme === void 0) {
            components.reference = "relative";
          } else if (components.fragment === void 0) {
            components.reference = "absolute";
          } else {
            components.reference = "uri";
          }
          if (options.reference && options.reference !== "suffix" && options.reference !== components.reference) {
            components.error = components.error || "URI is not a " + options.reference + " reference.";
          }
          var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
          if (!options.unicodeSupport && (!schemeHandler || !schemeHandler.unicodeSupport)) {
            if (components.host && (options.domainHost || schemeHandler && schemeHandler.domainHost)) {
              try {
                components.host = punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase());
              } catch (e) {
                components.error = components.error || "Host's domain name can not be converted to ASCII via punycode: " + e;
              }
            }
            _normalizeComponentEncoding(components, URI_PROTOCOL);
          } else {
            _normalizeComponentEncoding(components, protocol);
          }
          if (schemeHandler && schemeHandler.parse) {
            schemeHandler.parse(components, options);
          }
        } else {
          components.error = components.error || "URI can not be parsed.";
        }
        return components;
      }
      function _recomposeAuthority(components, options) {
        var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
        var uriTokens = [];
        if (components.userinfo !== void 0) {
          uriTokens.push(components.userinfo);
          uriTokens.push("@");
        }
        if (components.host !== void 0) {
          uriTokens.push(_normalizeIPv6(_normalizeIPv4(String(components.host), protocol), protocol).replace(protocol.IPV6ADDRESS, function(_, $1, $2) {
            return "[" + $1 + ($2 ? "%25" + $2 : "") + "]";
          }));
        }
        if (typeof components.port === "number" || typeof components.port === "string") {
          uriTokens.push(":");
          uriTokens.push(String(components.port));
        }
        return uriTokens.length ? uriTokens.join("") : void 0;
      }
      var RDS1 = /^\.\.?\//;
      var RDS2 = /^\/\.(\/|$)/;
      var RDS3 = /^\/\.\.(\/|$)/;
      var RDS5 = /^\/?(?:.|\n)*?(?=\/|$)/;
      function removeDotSegments(input) {
        var output = [];
        while (input.length) {
          if (input.match(RDS1)) {
            input = input.replace(RDS1, "");
          } else if (input.match(RDS2)) {
            input = input.replace(RDS2, "/");
          } else if (input.match(RDS3)) {
            input = input.replace(RDS3, "/");
            output.pop();
          } else if (input === "." || input === "..") {
            input = "";
          } else {
            var im = input.match(RDS5);
            if (im) {
              var s = im[0];
              input = input.slice(s.length);
              output.push(s);
            } else {
              throw new Error("Unexpected dot segment condition");
            }
          }
        }
        return output.join("");
      }
      function serialize(components) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var protocol = options.iri ? IRI_PROTOCOL : URI_PROTOCOL;
        var uriTokens = [];
        var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
        if (schemeHandler && schemeHandler.serialize)
          schemeHandler.serialize(components, options);
        if (components.host) {
          if (protocol.IPV6ADDRESS.test(components.host)) {
          } else if (options.domainHost || schemeHandler && schemeHandler.domainHost) {
            try {
              components.host = !options.iri ? punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase()) : punycode.toUnicode(components.host);
            } catch (e) {
              components.error = components.error || "Host's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
            }
          }
        }
        _normalizeComponentEncoding(components, protocol);
        if (options.reference !== "suffix" && components.scheme) {
          uriTokens.push(components.scheme);
          uriTokens.push(":");
        }
        var authority = _recomposeAuthority(components, options);
        if (authority !== void 0) {
          if (options.reference !== "suffix") {
            uriTokens.push("//");
          }
          uriTokens.push(authority);
          if (components.path && components.path.charAt(0) !== "/") {
            uriTokens.push("/");
          }
        }
        if (components.path !== void 0) {
          var s = components.path;
          if (!options.absolutePath && (!schemeHandler || !schemeHandler.absolutePath)) {
            s = removeDotSegments(s);
          }
          if (authority === void 0) {
            s = s.replace(/^\/\//, "/%2F");
          }
          uriTokens.push(s);
        }
        if (components.query !== void 0) {
          uriTokens.push("?");
          uriTokens.push(components.query);
        }
        if (components.fragment !== void 0) {
          uriTokens.push("#");
          uriTokens.push(components.fragment);
        }
        return uriTokens.join("");
      }
      function resolveComponents(base2, relative) {
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var skipNormalization = arguments[3];
        var target = {};
        if (!skipNormalization) {
          base2 = parse3(serialize(base2, options), options);
          relative = parse3(serialize(relative, options), options);
        }
        options = options || {};
        if (!options.tolerant && relative.scheme) {
          target.scheme = relative.scheme;
          target.userinfo = relative.userinfo;
          target.host = relative.host;
          target.port = relative.port;
          target.path = removeDotSegments(relative.path || "");
          target.query = relative.query;
        } else {
          if (relative.userinfo !== void 0 || relative.host !== void 0 || relative.port !== void 0) {
            target.userinfo = relative.userinfo;
            target.host = relative.host;
            target.port = relative.port;
            target.path = removeDotSegments(relative.path || "");
            target.query = relative.query;
          } else {
            if (!relative.path) {
              target.path = base2.path;
              if (relative.query !== void 0) {
                target.query = relative.query;
              } else {
                target.query = base2.query;
              }
            } else {
              if (relative.path.charAt(0) === "/") {
                target.path = removeDotSegments(relative.path);
              } else {
                if ((base2.userinfo !== void 0 || base2.host !== void 0 || base2.port !== void 0) && !base2.path) {
                  target.path = "/" + relative.path;
                } else if (!base2.path) {
                  target.path = relative.path;
                } else {
                  target.path = base2.path.slice(0, base2.path.lastIndexOf("/") + 1) + relative.path;
                }
                target.path = removeDotSegments(target.path);
              }
              target.query = relative.query;
            }
            target.userinfo = base2.userinfo;
            target.host = base2.host;
            target.port = base2.port;
          }
          target.scheme = base2.scheme;
        }
        target.fragment = relative.fragment;
        return target;
      }
      function resolve(baseURI, relativeURI, options) {
        var schemelessOptions = assign({ scheme: "null" }, options);
        return serialize(resolveComponents(parse3(baseURI, schemelessOptions), parse3(relativeURI, schemelessOptions), schemelessOptions, true), schemelessOptions);
      }
      function normalize(uri, options) {
        if (typeof uri === "string") {
          uri = serialize(parse3(uri, options), options);
        } else if (typeOf(uri) === "object") {
          uri = parse3(serialize(uri, options), options);
        }
        return uri;
      }
      function equal(uriA, uriB, options) {
        if (typeof uriA === "string") {
          uriA = serialize(parse3(uriA, options), options);
        } else if (typeOf(uriA) === "object") {
          uriA = serialize(uriA, options);
        }
        if (typeof uriB === "string") {
          uriB = serialize(parse3(uriB, options), options);
        } else if (typeOf(uriB) === "object") {
          uriB = serialize(uriB, options);
        }
        return uriA === uriB;
      }
      function escapeComponent(str, options) {
        return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.ESCAPE : IRI_PROTOCOL.ESCAPE, pctEncChar);
      }
      function unescapeComponent(str, options) {
        return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.PCT_ENCODED : IRI_PROTOCOL.PCT_ENCODED, pctDecChars);
      }
      var handler = {
        scheme: "http",
        domainHost: true,
        parse: function parse4(components, options) {
          if (!components.host) {
            components.error = components.error || "HTTP URIs must have a host.";
          }
          return components;
        },
        serialize: function serialize2(components, options) {
          var secure = String(components.scheme).toLowerCase() === "https";
          if (components.port === (secure ? 443 : 80) || components.port === "") {
            components.port = void 0;
          }
          if (!components.path) {
            components.path = "/";
          }
          return components;
        }
      };
      var handler$1 = {
        scheme: "https",
        domainHost: handler.domainHost,
        parse: handler.parse,
        serialize: handler.serialize
      };
      function isSecure(wsComponents) {
        return typeof wsComponents.secure === "boolean" ? wsComponents.secure : String(wsComponents.scheme).toLowerCase() === "wss";
      }
      var handler$2 = {
        scheme: "ws",
        domainHost: true,
        parse: function parse4(components, options) {
          var wsComponents = components;
          wsComponents.secure = isSecure(wsComponents);
          wsComponents.resourceName = (wsComponents.path || "/") + (wsComponents.query ? "?" + wsComponents.query : "");
          wsComponents.path = void 0;
          wsComponents.query = void 0;
          return wsComponents;
        },
        serialize: function serialize2(wsComponents, options) {
          if (wsComponents.port === (isSecure(wsComponents) ? 443 : 80) || wsComponents.port === "") {
            wsComponents.port = void 0;
          }
          if (typeof wsComponents.secure === "boolean") {
            wsComponents.scheme = wsComponents.secure ? "wss" : "ws";
            wsComponents.secure = void 0;
          }
          if (wsComponents.resourceName) {
            var _wsComponents$resourc = wsComponents.resourceName.split("?"), _wsComponents$resourc2 = slicedToArray(_wsComponents$resourc, 2), path = _wsComponents$resourc2[0], query = _wsComponents$resourc2[1];
            wsComponents.path = path && path !== "/" ? path : void 0;
            wsComponents.query = query;
            wsComponents.resourceName = void 0;
          }
          wsComponents.fragment = void 0;
          return wsComponents;
        }
      };
      var handler$3 = {
        scheme: "wss",
        domainHost: handler$2.domainHost,
        parse: handler$2.parse,
        serialize: handler$2.serialize
      };
      var O = {};
      var isIRI = true;
      var UNRESERVED$$ = "[A-Za-z0-9\\-\\.\\_\\~" + (isIRI ? "\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF" : "") + "]";
      var HEXDIG$$ = "[0-9A-Fa-f]";
      var PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$));
      var ATEXT$$ = "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]";
      var QTEXT$$ = "[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]";
      var VCHAR$$ = merge(QTEXT$$, '[\\"\\\\]');
      var SOME_DELIMS$$ = "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]";
      var UNRESERVED = new RegExp(UNRESERVED$$, "g");
      var PCT_ENCODED = new RegExp(PCT_ENCODED$, "g");
      var NOT_LOCAL_PART = new RegExp(merge("[^]", ATEXT$$, "[\\.]", '[\\"]', VCHAR$$), "g");
      var NOT_HFNAME = new RegExp(merge("[^]", UNRESERVED$$, SOME_DELIMS$$), "g");
      var NOT_HFVALUE = NOT_HFNAME;
      function decodeUnreserved(str) {
        var decStr = pctDecChars(str);
        return !decStr.match(UNRESERVED) ? str : decStr;
      }
      var handler$4 = {
        scheme: "mailto",
        parse: function parse$$1(components, options) {
          var mailtoComponents = components;
          var to = mailtoComponents.to = mailtoComponents.path ? mailtoComponents.path.split(",") : [];
          mailtoComponents.path = void 0;
          if (mailtoComponents.query) {
            var unknownHeaders = false;
            var headers = {};
            var hfields = mailtoComponents.query.split("&");
            for (var x = 0, xl = hfields.length; x < xl; ++x) {
              var hfield = hfields[x].split("=");
              switch (hfield[0]) {
                case "to":
                  var toAddrs = hfield[1].split(",");
                  for (var _x = 0, _xl = toAddrs.length; _x < _xl; ++_x) {
                    to.push(toAddrs[_x]);
                  }
                  break;
                case "subject":
                  mailtoComponents.subject = unescapeComponent(hfield[1], options);
                  break;
                case "body":
                  mailtoComponents.body = unescapeComponent(hfield[1], options);
                  break;
                default:
                  unknownHeaders = true;
                  headers[unescapeComponent(hfield[0], options)] = unescapeComponent(hfield[1], options);
                  break;
              }
            }
            if (unknownHeaders)
              mailtoComponents.headers = headers;
          }
          mailtoComponents.query = void 0;
          for (var _x2 = 0, _xl2 = to.length; _x2 < _xl2; ++_x2) {
            var addr = to[_x2].split("@");
            addr[0] = unescapeComponent(addr[0]);
            if (!options.unicodeSupport) {
              try {
                addr[1] = punycode.toASCII(unescapeComponent(addr[1], options).toLowerCase());
              } catch (e) {
                mailtoComponents.error = mailtoComponents.error || "Email address's domain name can not be converted to ASCII via punycode: " + e;
              }
            } else {
              addr[1] = unescapeComponent(addr[1], options).toLowerCase();
            }
            to[_x2] = addr.join("@");
          }
          return mailtoComponents;
        },
        serialize: function serialize$$1(mailtoComponents, options) {
          var components = mailtoComponents;
          var to = toArray(mailtoComponents.to);
          if (to) {
            for (var x = 0, xl = to.length; x < xl; ++x) {
              var toAddr = String(to[x]);
              var atIdx = toAddr.lastIndexOf("@");
              var localPart = toAddr.slice(0, atIdx).replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_LOCAL_PART, pctEncChar);
              var domain = toAddr.slice(atIdx + 1);
              try {
                domain = !options.iri ? punycode.toASCII(unescapeComponent(domain, options).toLowerCase()) : punycode.toUnicode(domain);
              } catch (e) {
                components.error = components.error || "Email address's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
              }
              to[x] = localPart + "@" + domain;
            }
            components.path = to.join(",");
          }
          var headers = mailtoComponents.headers = mailtoComponents.headers || {};
          if (mailtoComponents.subject)
            headers["subject"] = mailtoComponents.subject;
          if (mailtoComponents.body)
            headers["body"] = mailtoComponents.body;
          var fields = [];
          for (var name in headers) {
            if (headers[name] !== O[name]) {
              fields.push(name.replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFNAME, pctEncChar) + "=" + headers[name].replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFVALUE, pctEncChar));
            }
          }
          if (fields.length) {
            components.query = fields.join("&");
          }
          return components;
        }
      };
      var URN_PARSE = /^([^\:]+)\:(.*)/;
      var handler$5 = {
        scheme: "urn",
        parse: function parse$$1(components, options) {
          var matches = components.path && components.path.match(URN_PARSE);
          var urnComponents = components;
          if (matches) {
            var scheme = options.scheme || urnComponents.scheme || "urn";
            var nid = matches[1].toLowerCase();
            var nss = matches[2];
            var urnScheme = scheme + ":" + (options.nid || nid);
            var schemeHandler = SCHEMES[urnScheme];
            urnComponents.nid = nid;
            urnComponents.nss = nss;
            urnComponents.path = void 0;
            if (schemeHandler) {
              urnComponents = schemeHandler.parse(urnComponents, options);
            }
          } else {
            urnComponents.error = urnComponents.error || "URN can not be parsed.";
          }
          return urnComponents;
        },
        serialize: function serialize$$1(urnComponents, options) {
          var scheme = options.scheme || urnComponents.scheme || "urn";
          var nid = urnComponents.nid;
          var urnScheme = scheme + ":" + (options.nid || nid);
          var schemeHandler = SCHEMES[urnScheme];
          if (schemeHandler) {
            urnComponents = schemeHandler.serialize(urnComponents, options);
          }
          var uriComponents = urnComponents;
          var nss = urnComponents.nss;
          uriComponents.path = (nid || options.nid) + ":" + nss;
          return uriComponents;
        }
      };
      var UUID = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/;
      var handler$6 = {
        scheme: "urn:uuid",
        parse: function parse4(urnComponents, options) {
          var uuidComponents = urnComponents;
          uuidComponents.uuid = uuidComponents.nss;
          uuidComponents.nss = void 0;
          if (!options.tolerant && (!uuidComponents.uuid || !uuidComponents.uuid.match(UUID))) {
            uuidComponents.error = uuidComponents.error || "UUID is not valid.";
          }
          return uuidComponents;
        },
        serialize: function serialize2(uuidComponents, options) {
          var urnComponents = uuidComponents;
          urnComponents.nss = (uuidComponents.uuid || "").toLowerCase();
          return urnComponents;
        }
      };
      SCHEMES[handler.scheme] = handler;
      SCHEMES[handler$1.scheme] = handler$1;
      SCHEMES[handler$2.scheme] = handler$2;
      SCHEMES[handler$3.scheme] = handler$3;
      SCHEMES[handler$4.scheme] = handler$4;
      SCHEMES[handler$5.scheme] = handler$5;
      SCHEMES[handler$6.scheme] = handler$6;
      exports2.SCHEMES = SCHEMES;
      exports2.pctEncChar = pctEncChar;
      exports2.pctDecChars = pctDecChars;
      exports2.parse = parse3;
      exports2.removeDotSegments = removeDotSegments;
      exports2.serialize = serialize;
      exports2.resolveComponents = resolveComponents;
      exports2.resolve = resolve;
      exports2.normalize = normalize;
      exports2.equal = equal;
      exports2.escapeComponent = escapeComponent;
      exports2.unescapeComponent = unescapeComponent;
      Object.defineProperty(exports2, "__esModule", { value: true });
    });
  }
});

// package.json
var package_default = {
  name: "@monogrid/serverless-cms",
  version: "3.3.0",
  description: "A CMS based on AWS Serverless Resources, with a GraphQL API, with Dynamic Schema editing loosely based on the likes of Contentful / Prismic / etc",
  license: "UNLICENSED",
  author: "MONOGRID <hello@mono-grid.com>",
  exports: {
    ".": {
      require: "./dist/index.js",
      import: "./dist/index.mjs",
      types: "./dist/index.d.ts"
    },
    "./utils": {
      require: "./serverless_modules/dist/utils.js",
      import: "./serverless_modules/dist/utils.js",
      types: "./serverless_modules/dist/utils.d.ts"
    }
  },
  main: "./dist/index.js",
  module: "./dist/index.mjs",
  types: "./dist/index.d.ts",
  typesVersions: {
    "*": {
      ".": [
        "./dist/index.d.ts"
      ],
      utils: [
        "./serverless_modules/dist/utils.d.ts"
      ]
    }
  },
  files: [
    "dist",
    "lambda",
    "src",
    "serverless_modules",
    "tsconfig.json"
  ],
  scripts: {
    build: "concurrently yarn:build:*",
    "build:library": "tsup src/index.ts --format cjs,esm --dts",
    "build:serverless_modules": "tsc -p ./serverless_modules/tsconfig.json",
    coverage: "jest --coverage",
    deploy: "yarn build:serverless_modules && sls deploy --verbose",
    "export-env": "safe-export-env",
    lint: 'eslint "**/*.{ts,js}"',
    package: "yarn build:serverless_modules && sls package",
    start: "yarn build && node --inspect node_modules/serverless/bin/serverless.js offline start -t",
    test: "jest"
  },
  config: {
    commitizen: {
      path: "./node_modules/cz-conventional-changelog"
    }
  },
  dependencies: {
    "@apollo/server": "^4.2.1",
    "@as-integrations/aws-lambda": "^2.0.0",
    "@aws-sdk/abort-controller": "^3.226.0",
    "@aws-sdk/client-cognito-identity-provider": "^3.238.0",
    "@aws-sdk/client-dynamodb": "^3.238.0",
    "@aws-sdk/client-lambda": "^3.238.0",
    "@aws-sdk/client-s3": "^3.238.0",
    "@aws-sdk/client-ses": "^3.238.0",
    "@aws-sdk/client-sns": "^3.238.0",
    "@aws-sdk/lib-storage": "^3.241.0",
    "@aws-sdk/s3-presigned-post": "^3.238.0",
    "@aws-sdk/s3-request-presigner": "^3.241.0",
    "@dmytropaduchak/simple-bilinear-interpolation": "^1.0.9",
    "@graphql-tools/schema": "^9.0.1",
    "@nandangk95/dynamodb-auto-marshaller": "^0.7.10",
    "@nandangk95/dynamodb-expressions": "^0.7.10",
    "@saeris/graphql-scalars": "^2.1.1",
    "@types/sharp": "0.31.1",
    archiver: "^5.3.0",
    "aws-jwt-verify": "^4.0.0",
    cosmiconfig: "^8.0.0",
    deepdash: "^5.3.9",
    exifr: "^7.1.3",
    graphql: "^16.6.0",
    "graphql-tag": "^2.12.6",
    "graphql-type-json": "^0.3.2",
    jexl: "^2.3.0",
    limiter: "^2.1.0",
    lodash: "^4.17.21",
    mjml: "^4.12.0",
    "object-hash": "^3.0.0",
    runtypes: "^6.5.1",
    "secure-random-password": "^0.2.3",
    slug: "^8.0.0",
    typescript: "^5.0.2",
    uuid: "^9.0.0"
  },
  devDependencies: {
    "@aws-sdk/types": "^3.226.0",
    "@babel/core": "^7.17.8",
    "@babel/preset-env": "^7.16.11",
    "@babel/preset-typescript": "^7.16.7",
    "@monogrid/env": "^1.1.3",
    "@monogrid/serverless-aws-infrastructure": "^4.0.3",
    "@monogrid/serverless-modular-configuration": "^3.0.0",
    "@semantic-release/changelog": "^6.0.1",
    "@semantic-release/exec": "^6.0.2",
    "@semantic-release/git": "^10.0.1",
    "@semantic-release/gitlab": "^12.0.1",
    "@types/archiver": "^5.3.1",
    "@types/aws-lambda": "^8.10.109",
    "@types/jest": "^29.5.0",
    "@types/jexl": "^2.3.0",
    "@types/mjml": "^4.7.0",
    "@types/node": "^18.13.0",
    "@types/object-hash": "^3.0.2",
    "@types/secure-random-password": "^0.2.1",
    "@types/semantic-release": "^20.0.1",
    "@types/slug": "^5.0.3",
    "@types/uuid": "^9.0.0",
    "@typescript-eslint/eslint-plugin": "^5.41.0",
    "@typescript-eslint/parser": "^5.41.0",
    "aws-sdk-client-mock": "^2.0.1",
    "aws-sdk-client-mock-jest": "^2.0.1",
    "circular-dependency-plugin": "^5.2.2",
    concurrently: "^8.0.1",
    "conventional-changelog-conventionalcommits": "^5.0.0",
    "cz-conventional-changelog": "3.3.0",
    eslint: "^8.11.0",
    "eslint-config-standard": "^17.0.0",
    "eslint-import-resolver-typescript": "^3.5.2",
    "eslint-plugin-import": "^2.26.0",
    "eslint-plugin-n": "^15.2.4",
    "eslint-plugin-promise": "^6.0.0",
    "eslint-plugin-simple-import-sort": "^10.0.0",
    "eslint-plugin-unused-imports": "^2.0.0",
    jest: "^29.4.1",
    "jest-dynalite": "^3.6.1",
    "jest-extended": "^3.0.2",
    "jest-junit": "^16.0.0",
    jszip: "^3.10.1",
    "lambda-sample-events": "^1.0.1",
    "mock-jwks": "^2.0.0",
    nock: "^13.3.0",
    "semantic-release": "^21.0.0",
    sharp: "0.31.2",
    "source-map-support": "^0.5.21",
    "ts-loader": "^9.2.8",
    tsup: "^6.2.2",
    webpack: "^5.70.0",
    "webpack-bundle-analyzer": "^4.5.0",
    "webpack-cli": "^5.0.0",
    "webpack-node-externals": "^3.0.0"
  },
  peerDependencies: {
    "@monogrid/env": "^1.1.2",
    "@monogrid/serverless-aws-infrastructure": "^4.0.2",
    "ts-loader": "^9.2.8"
  },
  engines: {
    node: "^14.17.0 || >=16.0.0"
  },
  publishConfig: {
    "@monogrid:registry": "https://gitlab.com/api/v4/projects/23397256/packages/npm/",
    access: "restricted"
  }
};

// src/auth/MinimumACL.ts
var MinimumACL = /* @__PURE__ */ ((MinimumACL2) => {
  MinimumACL2[MinimumACL2["PUBLIC"] = 0] = "PUBLIC";
  MinimumACL2[MinimumACL2["REGISTERED"] = 1] = "REGISTERED";
  MinimumACL2[MinimumACL2["CREATOR"] = 2] = "CREATOR";
  MinimumACL2[MinimumACL2["EDITOR"] = 3] = "EDITOR";
  MinimumACL2[MinimumACL2["ADMIN"] = 4] = "ADMIN";
  MinimumACL2[MinimumACL2["NOONE"] = 5] = "NOONE";
  return MinimumACL2;
})(MinimumACL || {});

// src/auth/aclToString.ts
var aclToString_default = (acl) => {
  switch (acl) {
    case 5 /* NOONE */:
      return "NOONE";
    case 4 /* ADMIN */:
      return "ADMIN";
    case 3 /* EDITOR */:
      return "EDITOR";
    case 2 /* CREATOR */:
      return "CREATOR";
    case 1 /* REGISTERED */:
      return "REGISTERED";
  }
  return "PUBLIC";
};

// src/auth/userHasRequestedACL.ts
import { getEnv } from "@monogrid/env";

// src/constants.ts
var AWS_COGNITO_USER_GROUP = "AWSCognito";
var USER_CONTENT_MODEL_ID = "User";
var MEDIA_FILE_CONTENT_MODEL_ID = "MediaFile";
var UNKNOWN_SCHEMA_HASH = "unknown-schema-hash";
var CONTENT_SINGLETON_ID = "singleton";
var BASE_VARIANT_NAME = "base";
var PUBLIC_USER = {
  email: "anonymous@public-domain.com",
  groups: [],
  enabled: true
};
var FieldGridSize = /* @__PURE__ */ ((FieldGridSize2) => {
  FieldGridSize2["FULL"] = "1";
  FieldGridSize2["THREEQUARTER"] = "3/4";
  FieldGridSize2["HALF"] = "1/2";
  FieldGridSize2["QUARTER"] = "1/4";
  return FieldGridSize2;
})(FieldGridSize || {});
var ContentStatus = /* @__PURE__ */ ((ContentStatus2) => {
  ContentStatus2["DRAFT"] = "DRAFT";
  ContentStatus2["PUBLISHED"] = "PUBLISHED";
  return ContentStatus2;
})(ContentStatus || {});
var ContentUpdateStrategy = /* @__PURE__ */ ((ContentUpdateStrategy3) => {
  ContentUpdateStrategy3["REPLACE"] = "REPLACE";
  ContentUpdateStrategy3["MERGE"] = "MERGE";
  ContentUpdateStrategy3["ASSIGN"] = "ASSIGN";
  return ContentUpdateStrategy3;
})(ContentUpdateStrategy || {});
var RepeaterReferenceResolutionStrategy = /* @__PURE__ */ ((RepeaterReferenceResolutionStrategy2) => {
  RepeaterReferenceResolutionStrategy2["COMPLETE"] = "COMPLETE";
  RepeaterReferenceResolutionStrategy2["SIMPLE"] = "SIMPLE";
  RepeaterReferenceResolutionStrategy2["NONE"] = "NONE";
  return RepeaterReferenceResolutionStrategy2;
})(RepeaterReferenceResolutionStrategy || {});
var RichTextModes = /* @__PURE__ */ ((RichTextModes2) => {
  RichTextModes2["BASIC"] = "Basic";
  RichTextModes2["FULL"] = "Full";
  return RichTextModes2;
})(RichTextModes || {});
var ColorFormats = /* @__PURE__ */ ((ColorFormats2) => {
  ColorFormats2["HEX"] = "hex";
  ColorFormats2["RGB"] = "rgb";
  ColorFormats2["HSL"] = "hsl";
  ColorFormats2["AUTO"] = "auto";
  ColorFormats2["MIXED"] = "mixed";
  return ColorFormats2;
})(ColorFormats || {});
var AutomationActions = /* @__PURE__ */ ((AutomationActions2) => {
  AutomationActions2["DELETE"] = "DELETE";
  AutomationActions2["PUBLISH"] = "PUBLISH";
  AutomationActions2["UNPUBLISH"] = "UNPUBLISH";
  return AutomationActions2;
})(AutomationActions || {});
var AutomationTargetTypes = /* @__PURE__ */ ((AutomationTargetTypes2) => {
  AutomationTargetTypes2["CONTENT"] = "CONTENT";
  return AutomationTargetTypes2;
})(AutomationTargetTypes || {});
var AutomationStatus = /* @__PURE__ */ ((AutomationStatus2) => {
  AutomationStatus2["PENDING"] = "PENDING";
  AutomationStatus2["COMPLETED"] = "COMPLETED";
  AutomationStatus2["FAILED"] = "FAILED";
  return AutomationStatus2;
})(AutomationStatus || {});
var DateModes = /* @__PURE__ */ ((DateModes2) => {
  DateModes2["DEFAULT"] = "Default";
  DateModes2["DATETIME"] = "DateTime";
  DateModes2["MONTH"] = "Month";
  DateModes2["YEAR"] = "Year";
  DateModes2["TIME"] = "Time";
  return DateModes2;
})(DateModes || {});

// src/utils/validateEmail.ts
function validateEmail_default(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

// src/auth/userHasRequestedACL.ts
function userHasRequestedACL_default(user, requestedACL, contentCreator) {
  if (isNaN(requestedACL) || requestedACL === null || requestedACL === void 0) {
    throw new Error("You must define a valid ACL to check against");
  }
  if (!user || user && user.email === PUBLIC_USER.email || user && user.enabled !== true) {
    return requestedACL === 0 /* PUBLIC */;
  }
  const env = getEnv();
  let userACL = 0 /* PUBLIC */;
  if (user.groups && user.groups.length > 0 && user.groups.indexOf(AWS_COGNITO_USER_GROUP) !== -1) {
    userACL = 5 /* NOONE */;
  } else if (user.groups && user.groups.length > 0 && typeof env.ADMINS_GROUP_NAME === "string" && user.groups.indexOf(env.ADMINS_GROUP_NAME) !== -1) {
    userACL = 4 /* ADMIN */;
  } else if (user.groups && user.groups.length > 0 && typeof env.EDITORS_GROUP_NAME === "string" && user.groups.indexOf(env.EDITORS_GROUP_NAME) !== -1) {
    userACL = 3 /* EDITOR */;
  } else if (validateEmail_default(user.email) && contentCreator && validateEmail_default(contentCreator) && user.email === contentCreator) {
    userACL = 2 /* CREATOR */;
  } else {
    userACL = 1 /* REGISTERED */;
  }
  return userACL >= requestedACL;
}

// src/utils/capitalize.ts
function capitalize_default(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

// src/errors.ts
import { Failcode } from "runtypes";

// src/utils/truncateString.ts
function truncateString_default(str, num) {
  if (str.length > num) {
    return str.slice(0, num) + "...";
  } else {
    return str;
  }
}

// src/errors.ts
var _details, _code;
var ContentModelValidationError = class extends Error {
  constructor(message, code, details) {
    super(message);
    __privateAdd(this, _details, void 0);
    __privateAdd(this, _code, void 0);
    __privateSet(this, _code, code);
    __privateSet(this, _details, details);
  }
  get details() {
    return __privateGet(this, _details);
  }
  get code() {
    return __privateGet(this, _code);
  }
};
_details = new WeakMap();
_code = new WeakMap();
var AutomationValidationError = class extends ContentModelValidationError {
};
var MalformedFieldError = class extends ContentModelValidationError {
  constructor(input, fieldType, code, details) {
    super(`Input value ${truncateString_default(JSON.stringify(input), 50)} does not conform to the definition of ${fieldType}`, code, details);
  }
};
var MalformedRepeaterInstanceError = class extends ContentModelValidationError {
  constructor(input, code, details) {
    super(`Input value ${truncateString_default(JSON.stringify(input), 50)} does not conform to the definition of a Repeater Instance`, code, details);
  }
};
var MalformedAreaError = class extends ContentModelValidationError {
  constructor(input, code, details) {
    super(`Input value ${truncateString_default(JSON.stringify(input), 50)} does not conform to the definition of an Area`, code, details);
  }
};
var MalformedAutomationDefinitionError = class extends AutomationValidationError {
  constructor(input, code, details) {
    super(`Input value ${truncateString_default(JSON.stringify(input), 50)} does not conform to the definition of a AutomationDefinition`, code, details);
  }
};
var MalformedAutomationError = class extends AutomationValidationError {
  constructor(input, code, details) {
    super(`Input value ${truncateString_default(JSON.stringify(input), 50)} does not conform to the definition of a Automation`, code, details);
  }
};
var MalformedContentModelDefinitionError = class extends ContentModelValidationError {
  constructor(input, code, details) {
    super(`Input value ${truncateString_default(JSON.stringify(input), 50)} does not conform to the definition of a ContentModelDefinition`, code, details);
  }
};
var MalformedContentModelError = class extends ContentModelValidationError {
  constructor(input, code, details) {
    super(`Input value ${truncateString_default(JSON.stringify(input), 50)} does not conform to the definition of a ContentModel`, code, details);
  }
};
var MalformedValidationExpressionError = class extends ContentModelValidationError {
  constructor(input, code, details) {
    super(`Input value ${truncateString_default(JSON.stringify(input), 50)} does not conform to the definition of a ValidationExpression`, code, details);
  }
};
var NonInstantiableFieldError = class extends ContentModelValidationError {
  constructor() {
    super('An Object with a "fieldType" property is needed to instantiate a Field', Failcode.PROPERTY_MISSING);
  }
};
var _field, _data, _results;
var MalformedInputError = class extends Error {
  constructor(field, data, ...args) {
    super(`${field.fieldName}(${field.fieldType}) failed validation for input "${data}": ${args.map((f) => `"${f.message}"`).join(", ")}`);
    __privateAdd(this, _field, void 0);
    __privateAdd(this, _data, void 0);
    __privateAdd(this, _results, void 0);
    __privateSet(this, _field, field);
    __privateSet(this, _data, data);
    __privateSet(this, _results, args);
  }
  getDetailedMessage(rootType) {
    return `${__privateGet(this, _field).getPath(rootType)}(${__privateGet(this, _field).fieldType}) failed validation for input "${__privateGet(this, _data)}": ${__privateGet(this, _results).map((f) => `"${f.message}"`).join(", ")}`;
  }
};
_field = new WeakMap();
_data = new WeakMap();
_results = new WeakMap();

// src/runtypes.ts
import { Array as Array2, Boolean, Dictionary, Function, InstanceOf, Literal, Number, Record, String as String2, Union, Unknown as Unknown2 } from "runtypes";

// src/utils/runtypeFromEnum.ts
import { Unknown } from "runtypes";
var runtypeFromEnum = (theEnum) => {
  const values = Object.values(theEnum);
  const isEnumValue = (input) => values.includes(input);
  const errorMessage = (input) => `Failed constraint check. Expected one of ${JSON.stringify(values)}, but received ${JSON.stringify(input)}`;
  return Unknown.withConstraint((object) => isEnumValue(object) || errorMessage(object));
};

// src/runtypes.ts
var MinimumACLRT = Union(
  Literal(0),
  Literal(1),
  Literal(2),
  Literal(3),
  Literal(4),
  Literal(5)
);
var FieldGridSizeRT = Union(
  Literal("1" /* FULL */),
  Literal("3/4" /* THREEQUARTER */),
  Literal("1/2" /* HALF */),
  Literal("1/4" /* QUARTER */)
);
var RichTextModesRT = Union(
  Literal("Basic" /* BASIC */),
  Literal("Full" /* FULL */)
);
var ColorFormatsRT = Union(
  Literal("hex" /* HEX */),
  Literal("rgb" /* RGB */),
  Literal("hsl" /* HSL */),
  Literal("auto" /* AUTO */),
  Literal("mixed" /* MIXED */)
);
var DateModesRT = Union(
  Literal("Default" /* DEFAULT */),
  Literal("DateTime" /* DATETIME */),
  Literal("Month" /* MONTH */),
  Literal("Year" /* YEAR */),
  Literal("Time" /* TIME */)
);
var DateInputRT = String2.withConstraint((s) => new Date(s).toString() !== "Invalid Date" || "Invalid Date").Or(Number.withConstraint((s) => new Date(s).toString() !== "Invalid Date" || "Invalid Date")).Or(InstanceOf(Date));
var DateFieldRT = Record({
  mode: DateModesRT.optional()
});
var AutomationActionsRT = runtypeFromEnum(AutomationActions);
var AutomationTargetTypesRT = runtypeFromEnum(AutomationTargetTypes);
var AutomationStatusRT = runtypeFromEnum(AutomationStatus);
var ContentStatusRT = runtypeFromEnum(ContentStatus);
var UnknownArrayRT = Array2(Unknown2);
var StringArrayRT = Array2(String2);
var NotEmptyStringRT = String2.withConstraint((s) => /^.+$/.test(s));
var NotEmptyStringArrayRT = Array2(NotEmptyStringRT);
var GraphQLNameRT = String2.withConstraint((s) => /^[_A-Za-z][_0-9A-Za-z]*$/.test(s) && /^.+$/.test(s) || "Invalid GraphQL name, see https://spec.graphql.org/June2018/#sec-Names for allowed names");
var InstantiableFieldRT = Record({
  fieldType: String2
});
var VisibilityExpressionsFieldRT = Record({
  fieldName: String2,
  expressions: Array2(Unknown2).withConstraint((s) => s.length > 0)
});
var FieldRT = InstantiableFieldRT.extend({
  fieldName: GraphQLNameRT,
  fieldLabel: String2.optional(),
  fieldDescription: String2.optional(),
  fieldPlaceholder: String2.optional(),
  fieldRequired: Boolean.optional(),
  fieldExcludedFromLists: Boolean.optional(),
  validationExpressions: Array2(Unknown2).optional(),
  visibilityExpressions: Array2(Unknown2).optional(),
  readACL: MinimumACLRT,
  writeACL: MinimumACLRT,
  usageCount: Array2(Unknown2).optional()
});
var GridFieldRT = Record({
  fieldGridSize: FieldGridSizeRT.optional()
});
var AreaRT = Record({
  name: NotEmptyStringRT,
  fields: Array2(Unknown2)
});
var AutomationRT = Record({
  id: NotEmptyStringRT,
  automationStatus: AutomationStatusRT,
  automationExecutionTime: DateInputRT,
  statusMessage: String2.optional(),
  _author: String2.optional(),
  _modifiedBy: String2.optional(),
  _createdAt: DateInputRT.optional(),
  _modifiedAt: DateInputRT.optional(),
  definition: Unknown2
});
var AutomationDefinitionRT = Record({
  action: AutomationActionsRT,
  target: String2,
  targetType: AutomationTargetTypesRT
});
var ContentModelRT = Record({
  id: GraphQLNameRT,
  _author: String2.optional(),
  _modifiedBy: String2.optional(),
  _createdAt: DateInputRT.optional(),
  _modifiedAt: DateInputRT.optional(),
  definition: Unknown2
});
var ContentModelDefinitionRT = Record({
  areas: Array2(Unknown2),
  group: String2.optional(),
  label: String2.optional(),
  description: String2.optional(),
  previewUrl: String2.optional(),
  singleton: Boolean.optional(),
  sortFields: Array2(String2).withConstraint((s) => s.length <= 3 || "Maximum number of Sort Fields is 3").optional(),
  statusUnmanaged: Boolean.optional(),
  slugManaged: Boolean.optional(),
  variants: Array2(Unknown2).optional(),
  createACL: MinimumACLRT,
  deleteACL: MinimumACLRT,
  draftGetACL: MinimumACLRT,
  publishedGetACL: MinimumACLRT,
  draftListACL: MinimumACLRT,
  publishedListACL: MinimumACLRT,
  updateACL: MinimumACLRT,
  publishACL: MinimumACLRT,
  unpublishACL: MinimumACLRT
});
var VariantRT = Record({
  name: NotEmptyStringRT,
  parent: String2.optional()
});
var ArrayFieldRT = Record({
  arrayValueType: FieldRT
});
var MapFieldRT = Record({
  mapKey: FieldRT,
  mapValue: FieldRT
});
var TitleFieldRT = Record({
  useAsSlug: Boolean.optional()
});
var SelectFieldRT = Record({
  selectValues: Array2(NotEmptyStringRT)
});
var RichTextFieldRT = Record({
  mode: RichTextModesRT.optional()
});
var ColorFieldRT = Record({
  defaultColorFormat: ColorFormatsRT,
  enableFormatChange: Boolean.optional(),
  enableAlpha: Boolean.optional(),
  forceAlpha: Boolean.optional(),
  showSwatchesOnly: Boolean.optional(),
  swatches: Array2(Unknown2).optional()
});
var LegacyReferenceFieldInputRT = String2.withConstraint((s) => {
  const spl = s.split("/");
  return spl[0] === "_reference" && spl.length === 3 || "Malformed Reference String, must be _reference/{{ModelID}}/{{ContentID}}";
});
var ReferenceFieldInputRT = Record({
  id: NotEmptyStringRT
});
var ReferenceFieldRT = Record({
  referenceModelId: GraphQLNameRT
});
var RepeaterInstanceInputRT = Record({
  _repeaterType: NotEmptyStringRT
});
var RepeaterRT = Record({
  name: NotEmptyStringRT,
  description: String2.optional(),
  icon: String2.optional(),
  fields: Array2(Unknown2)
});
var RepeaterFieldRT = Record({
  repeaters: Array2(Unknown2)
});
var ValidationErrorMessageParametersRT = Record({
  operand: Union(
    Array2(NotEmptyStringRT),
    NotEmptyStringRT,
    Array2(Number),
    Number
  ),
  comparator: NotEmptyStringRT.optional(),
  widthOrHeight: NotEmptyStringRT.optional()
});
var ValidationExpressionRT = Record({
  expression: String2,
  errorMessage: String2,
  errorParams: Unknown2.optional()
});
var ValidationInputRT = Record({
  name: String2,
  type: String2,
  label: String2,
  inputParams: Unknown2.optional(),
  items: Array2(Unknown2).optional(),
  multiple: Boolean.optional(),
  stringify: Boolean.optional()
});
var ValidationRT = Record({
  label: String2,
  value: String2,
  input: Array2(ValidationInputRT),
  getExpression: Function
});
var EmptyVariantsRT = Record({
  id: String2.optional()
}).And(Dictionary(Unknown2, String2));
var VariantObjectRT = Record({ id: String2.optional() }).And(Dictionary(Unknown2, String2));
var FilledVariantsRT = Record({
  id: String2
}).And(Dictionary(VariantObjectRT.Or(String2), String2));
var ContentDataWithNoVariantsRT = Record({
  id: String2.optional(),
  _slug: String2.optional()
}).And(Dictionary(Unknown2, String2));
var ContentDataWithVariantsRT = Record({
  id: String2.optional(),
  _slug: String2.optional(),
  _variants: EmptyVariantsRT.Or(FilledVariantsRT)
}).And(Dictionary(Unknown2, String2));
var ContentDataRT = ContentDataWithNoVariantsRT.Or(ContentDataWithVariantsRT);

// src/fields/TextField.ts
import { String as String3 } from "runtypes";

// src/utils/isNil.ts
function isNil_default(object) {
  return object === void 0 || object === null;
}

// src/validation/index.ts
import jexl2 from "jexl";

// src/utils/isMimeType.ts
function isMimeType_default(mime, pattern) {
  if (!pattern || pattern && typeof pattern !== "string")
    throw new Error("Pattern must be a string like */* or image/* or image/jpeg");
  if (!mime)
    return false;
  const mimeParts = mime.split("/");
  const patternsArray = pattern.split(",");
  for (let i = 0; i < patternsArray.length; i++) {
    const patternParts = patternsArray[i].split("/");
    let first = true;
    let second = true;
    if (patternParts[0] !== "*") {
      first = mimeParts[0].toLowerCase() === patternParts[0].toLowerCase();
    }
    if (patternParts[1] !== "*") {
      second = mimeParts[1].toLowerCase() === patternParts[1].toLowerCase();
    }
    if (first && second) {
      return true;
    }
  }
  return false;
}

// src/validation/FieldValidationResult.ts
var _field2, _expression, _result, _rootType;
var FieldValidationResult = class {
  /**
   *
   * @param field
   * @param expression
   * @param result
   * @param rootType
   */
  constructor(field, expression, result, rootType) {
    __privateAdd(this, _field2, void 0);
    __privateAdd(this, _expression, void 0);
    __privateAdd(this, _result, void 0);
    __privateAdd(this, _rootType, void 0);
    __privateSet(this, _field2, field);
    __privateSet(this, _expression, expression);
    __privateSet(this, _result, result);
    __privateSet(this, _rootType, rootType);
  }
  get field() {
    return __privateGet(this, _field2);
  }
  get expression() {
    return __privateGet(this, _expression);
  }
  get result() {
    return __privateGet(this, _result);
  }
  get rootType() {
    return __privateGet(this, _rootType);
  }
};
_field2 = new WeakMap();
_expression = new WeakMap();
_result = new WeakMap();
_rootType = new WeakMap();

// src/validation/ValidationErrorMessageParameters.ts
var ValidationErrorMessageParameters = class {
  /**
   *
   * @param json
   * @returns
   */
  static fromJSON(json) {
    if (ValidationErrorMessageParametersRT.guard(json)) {
      const ret = new ValidationErrorMessageParameters();
      ret.operand = json.operand;
      ret.comparator = json.comparator;
      return ret;
    }
  }
};

// src/validation/ValidationExpression.ts
import jexl from "jexl";
var ValidationExpression = class {
  /**
   *
   * @param field
   * @param value
   * @param rootType
   * @returns
   */
  eval(field, value, rootType) {
    return __async(this, null, function* () {
      try {
        return new FieldValidationResult(field, this, yield jexl.eval(this.expression, { value }), rootType);
      } catch (err) {
        console.error("Error while validating", field.getPath(rootType), "against JEXL Expression", this.expression, err);
      }
      return new FieldValidationResult(field, this, false, rootType);
    });
  }
  toString() {
    if (this.errorParams) {
      return `Value must be ${this.errorParams.comparator || ""}${this.errorParams.operand}`;
    }
    return "";
  }
  /**
   *
   * @param json
   * @returns
   */
  static fromJSON(json) {
    const validation = ValidationExpressionRT.validate(json);
    if (validation.success) {
      const ret = new ValidationExpression();
      ret.expression = validation.value.expression;
      ret.errorMessage = validation.value.errorMessage;
      ret.errorParams = ValidationErrorMessageParameters.fromJSON(validation.value.errorParams);
      return ret;
    } else {
      throw new MalformedValidationExpressionError(json, validation.code, validation.details);
    }
  }
};

// src/validation/BoolInvalidValidationExpression.ts
var BoolInvalidValidationExpression = class extends ValidationExpression {
  /**
   *
   */
  constructor() {
    super();
    this.expression = "bool_invalid";
    this.errorMessage = "bool_invalid";
    this.errorParams = new ValidationErrorMessageParameters();
  }
  /**
   *
   * @param field
   * @param value
   * @returns
   */
  eval(field, value, rootType) {
    return __async(this, null, function* () {
      return new FieldValidationResult(field, this, false, rootType);
    });
  }
};

// src/validation/ColorSwatchInvalidValidationExpression.ts
var ColorSwatchInvalidValidationExpression = class extends ValidationExpression {
  /**
   *
   */
  constructor() {
    super();
    this.expression = "color_swatch_invalid";
    this.errorMessage = "color_swatch_invalid";
    this.errorParams = new ValidationErrorMessageParameters();
  }
  /**
   *
   * @param field
   * @param value
   * @returns
   */
  eval(field, value, rootType) {
    return __async(this, null, function* () {
      return new FieldValidationResult(field, this, false, rootType);
    });
  }
};

// src/validation/NumberInvalidValidationExpression.ts
var NumberInvalidValidationExpression = class extends ValidationExpression {
  /**
   *
   */
  constructor() {
    super();
    this.expression = "number_invalid";
    this.errorMessage = "number_invalid";
    this.errorParams = new ValidationErrorMessageParameters();
  }
  /**
   *
   * @param field
   * @param value
   * @returns
   */
  eval(field, value, rootType) {
    return __async(this, null, function* () {
      return new FieldValidationResult(field, this, false, rootType);
    });
  }
};

// src/validation/RequiredValidationExpression.ts
var RequiredValidationExpression = class extends ValidationExpression {
  /**
   *
   */
  constructor() {
    super();
    this.expression = "required";
    this.errorMessage = "This field is required";
    this.errorParams = new ValidationErrorMessageParameters();
  }
  /**
   *
   * @param field
   * @param value
   * @returns
   */
  eval(field, value, rootType) {
    return __async(this, null, function* () {
      return new FieldValidationResult(field, this, false, rootType);
    });
  }
};

// src/validation/UrlInvalidValidationExpression.ts
var UrlInvalidValidationExpression = class extends ValidationExpression {
  /**
   *
   */
  constructor() {
    super();
    this.expression = "url_invalid";
    this.errorMessage = "url_invalid";
    this.errorParams = new ValidationErrorMessageParameters();
  }
  /**
   *
   * @param field
   * @param value
   * @returns
   */
  eval(field, value, rootType) {
    return __async(this, null, function* () {
      return new FieldValidationResult(field, this, false, rootType);
    });
  }
};

// src/validation/index.ts
jexl2.addTransform("uniq", (val) => [...new Set(val)]);
jexl2.addTransform("length", (val) => val && val.length);
jexl2.addTransform("jsonparse", (val) => val && JSON.parse(val));
jexl2.addTransform("getTime", (val) => val && new Date(val).getTime());
jexl2.addTransform("toInt", (val) => parseInt(val));
jexl2.addBinaryOp("~=", 20, (left, right) => left.match(new RegExp(`^${right}$`)) !== null);
jexl2.addBinaryOp("mime=", 20, isMimeType_default);

// src/BaseField.ts
var _parent;
var _Field = class {
  /**
   *
   * @param parent
   */
  constructor(parent) {
    /**
     * parent of this field, if it exists
     */
    __privateAdd(this, _parent, void 0);
    __privateSet(this, _parent, parent);
    this.readACL = 0 /* PUBLIC */;
    this.writeACL = 3 /* EDITOR */;
  }
  /**
   *
   */
  get producesGraphQLRootTypes() {
    return false;
  }
  get graphQLArguments() {
    return "";
  }
  /**
   *
   * @param content
   * @param referenceResolverCallback
   * @param excludeRequired
   * @returns
   */
  validateContent(content, referenceResolverCallback, rootType, excludeRequired) {
    return __async(this, null, function* () {
      let validationPromises = [];
      if (!excludeRequired && this.fieldRequired === true) {
        if (!this.contentRequiredCheck(content)) {
          validationPromises.push(new RequiredValidationExpression().eval(this, content, rootType));
        }
      }
      if (UnknownArrayRT.guard(this.validationExpressions)) {
        if (!isNil_default(content)) {
          validationPromises = validationPromises.concat(this.validationExpressions.map((ve) => ve.eval(this, content, rootType)));
        }
      }
      return Promise.all(validationPromises);
    });
  }
  /**
   *
   * @param content
   * @returns
   */
  contentRequiredCheck(content) {
    return !isNil_default(content);
  }
  /**
   *
   * @param rootName
   * @returns
   */
  getUniqueTypeName(namePrefix) {
    const parentName = __privateGet(this, _parent) ? __privateGet(this, _parent).getUniqueTypeName(namePrefix) : namePrefix;
    return parentName + capitalize_default(this.fieldName);
  }
  /**
   *
   */
  nameChild(child) {
    if (child instanceof _Field)
      return `.${child.fieldName}`;
    return "";
  }
  /**
   *
   * @returns
   */
  getPath(rootName, rootField) {
    if (this === rootField) {
      return this.getUniqueTypeName(rootName);
    }
    if (__privateGet(this, _parent)) {
      const parentPath = __privateGet(this, _parent).getPath(rootName, rootField);
      return `${parentPath}${__privateGet(this, _parent).nameChild(this)}`;
    }
    return `${rootName}.${this.fieldName}`;
  }
  /**
   *
   * @returns
   */
  findNearestGraphQLRootType() {
    if (__privateGet(this, _parent)) {
      if (__privateGet(this, _parent).producesGraphQLRootTypes) {
        return __privateGet(this, _parent);
      } else {
        return __privateGet(this, _parent).findNearestGraphQLRootType();
      }
    }
    return void 0;
  }
  /**
   *
   */
  getGraphQLSchemaLocation(rootName) {
    return this.getPath(rootName, this.findNearestGraphQLRootType());
  }
  /**
   *
   * @param fieldType
   * @returns
   */
  isChildOfType(fieldType) {
    if (__privateGet(this, _parent)) {
      return __privateGet(this, _parent) instanceof fieldType;
    }
    return false;
  }
  /**
   *
   * @param fieldType
   * @returns
   */
  isDescendantOfType(fieldType) {
    if (this.isChildOfType(fieldType))
      return true;
    if (__privateGet(this, _parent)) {
      return __privateGet(this, _parent).isDescendantOfType(fieldType);
    }
    return false;
  }
  /**
   *
   * @param callback
   */
  traverse(callback) {
    callback(this);
    const children = this.children;
    for (let i = 0, l = children.length; i < l; i++) {
      children[i].traverse(callback);
    }
  }
  getGraphQLRootTypes(namePrefix, isVariant) {
    return "";
  }
  toGraphQLType(parent = "") {
    throw new Error("Not Implemented");
  }
  toGraphQLCreateInputType(parent = "") {
    return this.toGraphQLType(parent);
  }
  toGraphQLUpdateInputType(parent = "") {
    return this.toGraphQLCreateInputType(parent);
  }
  getCompleteInputFragment(data) {
    return `${this.fieldName}: ${this.getInputFragment(data)}
`;
  }
  getInputFragment(data) {
    throw new Error("Not Implemented");
  }
  formatDataForInput(data, throwErrorOnTypeMismatch, updateStrategy) {
    throw new Error("Not Implemented");
  }
  createPropertyOnInputVariable(inputVariable, data, throwErrorOnTypeMismatch, updateStrategy) {
    const result = this.formatDataForInput(data[this.fieldName], throwErrorOnTypeMismatch, updateStrategy);
    switch (updateStrategy) {
      case "ASSIGN" /* ASSIGN */:
      case "MERGE" /* MERGE */:
        if (!isNil_default(result)) {
          inputVariable[this.fieldName] = result;
        }
        break;
      default:
        inputVariable[this.fieldName] = result;
        break;
    }
  }
  getQueryFragment(contentModelList, params, includeReferents) {
    throw new Error("Not Implemented");
  }
  getInnerQueryFields(contentModelList, params, includeReferents) {
  }
  get children() {
    return [];
  }
  /**
   *
   */
  static getSchema() {
    return FieldRT.fields;
  }
  /**
   *
   * @param json
   * @param instance
   */
  static fillFromJSON(json, instance) {
    const validation = FieldRT.validate(json);
    if (validation.success) {
      instance.fieldType = validation.value.fieldType;
      instance.fieldName = validation.value.fieldName;
      instance.fieldLabel = validation.value.fieldLabel;
      instance.fieldDescription = validation.value.fieldDescription;
      instance.fieldPlaceholder = validation.value.fieldPlaceholder;
      instance.fieldRequired = validation.value.fieldRequired;
      instance.fieldExcludedFromLists = validation.value.fieldExcludedFromLists;
      instance.readACL = validation.value.readACL;
      instance.writeACL = validation.value.writeACL;
      instance.usageCount = validation.value.usageCount;
      const getValidation = (ve) => {
        const validatedVE = ValidationExpression.fromJSON(ve);
        if (ve.errorParams) {
          const errorParamsValidation = ValidationErrorMessageParametersRT.validate(ve.errorParams);
          if (!errorParamsValidation.success) {
            throw new MalformedFieldError(json, instance.fieldType || json.fieldType, errorParamsValidation.code, errorParamsValidation.details);
          }
        }
        return validatedVE;
      };
      if (validation.value.validationExpressions) {
        instance.validationExpressions = validation.value.validationExpressions.map(getValidation);
      }
      if (validation.value.visibilityExpressions) {
        instance.visibilityExpressions = validation.value.visibilityExpressions.map((viExp) => {
          const validatedViExp = VisibilityExpressionsFieldRT.validate(viExp);
          if (validatedViExp.success) {
            return {
              fieldName: validatedViExp.value.fieldName,
              expressions: validatedViExp.value.expressions.map(getValidation)
            };
          } else {
            throw new MalformedFieldError(json, instance.fieldType || json.fieldType, validatedViExp.code, validatedViExp.details);
          }
        });
      }
    } else {
      throw new MalformedFieldError(json, instance.fieldType || json.fieldType, validation.code, validation.details);
    }
  }
};
var Field = _Field;
_parent = new WeakMap();

// src/utils/graphqlEscape.ts
function graphqlEscape_default(str) {
  return str ? `"${str.replace(/\\/g, "\\\\").replace(/\n/g, "\\n").replace(/"/g, '\\"')}"` : null;
}

// src/utils/mergeObjectAt.ts
function mergeObjectAt(source, extension, at, prepend) {
  return Object.entries(source).reduce((acc, [key, value]) => __spreadValues(__spreadProps(__spreadValues(__spreadValues({}, acc), key === at && prepend ? extension : null), {
    [key]: value
  }), key === at && !prepend ? extension : null), {});
}

// src/fields/TextField.ts
var _TextField = class extends Field {
  /**
   *
   * @param content
   * @returns
   */
  contentRequiredCheck(content) {
    super.contentRequiredCheck(content);
    if (String3.guard(content)) {
      return content.length > 0;
    }
    return false;
  }
  toGraphQLType(parent = "") {
    return "String";
  }
  toGraphQLCreateInputType(parent = "") {
    return "String";
  }
  toGraphQLUpdateInputType(parent = "") {
    return "String";
  }
  getInputFragment(data) {
    const validateResult = String3.validate(data);
    if (validateResult.success) {
      return `${graphqlEscape_default(validateResult.value)}`;
    }
    return "null";
  }
  formatDataForInput(data, throwErrorOnTypeMismatch, updateStrategy) {
    const validationResult = String3.validate(data);
    if (validationResult.success) {
      return validationResult.value;
    }
    if (throwErrorOnTypeMismatch && !isNil_default(data))
      throw new MalformedInputError(this, data, validationResult);
    return null;
  }
  getQueryFragment(contentModelList, params, includeReferents) {
    return `${this.fieldName}
`;
  }
  /**
   *
   */
  static getSchema() {
    return mergeObjectAt(super.getSchema(), GridFieldRT.fields, "fieldRequired", true);
  }
  /**
   *
   * @param json
   * @param instance
   */
  static fillFromJSON(json, instance) {
    if (instance instanceof _TextField) {
      const validation = GridFieldRT.validate(json);
      if (!validation.success) {
        throw new MalformedFieldError(json, _TextField.SCHEMA_TYPE, validation.code, validation.details);
      }
      instance.fieldGridSize = validation.value.fieldGridSize;
      Field.fillFromJSON(json, instance);
    } else {
      throw new Error("Instance is not an instance of TextField");
    }
  }
  /**
   *
   * @param json
   * @param parent
   * @returns
   */
  static fromJSON(json, parent) {
    const validation = GridFieldRT.validate(json);
    if (!validation.success) {
      throw new MalformedFieldError(json, _TextField.SCHEMA_TYPE, validation.code, validation.details);
    }
    const instance = new _TextField(parent);
    instance.fieldGridSize = validation.value.fieldGridSize;
    Field.fillFromJSON(json, instance);
    return instance;
  }
};
var TextField = _TextField;
/**
 *
 */
TextField.SCHEMA_TYPE = "Text";

// src/fields/TitleField.ts
var _TitleField = class extends TextField {
  /**
   *
   * @param json
   * @param parent
   * @returns
   */
  static fromJSON(json, parent) {
    const validation = TitleFieldRT.validate(json);
    if (validation.success) {
      const instance = new _TitleField(parent);
      TextField.fillFromJSON(json, instance);
      instance.useAsSlug = validation.value.useAsSlug;
      return instance;
    } else {
      throw new MalformedFieldError(json, _TitleField.SCHEMA_TYPE, validation.code, validation.details);
    }
  }
};
var TitleField = _TitleField;
/**
 *
 */
TitleField.SCHEMA_TYPE = "Title";

// src/utils/contentIDField.ts
function contentIDField_default(contentModel) {
  if (!contentModel)
    return void 0;
  for (let i = 0; i < contentModel.definition.areas.length; i++) {
    const area = contentModel.definition.areas[i];
    for (let k = 0; k < area.fields.length; k++) {
      const field = area.fields[k];
      if (field instanceof TitleField && field.useAsSlug === true) {
        return field;
      }
    }
  }
  return void 0;
}

// src/utils/deepmerge.ts
var DeepMergeStrategy = /* @__PURE__ */ ((DeepMergeStrategy2) => {
  DeepMergeStrategy2["MERGE"] = "MERGE";
  DeepMergeStrategy2["ASSIGN"] = "ASSIGN";
  return DeepMergeStrategy2;
})(DeepMergeStrategy || {});
var isObject = (item) => {
  return item === Object(item) && !Array.isArray(item);
};
var deepmerge = (strategy, target, ...sources) => {
  if (!sources.length) {
    return target;
  }
  const result = target;
  if (isObject(result)) {
    const len = sources.length;
    for (let i = 0; i < len; i += 1) {
      const elm = sources[i];
      if (isObject(elm)) {
        for (const key in elm) {
          if (Object.prototype.hasOwnProperty.call(elm, key)) {
            if (isObject(elm[key])) {
              if (!result[key] || !isObject(result[key])) {
                result[key] = {};
              }
              deepmerge(strategy, result[key], elm[key]);
            } else {
              if (Array.isArray(result[key]) && Array.isArray(elm[key]) && (strategy !== "ASSIGN" /* ASSIGN */ || result[key].length === elm[key].length)) {
                const resArr = result[key];
                const elmArr = elm[key];
                result[key] = resArr.map((obj, i2) => {
                  if (isObject(obj)) {
                    return deepmerge(strategy, obj, elmArr[i2]);
                  }
                  return !isNil_default(elmArr[i2]) ? elmArr[i2] : obj;
                });
              } else {
                if (!isNil_default(elm[key]))
                  result[key] = elm[key];
              }
            }
          }
        }
      }
    }
  }
  return result;
};

// src/utils/flattenArray.ts
var flattenArray = (arr) => {
  return [].concat(...arr);
};
var flattenArrayDeep = (input) => {
  return flattenArray(input.map((x) => Array.isArray(x) ? flattenArrayDeep(x) : [x]));
};

// src/utils/floatToSortableString.ts
function floatToSortableString_default(number) {
  const maxlen = 50;
  number = +number;
  const str = number.toString();
  const arr = str.split(".");
  if (!arr[1]) {
    arr[1] = "0";
  }
  const len0 = arr[0].length;
  const diff0 = maxlen - len0;
  if (diff0 > 0) {
    arr[0] = arr[0].padStart(diff0, "0");
  }
  const len1 = arr[1].length;
  const diff1 = maxlen - len1;
  if (diff1 > 0) {
    arr[1] = arr[1].padEnd(diff1, "0");
  }
  return arr.join(".");
}

// src/utils/getContentBasicFields.ts
import { hasEnabledFlag } from "@monogrid/env";
function getContentBasicFields_default() {
  return `
  id
  _slug
  ${hasEnabledFlag("CMS_FEATURE_OCC") ? "_hash" : ""}
  _author
  _createdAt
  _modifiedAt
  _modifiedBy
  _isPublished
  _isUpdated
  __typename
  `;
}

// src/utils/getGlobalQueryStatus.ts
function getGlobalQueryStatus_default(info) {
  let status;
  if (info.operation.operation === "mutation") {
    status = "DRAFT" /* DRAFT */;
  } else if (ContentStatusRT.guard(info.variableValues.status)) {
    status = info.variableValues.status;
  } else if (info.operation.loc) {
    status = info.operation.loc.source.body.indexOf("status: DRAFT") !== -1 ? "DRAFT" /* DRAFT */ : void 0;
  }
  return status || "PUBLISHED" /* PUBLISHED */;
}

// src/utils/getGlobalQueryVariants.ts
function getGlobalQueryVariants_default(info) {
  let variants = ["base"];
  if (info.variableValues.variants && Array.isArray(info.variableValues.variants)) {
    variants = info.variableValues.variants;
  } else {
  }
  return variants;
}

// src/utils/getTitleInfoForInput.ts
function getTitleInfoForInput_default(model, input) {
  let retValue;
  model.findFieldsByType(TitleField).forEach((titleField) => {
    const val = input[titleField.fieldName];
    if (titleField.useAsSlug === true && typeof val === "string" && val.length > 0) {
      retValue = {
        name: titleField.fieldName,
        value: val
      };
    }
  });
  return retValue;
}

// src/utils/getUndefinedForField.ts
function getUndefinedForField_default(field, filler = "undefined") {
  switch (field.fieldType) {
    case "Date":
    case "DateTime":
      return (/* @__PURE__ */ new Date()).toISOString();
    case "URL":
      return `http://${filler}`;
    case "Array":
    case "Repeater":
      return [];
    case "BOOL":
      return false;
    case "Map":
      return {};
    case "Image":
    case "GenericMedia":
      return {
        fileName: filler,
        fileSize: NaN,
        modifiedAt: (/* @__PURE__ */ new Date()).toISOString(),
        mimeType: filler,
        metaData: "{}"
      };
    default:
      return filler;
  }
}

// src/utils/isObject.ts
function isObject_default(value) {
  return !isNil_default(value) && typeof value === "object" && !Array.isArray(value);
}

// src/fields/index.ts
var fields_exports = {};
__export(fields_exports, {
  ArrayField: () => ArrayField,
  BoolField: () => BoolField,
  ColorField: () => ColorField,
  DateField: () => DateField,
  DateTimeField: () => DateTimeField,
  GLBField: () => GLBField,
  GenericMediaField: () => GenericMediaField,
  ImageField: () => ImageField,
  JSONField: () => JSONField,
  MapField: () => MapField,
  NumberField: () => NumberField,
  Panorama360Field: () => Panorama360Field,
  ReferenceField: () => ReferenceField,
  RepeaterField: () => RepeaterField,
  RichTextField: () => RichTextField,
  SelectField: () => SelectField,
  TextField: () => TextField,
  TitleField: () => TitleField,
  URLField: () => URLField
});

// src/FieldFactory.ts
import { Failcode as Failcode2 } from "runtypes";
var getFieldFromJSON = (json, parent) => {
  if (!InstantiableFieldRT.guard(json))
    throw new NonInstantiableFieldError();
  const declarations = Object.values(fields_exports);
  for (let i = 0; i < declarations.length; i++) {
    const declaration = declarations[i];
    if (declaration.SCHEMA_TYPE === json.fieldType) {
      return declaration.fromJSON(json, parent);
    }
  }
  throw new ContentModelValidationError("Unknown Field type " + json.fieldType, Failcode2.CONTENT_INCORRECT);
};

// src/fields/ArrayField.ts
var _arrayInputString = (field, data) => {
  let values = "";
  for (let i = 0; i < data.length; i++) {
    values += `${field.arrayValueType.getInputFragment(data[i])},
    `;
  }
  return values;
};
var _ArrayField = class extends Field {
  nameChild(child) {
    return `[${child.fieldName}]`;
  }
  get graphQLArguments() {
    return this.arrayValueType.graphQLArguments;
  }
  toGraphQLType(parent = "") {
    const parentName = parent + capitalize_default(this.fieldName);
    return `[${this.arrayValueType.toGraphQLType(parentName)}]`;
  }
  toGraphQLCreateInputType(parent = "") {
    const parentName = parent + capitalize_default(this.fieldName);
    return `[${this.arrayValueType.toGraphQLCreateInputType(parentName)}]`;
  }
  toGraphQLUpdateInputType(parent = "") {
    const parentName = parent + capitalize_default(this.fieldName);
    return `[${this.arrayValueType.toGraphQLUpdateInputType(parentName)}]`;
  }
  getCompleteInputFragment(data) {
    const validationResult = UnknownArrayRT.validate(data);
    if (validationResult.success) {
      return `${this.fieldName}: [
          ${this.getInputFragment(validationResult.value)}
        ]
`;
    }
    return `${this.fieldName}: null
`;
  }
  /**
   * @param data
   * @returns
   */
  getInputFragment(data) {
    const validationResult = UnknownArrayRT.validate(data);
    if (validationResult.success) {
      return _arrayInputString(this, validationResult.value);
    }
    return "null";
  }
  formatDataForInput(data, throwErrorOnTypeMismatch, updateStrategy) {
    const validationResult = UnknownArrayRT.validate(data);
    if (validationResult.success) {
      return validationResult.value.map((value) => this.arrayValueType.formatDataForInput(value, throwErrorOnTypeMismatch, updateStrategy));
    }
    if (throwErrorOnTypeMismatch && !isNil_default(data))
      throw new MalformedInputError(this, data, validationResult);
    return null;
  }
  getInnerQueryFields(contentModelList, params, includeReferents) {
    return this.arrayValueType.getInnerQueryFields(contentModelList, params, includeReferents);
  }
  getQueryFragment(contentModelList, params, includeReferents) {
    const innerFields = this.arrayValueType.getInnerQueryFields(contentModelList, params, includeReferents);
    if (innerFields) {
      return `${this.fieldName} {
          ${innerFields}
        }
`;
    } else {
      return `${this.fieldName}
`;
    }
  }
  get children() {
    return [this.arrayValueType];
  }
  /**
   *
   */
  contentRequiredCheck(content) {
    if (!super.contentRequiredCheck(content))
      return false;
    if (UnknownArrayRT.guard(content)) {
      return content.length > 0;
    }
    return false;
  }
  validateContent(content, referenceResolverCallback, rootType, excludeRequired) {
    return __async(this, null, function* () {
      const validations = [__superGet(_ArrayField.prototype, this, "validateContent").call(this, content, referenceResolverCallback, rootType, excludeRequired)];
      if (UnknownArrayRT.guard(content)) {
        content.forEach((item) => {
          validations.push(this.arrayValueType.validateContent(item, referenceResolverCallback, rootType, excludeRequired));
        });
      }
      return flattenArrayDeep(yield Promise.all(validations));
    });
  }
  /**
   *
   * @param json
   * @param instance
   */
  static fillFromJSON(json, instance) {
    if (instance instanceof _ArrayField) {
      Field.fillFromJSON(json, instance);
    } else {
      throw new Error("Instance is not an instance of ArrayField");
    }
  }
  /**
   *
   */
  static getSchema() {
    return __spreadValues(__spreadValues({}, super.getSchema()), ArrayFieldRT.fields);
  }
  /**
   *
   * @param json
   * @param parent
   * @returns
   */
  static fromJSON(json, parent) {
    const validation = ArrayFieldRT.validate(json);
    if (validation.success) {
      const instance = new _ArrayField(parent);
      Field.fillFromJSON(json, instance);
      instance.arrayValueType = getFieldFromJSON(validation.value.arrayValueType, instance);
      return instance;
    } else {
      throw new MalformedFieldError(json, _ArrayField.SCHEMA_TYPE, validation.code, validation.details);
    }
  }
};
var ArrayField = _ArrayField;
/**
 *
 */
ArrayField.SCHEMA_TYPE = "Array";

// src/fields/BoolField.ts
import { Boolean as Boolean2 } from "runtypes";
var _BoolField = class extends Field {
  /**
   *
   * @param parent
   * @returns
   */
  toGraphQLType(parent = "") {
    return "Boolean";
  }
  getInputFragment(data) {
    const validationResult = Boolean2.validate(data);
    if (validationResult.success) {
      return `${validationResult.value}`;
    }
    return "null";
  }
  formatDataForInput(data, throwErrorOnTypeMismatch, updateStrategy) {
    const validationResult = Boolean2.validate(data);
    if (validationResult.success) {
      return validationResult.value;
    }
    if (throwErrorOnTypeMismatch && !isNil_default(data))
      throw new MalformedInputError(this, data, validationResult);
    return null;
  }
  getQueryFragment(contentModelList, params, includeReferents) {
    return `${this.fieldName}
`;
  }
  validateContent(content, referenceResolverCallback, rootType, excludeRequired) {
    return __async(this, null, function* () {
      const validations = [__superGet(_BoolField.prototype, this, "validateContent").call(this, content, referenceResolverCallback, rootType, excludeRequired)];
      if (!isNil_default(content) && typeof content !== "boolean") {
        validations.push(new BoolInvalidValidationExpression().eval(this, content, rootType).then((err) => [err]));
      }
      return flattenArrayDeep(yield Promise.all(validations));
    });
  }
  /**
   *
   */
  static getSchema() {
    return mergeObjectAt(super.getSchema(), GridFieldRT.fields, "fieldRequired", true);
  }
  /**
   *
   * @param json
   * @param instance
   */
  static fillFromJSON(json, instance) {
    if (instance instanceof _BoolField) {
      Field.fillFromJSON(json, instance);
      const validation = GridFieldRT.validate(json);
      if (!validation.success) {
        throw new MalformedFieldError(json, _BoolField.SCHEMA_TYPE, validation.code, validation.details);
      }
      instance.fieldGridSize = validation.value.fieldGridSize;
    } else {
      throw new Error("Instance is not an instance of BoolField");
    }
  }
  /**
   *
   * @param json
   * @param parent
   * @returns
   */
  static fromJSON(json, parent) {
    const validation = GridFieldRT.validate(json);
    if (!validation.success) {
      throw new MalformedFieldError(json, _BoolField.SCHEMA_TYPE, validation.code, validation.details);
    }
    const instance = new _BoolField(parent);
    instance.fieldGridSize = validation.value.fieldGridSize;
    Field.fillFromJSON(json, instance);
    return instance;
  }
};
var BoolField = _BoolField;
/**
 *
 */
BoolField.SCHEMA_TYPE = "BOOL";

// src/fields/ColorField.ts
var _ColorField = class extends TextField {
  /**
   *
   */
  validateContent(content, referenceResolverCallback, rootType, excludeRequired) {
    return __async(this, null, function* () {
      const validations = [__superGet(_ColorField.prototype, this, "validateContent").call(this, content, referenceResolverCallback, rootType, excludeRequired)];
      if (!isNil_default(content) && this.showSwatchesOnly && (this.swatches || []).findIndex((swatch) => swatch === content)) {
        validations.push(new ColorSwatchInvalidValidationExpression().eval(this, content, rootType).then((err) => [err]));
      }
      return flattenArrayDeep(yield Promise.all(validations));
    });
  }
  /**
   *
   */
  static getSchema() {
    return mergeObjectAt(super.getSchema(), ColorFieldRT.fields, "fieldRequired", true);
  }
  /**
   *
   * @param json
   * @param parent
   * @returns
   */
  static fromJSON(json, parent) {
    const validation = ColorFieldRT.validate(json);
    if (validation.success) {
      const instance = new _ColorField(parent);
      instance.defaultColorFormat = validation.value.defaultColorFormat;
      instance.enableFormatChange = validation.value.enableFormatChange;
      instance.enableAlpha = validation.value.enableAlpha;
      instance.forceAlpha = validation.value.forceAlpha;
      instance.showSwatchesOnly = validation.value.showSwatchesOnly;
      if (Array.isArray(validation.value.swatches)) {
        const v = NotEmptyStringArrayRT.validate(validation.value.swatches);
        if (v.success) {
          instance.swatches = v.value;
        } else {
          throw new MalformedFieldError(json, _ColorField.SCHEMA_TYPE, v.code, v.details);
        }
      } else {
        instance.swatches = void 0;
      }
      TextField.fillFromJSON(json, instance);
      return instance;
    } else {
      throw new MalformedFieldError(json, _ColorField.SCHEMA_TYPE, validation.code, validation.details);
    }
  }
};
var ColorField = _ColorField;
/**
 *
 */
ColorField.SCHEMA_TYPE = "Color";

// src/fields/DateField.ts
var _DateField = class extends TextField {
  /**
   *
   */
  static getSchema() {
    return mergeObjectAt(super.getSchema(), DateFieldRT.fields, "fieldRequired", true);
  }
  getInputFragment(data) {
    const validateResult = DateInputRT.validate(data);
    if (validateResult.success) {
      return `${graphqlEscape_default(new Date(validateResult.value).toISOString())}`;
    }
    return "null";
  }
  formatDataForInput(data, throwErrorOnTypeMismatch, updateStrategy) {
    const validationResult = DateInputRT.validate(data);
    if (validationResult.success) {
      return new Date(validationResult.value).toISOString();
    }
    if (throwErrorOnTypeMismatch && !isNil_default(data))
      throw new MalformedInputError(this, data, validationResult);
    return null;
  }
  /**
   *
   * @param json
   * @param parent
   * @returns
   */
  static fromJSON(json, parent) {
    const validation = DateFieldRT.validate(json);
    if (!validation.success) {
      throw new MalformedFieldError(json, _DateField.SCHEMA_TYPE, validation.code, validation.details);
    }
    const instance = new _DateField(parent);
    instance.mode = validation.value.mode;
    TextField.fillFromJSON(json, instance);
    return instance;
  }
};
var DateField = _DateField;
/**
 *
 */
DateField.SCHEMA_TYPE = "Date";

// src/fields/DateTimeField.ts
var _DateTimeField = class extends TextField {
  /**
   *
   * @param data
   * @returns
   */
  getInputFragment(data) {
    const validateResult = DateInputRT.validate(data);
    if (validateResult.success) {
      return `${graphqlEscape_default(new Date(validateResult.value).toISOString())}`;
    }
    return "null";
  }
  formatDataForInput(data, throwErrorOnTypeMismatch, updateStrategy) {
    const validationResult = DateInputRT.validate(data);
    if (validationResult.success) {
      return new Date(validationResult.value).toISOString();
    }
    if (throwErrorOnTypeMismatch && !isNil_default(data))
      throw new MalformedInputError(this, data, validationResult);
    return null;
  }
  /**
   *
   * @param json
   * @param parent
   * @returns
   */
  static fromJSON(json, parent) {
    const instance = new _DateTimeField(parent);
    TextField.fillFromJSON(json, instance);
    return instance;
  }
};
var DateTimeField = _DateTimeField;
/**
 *
 */
DateTimeField.SCHEMA_TYPE = "DateTime";

// src/fields/ReferenceField.ts
import { hasEnabledFlag as hasEnabledFlag2 } from "@monogrid/env";
var _ReferenceField = class extends Field {
  toGraphQLType(parent = "") {
    return this.referenceModelId;
  }
  toGraphQLCreateInputType(parent = "") {
    return "String";
  }
  get graphQLArguments() {
    return `(status: ContentStatus, variants: [${this.referenceModelId}VariantSelection])`;
  }
  getInputFragment(data) {
    const legacyValidationResult = LegacyReferenceFieldInputRT.validate(data);
    if (legacyValidationResult.success) {
      return `"${legacyValidationResult.value}"`;
    }
    const validationResult = ReferenceFieldInputRT.validate(data);
    if (validationResult.success) {
      return `"_reference/${this.referenceModelId}/${validationResult.value.id}"`;
    }
    return "null";
  }
  formatDataForInput(data, throwErrorOnTypeMismatch, updateStrategy) {
    const legacyValidationResult = LegacyReferenceFieldInputRT.validate(data);
    if (legacyValidationResult.success) {
      return legacyValidationResult.value;
    }
    const validationResult = ReferenceFieldInputRT.validate(data);
    if (validationResult.success) {
      return `_reference/${this.referenceModelId}/${validationResult.value.id}`;
    }
    if (throwErrorOnTypeMismatch && !isNil_default(data))
      throw new MalformedInputError(this, data, legacyValidationResult, validationResult);
    return null;
  }
  getInnerQueryFields(contentModelList, params, includeReferents) {
    var _a;
    const referentsFragment = `_referents {
      ${hasEnabledFlag2("CMS_FEATURE_LIST_ID") ? "id" : ""}
      count
      pointers
    }
    `;
    let innerFields = `
    ${getContentBasicFields_default()}
    ${includeReferents ? referentsFragment : ""}
    `;
    if (contentModelList && contentModelList.length > 0) {
      const id = this.referenceModelId;
      const referenceContentModel = contentModelList.find((obj) => obj.id === id);
      if (referenceContentModel) {
        innerFields += `
          ${((_a = contentIDField_default(referenceContentModel)) == null ? void 0 : _a.fieldName) || ""}
        `;
      }
    }
    return innerFields;
  }
  getQueryFragment(contentModelList, params, includeReferents) {
    return `${this.fieldName} {
        ${this.getInnerQueryFields(contentModelList, params, includeReferents)}
      }
`;
  }
  /**
   *
   * @param content
   * @param excludeRequired
   * @returns
   */
  validateContent(content, referenceResolverCallback, rootType, excludeRequired) {
    return __async(this, null, function* () {
      const legacyValidationResult = LegacyReferenceFieldInputRT.validate(content);
      if (legacyValidationResult.success) {
        const modelID = legacyValidationResult.value.split("/")[1];
        const contentID = legacyValidationResult.value.split("/")[2];
        const referenceContent = yield referenceResolverCallback(modelID, contentID);
        const validations = [__superGet(_ReferenceField.prototype, this, "validateContent").call(this, referenceContent, referenceResolverCallback, rootType, excludeRequired)];
        return flattenArrayDeep(yield Promise.all(validations));
      }
      const validationResult = ReferenceFieldInputRT.validate(content);
      if (validationResult.success) {
        const validations = [__superGet(_ReferenceField.prototype, this, "validateContent").call(this, content, referenceResolverCallback, rootType, excludeRequired)];
        const result = flattenArrayDeep(yield Promise.all(validations));
        return result;
      }
      return [];
    });
  }
  /**
   *
   */
  static getSchema() {
    return mergeObjectAt(super.getSchema(), ReferenceFieldRT.fields, "fieldRequired", true);
  }
  /**
   *
   * @param json
   * @param instance
   */
  static fillFromJSON(json, instance) {
    const validation = ReferenceFieldRT.validate(json);
    if (validation.success) {
      instance.referenceModelId = validation.value.referenceModelId;
    } else {
      throw new MalformedFieldError(json, instance.fieldType || `${json["fieldType"]}`, validation.code, validation.details);
    }
  }
  /**
   *
   * @param json
   * @param parent
   * @returns
   */
  static fromJSON(json, parent) {
    const validation = ReferenceFieldRT.validate(json);
    if (validation.success) {
      const instance = new _ReferenceField(parent);
      Field.fillFromJSON(json, instance);
      instance.referenceModelId = validation.value.referenceModelId;
      return instance;
    } else {
      throw new MalformedFieldError(json, _ReferenceField.SCHEMA_TYPE, validation.code, validation.details);
    }
  }
};
var ReferenceField = _ReferenceField;
/**
 *
 */
ReferenceField.SCHEMA_TYPE = "Reference";

// src/fields/GenericMediaField.ts
var _GenericMediaField = class extends ReferenceField {
  /**
   *
   * @param parent
   * @returns
   */
  toGraphQLType(parent = "") {
    return MEDIA_FILE_CONTENT_MODEL_ID;
  }
  get graphQLArguments() {
    return "";
  }
  getInnerQueryFields(contentModelList, params, includeReferents) {
    return `${super.getInnerQueryFields(contentModelList, params, includeReferents)}
      metaData
      fileSize
      mimeType
      isUploaded
      originalName
    `;
  }
  /**
   *
   */
  static getSchema() {
    return Object.entries(super.getSchema()).reduce((acc, [key, value]) => {
      if (key !== "referenceModelId") {
        acc[key] = value;
      }
      return acc;
    }, {});
  }
  /**
   *
   * @param json
   * @param instance
   */
  static fillFromJSON(json, instance) {
    if (instance instanceof _GenericMediaField) {
      Field.fillFromJSON(json, instance);
      instance.referenceModelId = MEDIA_FILE_CONTENT_MODEL_ID;
    } else {
      throw new Error("Instance is not an instance of GenericMediaField");
    }
  }
  /**
   *
   * @param json
   * @param parent
   * @returns
   */
  static fromJSON(json, parent) {
    const instance = new _GenericMediaField(parent);
    Field.fillFromJSON(json, instance);
    instance.referenceModelId = MEDIA_FILE_CONTENT_MODEL_ID;
    return instance;
  }
};
var GenericMediaField = _GenericMediaField;
/**
 *
 */
GenericMediaField.SCHEMA_TYPE = "GenericMedia";

// src/fields/GLBField.ts
var _GLBField = class extends GenericMediaField {
  /**
   *
   * @param json
   * @param parent
   * @returns
   */
  static fromJSON(json, parent) {
    const instance = new _GLBField(parent);
    GenericMediaField.fillFromJSON(json, instance);
    return instance;
  }
};
var GLBField = _GLBField;
/**
 *
 */
GLBField.SCHEMA_TYPE = "GLB";

// src/fields/ImageField.ts
var _ImageField = class extends GenericMediaField {
  /**
   *
   * @param json
   * @param parent
   * @returns
   */
  static fromJSON(json, parent) {
    const instance = new _ImageField(parent);
    GenericMediaField.fillFromJSON(json, instance);
    return instance;
  }
};
var ImageField = _ImageField;
/**
 *
 */
ImageField.SCHEMA_TYPE = "Image";

// src/fields/JSONField.ts
var _JSONField = class extends TextField {
  /**
   *
   * @param parent
   * @returns
   */
  toGraphQLType(parent = "") {
    return "JSON";
  }
  /**
   *
   * @param json
   * @param parent
   * @returns
   */
  static fromJSON(json, parent) {
    const instance = new _JSONField(parent);
    TextField.fillFromJSON(json, instance);
    return instance;
  }
};
var JSONField = _JSONField;
/**
 *
 */
JSONField.SCHEMA_TYPE = "JSON";

// src/fields/MapField.ts
import { hasEnabledFlag as hasEnabledFlag3 } from "@monogrid/env";
var _MapField = class extends Field {
  validateContent(content, referenceResolverCallback, rootType, excludeRequired) {
    return __async(this, null, function* () {
      const validations = [__superGet(_MapField.prototype, this, "validateContent").call(this, content, referenceResolverCallback, rootType, excludeRequired)];
      if (isObject_default(content)) {
        validations.push(this.mapKey.validateContent(content[this.mapKey.fieldName], referenceResolverCallback, rootType, excludeRequired));
        validations.push(this.mapValue.validateContent(content[this.mapValue.fieldName], referenceResolverCallback, rootType, excludeRequired));
      }
      const res = yield Promise.all(validations);
      return flattenArrayDeep(res);
    });
  }
  get producesGraphQLRootTypes() {
    return true;
  }
  toGraphQLType(parent = "") {
    const name = parent + capitalize_default(this.fieldName);
    return `${name}`;
  }
  toGraphQLCreateInputType(parent = "") {
    const name = parent + capitalize_default(this.fieldName);
    return `${name}CreateInput`;
  }
  toGraphQLUpdateInputType(parent = "") {
    const name = parent + capitalize_default(this.fieldName);
    return `${name}UpdateInput`;
  }
  getInputFragment(data) {
    if (isObject_default(data)) {
      return `{
        ${this.mapKey.getCompleteInputFragment(data[this.mapKey.fieldName])}
        ${this.mapValue.getCompleteInputFragment(data[this.mapValue.fieldName])}
      }`;
    }
    return "null";
  }
  formatDataForInput(data, throwErrorOnTypeMismatch, updateStrategy) {
    if (isObject_default(data)) {
      const ret = {};
      this.mapKey.createPropertyOnInputVariable(ret, data, throwErrorOnTypeMismatch, updateStrategy);
      this.mapValue.createPropertyOnInputVariable(ret, data, throwErrorOnTypeMismatch, updateStrategy);
      switch (updateStrategy) {
        case "ASSIGN" /* ASSIGN */:
        case "MERGE" /* MERGE */:
          if (Object.keys(ret).length > 0)
            return ret;
          break;
        default:
          return ret;
      }
    }
    return null;
  }
  getQueryFragment(contentModelList, params, includeReferents) {
    return `${this.fieldName} {
        ${hasEnabledFlag3("CMS_FEATURE_LIST_ID") ? "id" : ""}
        ${this.mapKey.getQueryFragment(contentModelList, params, includeReferents)}
        ${this.mapValue.getQueryFragment(contentModelList, params, includeReferents)}
      }
`;
  }
  getInnerQueryFields(contentModelList, params, includeReferents) {
    return `${hasEnabledFlag3("CMS_FEATURE_LIST_ID") ? "id" : ""}
          ${this.mapKey.getQueryFragment(contentModelList, params, includeReferents)}
          ${this.mapValue.getQueryFragment(contentModelList, params, includeReferents)}
`;
  }
  getGraphQLRootTypes(namePrefix, isVariant) {
    const name = this.getUniqueTypeName(namePrefix);
    let r = "";
    const keyArguments = this.mapKey.graphQLArguments;
    const valueArguments = this.mapValue.graphQLArguments;
    r += `
    type ${name} {
      ${hasEnabledFlag3("CMS_FEATURE_LIST_ID") ? "id: ID" : ""}
      ${this.mapKey.fieldName}${keyArguments}: ${this.mapKey.toGraphQLType(name)}${this.mapKey.fieldRequired && !isVariant ? "!" : ""}
      ${this.mapValue.fieldName}${valueArguments}: ${this.mapValue.toGraphQLType(name)}${this.mapValue.fieldRequired && !isVariant ? "!" : ""}
    }
    input ${name}CreateInput {
      ${this.mapKey.fieldName}: ${this.mapKey.toGraphQLCreateInputType(name)}${this.mapKey.fieldRequired && !isVariant ? "!" : ""}
      ${this.mapValue.fieldName}: ${this.mapValue.toGraphQLCreateInputType(name)}${this.mapValue.fieldRequired && !isVariant ? "!" : ""}
    }
    input ${name}UpdateInput {
      ${this.mapKey.fieldName}: ${this.mapKey.toGraphQLUpdateInputType(name)}
      ${this.mapValue.fieldName}: ${this.mapValue.toGraphQLUpdateInputType(name)}
    }
    `;
    return r;
  }
  get children() {
    return [this.mapKey, this.mapValue];
  }
  /**
   *
   */
  static getSchema() {
    return __spreadValues(__spreadValues({}, super.getSchema()), MapFieldRT.fields);
  }
  /**
   *
   * @param json
   * @param parent
   * @returns
   */
  static fromJSON(json, parent) {
    const validation = MapFieldRT.validate(json);
    if (validation.success) {
      const instance = new _MapField(parent);
      Field.fillFromJSON(json, instance);
      instance.mapKey = getFieldFromJSON(validation.value.mapKey, instance);
      instance.mapValue = getFieldFromJSON(validation.value.mapValue, instance);
      return instance;
    } else {
      throw new MalformedFieldError(json, _MapField.SCHEMA_TYPE, validation.code, validation.details);
    }
  }
};
var MapField = _MapField;
/**
 *
 */
MapField.SCHEMA_TYPE = "Map";

// src/fields/NumberField.ts
import { Number as Number2 } from "runtypes";
var _NumberField = class extends Field {
  toGraphQLType(parent = "") {
    return "Float";
  }
  getInputFragment(data) {
    const validateResult = Number2.validate(data);
    if (validateResult.success) {
      return `${validateResult.value}`;
    }
    return "null";
  }
  formatDataForInput(data, throwErrorOnTypeMismatch, updateStrategy) {
    const validationResult = Number2.validate(data);
    if (validationResult.success) {
      return validationResult.value;
    }
    if (throwErrorOnTypeMismatch && !isNil_default(data))
      throw new MalformedInputError(this, data, validationResult);
    return null;
  }
  getQueryFragment(contentModelList, params, includeReferents) {
    return `${this.fieldName}
`;
  }
  validateContent(content, referenceResolverCallback, rootType, excludeRequired) {
    return __async(this, null, function* () {
      const validations = [__superGet(_NumberField.prototype, this, "validateContent").call(this, content, referenceResolverCallback, rootType, excludeRequired)];
      if (!isNil_default(content) && typeof content !== "number") {
        validations.push(new NumberInvalidValidationExpression().eval(this, content, rootType).then((err) => [err]));
      }
      return flattenArrayDeep(yield Promise.all(validations));
    });
  }
  /**
   *
   */
  static getSchema() {
    return mergeObjectAt(super.getSchema(), GridFieldRT.fields, "fieldRequired", true);
  }
  /**
   *
   * @param json
   * @param parent
   * @returns
   */
  static fromJSON(json, parent) {
    const validation = GridFieldRT.validate(json);
    if (!validation.success) {
      throw new MalformedFieldError(json, _NumberField.SCHEMA_TYPE, validation.code, validation.details);
    }
    const instance = new _NumberField(parent);
    instance.fieldGridSize = validation.value.fieldGridSize;
    Field.fillFromJSON(json, instance);
    return instance;
  }
};
var NumberField = _NumberField;
/**
 *
 */
NumberField.SCHEMA_TYPE = "Number";

// src/fields/Panorama360Field.ts
var _Panorama360Field = class extends GenericMediaField {
  /**
   *
   * @param json
   * @param parent
   * @returns
   */
  static fromJSON(json, parent) {
    const instance = new _Panorama360Field(parent);
    GenericMediaField.fillFromJSON(json, instance);
    return instance;
  }
};
var Panorama360Field = _Panorama360Field;
/**
 *
 */
Panorama360Field.SCHEMA_TYPE = "Panorama360";

// src/fields/RepeaterField.ts
import * as rt from "runtypes";

// src/GraphQLGenerator.ts
import { hasEnabledFlag as hasEnabledFlag4 } from "@monogrid/env";
import { Record as Record2, String as String4 } from "runtypes";
var MutationAction = /* @__PURE__ */ ((MutationAction2) => {
  MutationAction2["PUBLISH"] = "Publish";
  MutationAction2["UNPUBLISH"] = "Unpublish";
  MutationAction2["CREATE"] = "Create";
  MutationAction2["DELETE"] = "Delete";
  MutationAction2["UPDATE"] = "Update";
  return MutationAction2;
})(MutationAction || {});
var GraphQLGenerator = class {
  /**
   *
   * @param contentModel
   * @param contentModelList
   * @returns
   */
  static variantsFields(contentModel, contentModelList, fieldParameters, includeReferents) {
    var _a;
    let base = `
    id
    `;
    (_a = contentModel.definition.variants) == null ? void 0 : _a.forEach((variant) => {
      base += `
      ${variant.name} {
        id
        ${GraphQLGenerator.queryFields(contentModel, contentModelList, fieldParameters, includeReferents)}
      }
      `;
    });
    return base;
  }
  /**
   *
   * @param contentModel
   * @param contentModelList
   * @returns
   */
  static queryFields(contentModel, contentModelList, fieldParameters = /* @__PURE__ */ new Map(), includeReferents) {
    let returnValue = "";
    if (!fieldParameters.has(RepeaterField)) {
      fieldParameters.set(RepeaterField, [`referenceResolutionStrategy: ${includeReferents ? "COMPLETE" : "SIMPLE"}`]);
    }
    contentModel.flatten().forEach((field) => {
      returnValue += field.getQueryFragment(contentModelList, fieldParameters, includeReferents);
    });
    return returnValue;
  }
  static contentQueryFields({ contentModel, contentModelList, light, includeVariants, includeReferents, additionalFields, fieldParameters }) {
    const idfield = contentIDField_default(contentModel);
    const variantsQuery = includeVariants ? `_variants {
        ${GraphQLGenerator.variantsFields(contentModel, contentModelList, fieldParameters, includeReferents)}
      }` : "";
    const referentsQuery = includeReferents ? `_referents {
        ${hasEnabledFlag4("CMS_FEATURE_LIST_ID") ? "id" : ""}
        count
        pointers
      }` : "";
    return `
      ${getContentBasicFields_default()}
      ${light ? (idfield == null ? void 0 : idfield.fieldName) || "" : GraphQLGenerator.queryFields(contentModel, contentModelList, fieldParameters, includeReferents)}
      ${variantsQuery}
      ${referentsQuery}
      ${additionalFields ? additionalFields.join("\n") : ""}
    `;
  }
  /**
   *
   * @param param0
   * @returns
   */
  static listQuery({ contentModel, contentModelList, light, includeListID, includeVariants, includeReferents, additionalFields }) {
    const _includeListID = includeListID === true && hasEnabledFlag4("CMS_FEATURE_LIST_ID");
    return `query List${contentModel.id}($sortOn: ${contentModel.id}SortOptions, $descending: Boolean, $limit: Int, $cursor: String, $status: ContentStatus, $variants:[${contentModel.id}VariantSelection]) {
      List${contentModel.id}(sortOn: $sortOn, descending: $descending, limit: $limit, cursor: $cursor, status: $status, variants: $variants) {
        ${_includeListID ? "id" : ""}
        items {
          ${GraphQLGenerator.contentQueryFields({ contentModel, contentModelList, light, includeVariants, includeReferents, additionalFields })}
        }
        cursor
        totalCount
      }
    }`;
  }
  /**
   *
   * @param param0
   * @returns
   */
  static referentsQuery({ contentModel, referentsContentModel, contentModelList, light, includeVariants, includeReferents, additionalFields }) {
    return `query ${contentModel.id}${referentsContentModel.id}Referents ($id: String, $sortOn: ${referentsContentModel.id}SortOptions, $descending: Boolean, $limit: Int, $cursor: String, $status: ContentStatus, $variants:[${referentsContentModel.id}VariantSelection]) {
      Get${contentModel.id}(id:$id, status: $status){
        id
        _referents {
          ${hasEnabledFlag4("CMS_FEATURE_LIST_ID") ? "id" : ""}
          ${referentsContentModel.id}Referents(sortOn: $sortOn, descending: $descending, limit: $limit, cursor: $cursor, status: $status, variants: $variants) {
            ${hasEnabledFlag4("CMS_FEATURE_LIST_ID") ? "id" : ""}
            items {
              ${GraphQLGenerator.contentQueryFields({ contentModel: referentsContentModel, contentModelList, light, includeVariants, includeReferents, additionalFields })}
            }
            cursor
            totalCount
          }
        }
      }
    }`;
  }
  /**
   *
   * @param params Patrameters
   * @returns
   */
  static getQuery({ contentModel, contentModelList, light, includeVariants, includeReferents, additionalFields }) {
    return `query Get${contentModel.id} ($slug: String, $id: String, $status: ContentStatus, $variants:[${contentModel.id}VariantSelection], $where: ${contentModel.id}WhereParameter) {
        Get${contentModel.id} (slug: $slug, id: $id, status: $status, variants: $variants, where: $where) {
          ${GraphQLGenerator.contentQueryFields({ contentModel, contentModelList, light, includeVariants, includeReferents, additionalFields })}
        }
      }
    `;
  }
  /**
   *
   * @param params Patrameters
   * @returns
   */
  static mutationQuery({ action, contentModel, contentModelList, light, includeVariants, includeReferents, additionalFields }) {
    const inputType = [];
    const inputVariable = [];
    if (action !== "Create" /* CREATE */) {
      inputType.push("$id: String!");
      inputVariable.push("id: $id");
    }
    if (action === "Update" /* UPDATE */ || action === "Create" /* CREATE */) {
      inputType.push(`$input:${contentModel.id}${action}Input!`);
      inputVariable.push("input: $input");
    }
    if (action === "Update" /* UPDATE */) {
      inputType.push("$updateStrategy:UpdateStrategy");
      inputVariable.push("updateStrategy: $updateStrategy");
    }
    if (hasEnabledFlag4("CMS_FEATURE_OCC") && (action === "Update" /* UPDATE */ || action === "Delete" /* DELETE */ || action === "Publish" /* PUBLISH */ || action === "Unpublish" /* UNPUBLISH */)) {
      inputType.push("$occHash:String");
      inputVariable.push("occHash: $occHash");
    }
    return `mutation ${action}${contentModel.id} (${inputType.join(", ")}) {
        ${action}${contentModel.id} (${inputVariable.join(", ")}) {
          ${GraphQLGenerator.contentQueryFields({ contentModel, contentModelList, light, includeVariants, includeReferents, additionalFields })}
        }
      }
    `;
  }
  /**
   *
   * @param area
   * @param data
   * @returns
   */
  static areaInputStringFromObject(area, data) {
    let ret = "";
    if (isObject_default(data)) {
      area.fields.forEach((field) => {
        ret += field.getCompleteInputFragment(data[field.fieldName]);
      });
    }
    return ret;
  }
  /**
   *
   * @param area
   * @param outputObject
   * @param data
   * @returns
   */
  static fillAreaVariables(area, outputObject, data, throwErrorOnTypeMismatch, updateStrategy) {
    if (isObject_default(data) && isObject_default(outputObject)) {
      area.fields.forEach((field) => field.createPropertyOnInputVariable(outputObject, data, throwErrorOnTypeMismatch, updateStrategy));
    }
  }
  /**
   *
   * @param contentModel
   * @param object
   * @param throwErrorOnTypeMismatch
   * @param updateStrategy
   * @returns
   */
  static cleanupInputObject(contentModel, object, throwErrorOnTypeMismatch, updateStrategy = "REPLACE" /* REPLACE */) {
    const cleanObject = {};
    if (Record2({ id: String4 }).guard(object)) {
      cleanObject.id = object.id;
    }
    if (hasEnabledFlag4("CMS_FEATURE_EDITABLE_CONTENT_SLUG") && Record2({ _slug: String4 }).guard(object)) {
      cleanObject._slug = object._slug;
    }
    const variantsInputValidation = ContentDataWithVariantsRT.validate(object);
    if (variantsInputValidation.success && contentModel.definition.variants) {
      cleanObject._variants = {};
      contentModel.definition.variants.forEach((variant) => {
        if (variantsInputValidation.value._variants[variant.name] && cleanObject._variants) {
          cleanObject._variants[variant.name] = {
            id: variant.name
          };
        }
      });
    }
    contentModel.definition.areas.forEach((area) => {
      GraphQLGenerator.fillAreaVariables(area, cleanObject, object, throwErrorOnTypeMismatch, updateStrategy);
      if (variantsInputValidation.success && contentModel.definition.variants) {
        contentModel.definition.variants.forEach((variant) => {
          if (cleanObject._variants) {
            GraphQLGenerator.fillAreaVariables(area, cleanObject._variants[variant.name], variantsInputValidation.value._variants[variant.name], throwErrorOnTypeMismatch, updateStrategy);
          }
        });
      }
    });
    return cleanObject;
  }
  /**
   * Generates an input string (to be used in a mutation) given a Content model and an object
   * If the object has an ID, it will be included in the input so this will make it incompatible with an update mutation
   *
   * @param contentModel The content model to use to generate the input
   * @param object The object based on the contentModel
   * @returns An input string to be used as input: {} in mutations such as CreateX or UpdateY
   */
  static inputFromObject(contentModel, object) {
    let fields = "";
    if (Record2({ id: String4 }).guard(object)) {
      fields += `id: ${graphqlEscape_default(object.id)}`;
    }
    let variantsContainerString = `
    _variants: {
    `;
    const variantStrings = {};
    const variantsInputValidation = ContentDataWithVariantsRT.validate(object);
    if (variantsInputValidation.success && contentModel.definition.variants) {
      contentModel.definition.variants.forEach((variant) => {
        if (variantsInputValidation.value._variants[variant.name]) {
          variantStrings[variant.name] = `
          ${variant.name}: {
            id: ${graphqlEscape_default(variant.name)}
          `;
        }
      });
    }
    contentModel.definition.areas.forEach((area) => {
      fields += GraphQLGenerator.areaInputStringFromObject(area, object);
      if (variantsInputValidation.success && contentModel.definition.variants) {
        contentModel.definition.variants.forEach((variant) => {
          if (variantStrings[variant.name]) {
            variantStrings[variant.name] += GraphQLGenerator.areaInputStringFromObject(area, variantsInputValidation.value._variants[variant.name]);
          }
        });
      }
    });
    Object.keys(variantStrings).forEach((key) => {
      variantStrings[key] += `
      }
      `;
      variantsContainerString += variantStrings[key];
    });
    variantsContainerString += `
    }
    `;
    fields += variantsContainerString;
    return fields;
  }
};

// src/fields/RepeaterField.ts
var RepeaterReferenceResolutionStrategyGraphQLEnum = `
enum RepeaterReferenceResolutionStrategy {
  # references are fully resolved, including _referents, this is the default for versions prior to 2.0.0
  ${"COMPLETE" /* COMPLETE */}
  # references are resolved, but _referents and other system fields are skipped
  ${"SIMPLE" /* SIMPLE */}
  # references are not resolved, use this options only if you have no ImageField, GenericMedia fields or ReferenceFields in your repeater
  ${"NONE" /* NONE */}
}
`;
var InvalidRepeaterValidationExpression = class extends ValidationExpression {
  /**
   *
   */
  constructor(repeaterType) {
    super();
    this.expression = "invalid-repeater";
    this.errorMessage = "Field contains an invalid repeater instance: " + repeaterType;
    this.errorParams = new ValidationErrorMessageParameters();
  }
  /**
   *
   * @param field
   * @param value
   * @param rootType
   * @returns
   */
  eval(field, value, rootType) {
    return __async(this, null, function* () {
      return new FieldValidationResult(field, this, false, rootType);
    });
  }
};
var _repeaterInputString = (repeaters, data) => {
  let values = "";
  for (let i = 0; i < data.length; i++) {
    const obj = data[i];
    const repeaterDef = repeaters.find((v) => v.name === obj._repeaterType);
    if (repeaterDef) {
      values += `
        {
          _repeaterType: "${repeaterDef.name}",
          ${GraphQLGenerator.areaInputStringFromObject(repeaterDef, obj)}
        },
      `;
    }
  }
  return values;
};
var _repeaterInputObject = (repeaters, data, throwErrorOnTypeMismatch, updateStrategy) => {
  const values = [];
  for (let i = 0; i < data.length; i++) {
    const obj = data[i];
    const repeaterDef = repeaters.find((v) => v.name === obj._repeaterType);
    if (repeaterDef) {
      const newVal = { _repeaterType: repeaterDef.name };
      GraphQLGenerator.fillAreaVariables(repeaterDef, newVal, obj, throwErrorOnTypeMismatch, updateStrategy);
      values.push(newVal);
    }
  }
  return values;
};
var Repeater = class {
  /**
   *
   * @param content
   * @param referenceResolverCallback
   * @param excludeRequired
   * @returns
   */
  validateContent(content, referenceResolverCallback, rootType, excludeRequired) {
    return __async(this, null, function* () {
      if (isObject_default(content)) {
        const fieldsValidationPromises = this.fields.map((field) => field.validateContent(content[field.fieldName], referenceResolverCallback, rootType, excludeRequired));
        return flattenArrayDeep(yield Promise.all(fieldsValidationPromises));
      }
      return [];
    });
  }
  /**
   *
   */
  static fromJSON(json, parent) {
    const validation = RepeaterRT.validate(json);
    if (validation.success) {
      const instance = new Repeater();
      instance.name = validation.value.name;
      instance.description = validation.value.description;
      instance.icon = validation.value.icon;
      instance.fields = validation.value.fields.map((json2) => getFieldFromJSON(json2, parent));
      return instance;
    } else {
      throw new MalformedRepeaterInstanceError(json, validation.code, validation.details);
    }
  }
};
var _RepeaterField = class extends Field {
  /**
   *
   * @param content
   * @returns
   */
  contentRequiredCheck(content) {
    if (!super.contentRequiredCheck(content))
      return false;
    if (UnknownArrayRT.guard(content)) {
      return content.length > 0;
    }
    return false;
  }
  validateContent(content, referenceResolverCallback, rootType, excludeRequired) {
    return __async(this, null, function* () {
      let validations = [__superGet(_RepeaterField.prototype, this, "validateContent").call(this, content, referenceResolverCallback, rootType, excludeRequired)];
      const typeValidation = rt.Array(RepeaterInstanceInputRT).validate(content);
      if (typeValidation.success) {
        typeValidation.value.forEach((item) => {
          const repeater = this.repeaters.find((r) => r.name === item._repeaterType);
          if (repeater) {
            validations = validations.concat(repeater.validateContent(item, referenceResolverCallback, rootType, excludeRequired));
          } else {
            validations.push(new InvalidRepeaterValidationExpression(item._repeaterType).eval(this, content, rootType).then((res) => [res]));
          }
        });
      } else {
        if (!isNil_default(content)) {
          validations.push(new InvalidRepeaterValidationExpression(`${content}`).eval(this, content, rootType).then((res) => [res]));
        }
      }
      return flattenArrayDeep(yield Promise.all(validations));
    });
  }
  get graphQLArguments() {
    return "(referenceResolutionStrategy: RepeaterReferenceResolutionStrategy)";
  }
  toGraphQLType(parent = "") {
    return "[RepeaterInstance]";
  }
  getInputFragment(data) {
    const validationResult = rt.Array(RepeaterInstanceInputRT).validate(data);
    if (validationResult.success) {
      return `[
           ${_repeaterInputString(this.repeaters, validationResult.value)}
         ]`;
    }
    return "null";
  }
  formatDataForInput(data, throwErrorOnTypeMismatch, updateStrategy) {
    const validationResult = rt.Array(RepeaterInstanceInputRT).validate(data);
    if (validationResult.success) {
      return _repeaterInputObject(this.repeaters, validationResult.value, throwErrorOnTypeMismatch, updateStrategy);
    }
    if (throwErrorOnTypeMismatch && !isNil_default(data))
      throw new MalformedInputError(this, data, validationResult);
    return null;
  }
  getQueryFragment(contentModelList, params, includeReferents) {
    const foundParams = params == null ? void 0 : params.get(_RepeaterField);
    const formattedParams = foundParams && foundParams.length > 0 ? `(${foundParams.join(", ")})` : "";
    return `${this.fieldName}${formattedParams}
`;
  }
  get children() {
    let ret = [];
    this.repeaters.forEach((r) => {
      ret = ret.concat(r.fields);
    });
    return ret;
  }
  /**
   *
   */
  static getSchema() {
    return __spreadValues(__spreadValues({}, super.getSchema()), rt.Record({ repeaters: rt.Array(RepeaterRT) }).fields);
  }
  /**
   *
   * @param json
   * @param parent
   * @returns
   */
  static fromJSON(json, parent) {
    const validation = RepeaterFieldRT.validate(json);
    if (validation.success) {
      const instance = new _RepeaterField(parent);
      Field.fillFromJSON(json, instance);
      instance.repeaters = validation.value.repeaters.map((r) => Repeater.fromJSON(r, instance));
      return instance;
    } else {
      throw new MalformedFieldError(json, _RepeaterField.SCHEMA_TYPE, validation.code, validation.details);
    }
  }
};
var RepeaterField = _RepeaterField;
/**
 *
 */
RepeaterField.SCHEMA_TYPE = "Repeater";

// src/fields/RichTextField.ts
var _RichTextField = class extends TextField {
  /**
   *
   */
  static getSchema() {
    return mergeObjectAt(super.getSchema(), RichTextFieldRT.fields, "fieldRequired", true);
  }
  /**
   *
   * @param json
   * @param parent
   * @returns
   */
  static fromJSON(json, parent) {
    const validation = RichTextFieldRT.validate(json);
    if (!validation.success) {
      throw new MalformedFieldError(json, _RichTextField.SCHEMA_TYPE, validation.code, validation.details);
    }
    const instance = new _RichTextField(parent);
    instance.mode = validation.value.mode;
    TextField.fillFromJSON(json, instance);
    return instance;
  }
};
var RichTextField = _RichTextField;
/**
 *
 */
RichTextField.SCHEMA_TYPE = "RichText";

// src/fields/SelectField.ts
var _SelectField = class extends TextField {
  /**
   *
   */
  static getSchema() {
    return mergeObjectAt(super.getSchema(), SelectFieldRT.fields, "fieldRequired", true);
  }
  /**
   *
   * @param json
   * @param parent
   * @returns
   */
  static fromJSON(json, parent) {
    const validation = SelectFieldRT.validate(json);
    if (validation.success) {
      const instance = new _SelectField(parent);
      instance.selectValues = validation.value.selectValues;
      TextField.fillFromJSON(json, instance);
      return instance;
    } else {
      throw new MalformedFieldError(json, _SelectField.SCHEMA_TYPE, validation.code, validation.details);
    }
  }
};
var SelectField = _SelectField;
/**
 *
 */
SelectField.SCHEMA_TYPE = "Select";

// src/fields/URLField.ts
var import_uri_js = __toESM(require_uri_all());
var _URLField = class extends TextField {
  toGraphQLType(parent = "") {
    return "URL";
  }
  validateContent(content, referenceResolverCallback, rootType, excludeRequired) {
    return __async(this, null, function* () {
      const validations = [__superGet(_URLField.prototype, this, "validateContent").call(this, content, referenceResolverCallback, rootType, excludeRequired)];
      if (!isNil_default(content) && (typeof content !== "string" || !(0, import_uri_js.parse)(content).scheme)) {
        validations.push(new UrlInvalidValidationExpression().eval(this, content, rootType).then((err) => [err]));
      }
      return flattenArrayDeep(yield Promise.all(validations));
    });
  }
  /**
   *
   * @param json
   * @param parent
   * @returns
   */
  static fromJSON(json, parent) {
    const instance = new _URLField(parent);
    TextField.fillFromJSON(json, instance);
    return instance;
  }
};
var URLField = _URLField;
/**
 *
 */
URLField.SCHEMA_TYPE = "URL";

// src/utils/parseFieldSchema.ts
var fieldTypes = Object.values(fields_exports).reduce((acc, field) => __spreadProps(__spreadValues({}, acc), { [field.SCHEMA_TYPE]: field }), {});
function parseRuntype(key, specs, overrides) {
  const defaults = __spreadValues({ fieldType: "Text", fieldRequired: true }, overrides);
  if (key === "fieldType") {
    return __spreadProps(__spreadValues({}, defaults), {
      fieldType: "Select",
      fieldName: key,
      fieldRequired: true,
      selectValues: Object.keys(fieldTypes)
    });
  }
  if (key === "usageCount") {
    return null;
  }
  if (key === "validationExpressions") {
    return __spreadProps(__spreadValues({}, defaults), {
      fieldType: "validationExpressions",
      fieldName: key,
      fieldRequired: false
    });
  }
  if (key === "visibilityExpressions") {
    return __spreadProps(__spreadValues({}, defaults), {
      fieldType: "visibilityExpressions",
      fieldName: key,
      fieldRequired: false
    });
  }
  if (key === "referenceModelId") {
    return __spreadProps(__spreadValues({}, defaults), {
      fieldType: "referenceModelId",
      fieldName: key,
      fieldRequired: true
    });
  }
  if (!("tag" in specs)) {
    return parseRuntype(key, specs.reflect);
  }
  switch (specs.tag) {
    case "array":
      return __spreadProps(__spreadValues({}, defaults), {
        fieldType: "Array",
        fieldName: key,
        arrayValueType: parseRuntype(key, specs.element)
      });
    case "boolean":
      return __spreadProps(__spreadValues({}, defaults), {
        fieldType: "BOOL",
        fieldName: key
      });
    case "constraint":
      return parseRuntype(key, specs.underlying);
    case "number":
      return __spreadProps(__spreadValues({}, defaults), {
        fieldType: "Number",
        fieldName: key
      });
    case "optional":
      return parseRuntype(key, specs.underlying, { fieldRequired: false });
    case "record":
      return {
        parentKey: key,
        schema: specs.fields
      };
    case "string":
      return __spreadProps(__spreadValues({}, defaults), {
        fieldName: key
      });
    case "union":
      return __spreadValues(__spreadProps(__spreadValues({}, defaults), {
        fieldName: key
      }), /ACL/.test(key) ? {
        fieldType: "acl",
        selectValues: Object.values(MinimumACL).map((value) => `${aclToString_default(value)}:${value}`)
      } : {
        fieldType: "Select",
        selectValues: specs.alternatives.map((entry) => entry.tag === "literal" || entry.tag === "dictionary" ? entry.value : void 0).filter((v) => v !== void 0)
      });
    default:
      return __spreadProps(__spreadValues({}, defaults), {
        fieldName: key
      });
  }
}
function getFieldsBySchema(schema2) {
  return Object.entries(schema2).map(([key, specs]) => parseRuntype(key, specs)).filter((entry) => !!entry);
}
function getDefaultFieldValue(specs, key) {
  switch (specs.tag) {
    case "array":
      return [getDefaultFieldValue(specs.element, key)].filter((entry) => !!entry);
    case "constraint":
    case "optional":
      return getDefaultFieldValue(specs.underlying, key);
    case "record":
      return Object.entries(specs.fields).reduce((acc, [subKey, subSpecs]) => __spreadProps(__spreadValues({}, acc), {
        [subKey]: getDefaultFieldValue(subSpecs, subKey)
      }), {});
    case "union":
      if (key === "readACL") {
        return 0 /* PUBLIC */;
      } else if (key === "writeACL") {
        return 3 /* EDITOR */;
      }
      return specs.alternatives.filter((alternative) => alternative.tag === "literal" || alternative.tag === "dictionary")[0].value;
    default:
      return void 0;
  }
}
function getDefaultDataBySchema(schema2) {
  return Object.entries(schema2).reduce((acc, [key, specs]) => __spreadProps(__spreadValues({}, acc), {
    [key]: getDefaultFieldValue(specs, key)
  }), {});
}

// src/ContentModel.ts
import { getEnv as getEnv2, hasEnabledFlag as hasEnabledFlag5 } from "@monogrid/env";
import hash from "object-hash";

// src/Area.ts
var Area = class {
  /**
   *
   * @param json
   * @returns
   */
  static fromJSON(json) {
    const validation = AreaRT.validate(json);
    if (validation.success) {
      const instance = new Area();
      instance.name = validation.value.name;
      instance.fields = validation.value.fields.map((field) => getFieldFromJSON(field));
      return instance;
    } else {
      throw new MalformedAreaError(json, validation.code, validation.details);
    }
  }
};

// src/Variant.ts
var Variant = class {
  /**
   *
   * @param {Object} json
   * @returns {Variant}
   */
  static fromJSON(json) {
    const validation = VariantRT.validate(json);
    if (validation.success) {
      const variant = new Variant();
      variant.name = validation.value.name;
      variant.parent = validation.value.parent || "base";
      return variant;
    } else {
      throw new MalformedAreaError(json, validation.code, validation.details);
    }
  }
  static getBase() {
    const base = new Variant();
    base.name = BASE_VARIANT_NAME;
    return base;
  }
};

// src/ContentModelDefinition.ts
var ContentModelDefinition = class {
  /**
   *
   */
  constructor() {
    this.createACL = 3 /* EDITOR */;
    this.deleteACL = 3 /* EDITOR */;
    this.draftGetACL = 3 /* EDITOR */;
    this.draftListACL = 3 /* EDITOR */;
    this.updateACL = 3 /* EDITOR */;
    this.publishACL = 3 /* EDITOR */;
    this.unpublishACL = 3 /* EDITOR */;
    this.publishedListACL = 0 /* PUBLIC */;
    this.publishedGetACL = 0 /* PUBLIC */;
  }
  /**
   * Given content returns a string wchich can be sorted in dynamodb.
   * Valid content values are `string`, `number` and `boolean`, other types will return `undefined`
   *
   * @param index
   * @param content
   */
  extractSortFieldFromContent(index, content) {
    if (this.sortFields && this.sortFields[index]) {
      const contentSortField = content[this.sortFields[index]];
      if (typeof contentSortField === "string")
        return contentSortField;
      if (typeof contentSortField === "number")
        return floatToSortableString_default(contentSortField);
      if (typeof contentSortField === "boolean")
        return `${contentSortField}`;
    }
    return void 0;
  }
  /**
   *
   * @param json
   * @returns
   */
  static fromJSON(json) {
    const validation = ContentModelDefinitionRT.validate(json);
    if (validation.success) {
      const definition = new ContentModelDefinition();
      definition.areas = validation.value.areas.map((a) => Area.fromJSON(a));
      definition.group = validation.value.group;
      definition.label = validation.value.label;
      definition.description = validation.value.description;
      definition.previewUrl = validation.value.previewUrl;
      definition.singleton = validation.value.singleton;
      definition.sortFields = validation.value.sortFields;
      definition.statusUnmanaged = validation.value.statusUnmanaged;
      definition.slugManaged = validation.value.slugManaged;
      if (validation.value.variants) {
        definition.variants = validation.value.variants.map((v) => Variant.fromJSON(v));
      }
      definition.createACL = validation.value.createACL;
      definition.deleteACL = validation.value.deleteACL;
      definition.draftGetACL = validation.value.draftGetACL;
      definition.publishedGetACL = validation.value.publishedGetACL;
      definition.draftListACL = validation.value.draftListACL;
      definition.publishedListACL = validation.value.publishedListACL;
      definition.updateACL = validation.value.updateACL;
      definition.publishACL = validation.value.publishACL;
      definition.unpublishACL = validation.value.unpublishACL;
      return definition;
    } else {
      throw new MalformedContentModelDefinitionError(json, validation.code, validation.details);
    }
  }
};

// src/ContentModel.ts
var ContentModel2 = class {
  /**
   *
   */
  get hasVariants() {
    return !isNil_default(this.definition.variants);
  }
  /**
   *
   */
  flatten(includeNested = false) {
    const ret = [];
    this.definition.areas.forEach((area) => {
      area.fields.forEach((field) => {
        if (!includeNested) {
          ret.push(field);
        } else {
          field.traverse((f) => {
            ret.push(f);
          });
        }
      });
    });
    return ret;
  }
  /**
   *
   */
  validateContent(content, referenceResolverCallback) {
    return __async(this, null, function* () {
      if (isObject_default(content)) {
        let promises = this.flatten().map((field) => field.validateContent(content[field.fieldName], referenceResolverCallback, this.id));
        promises = flattenArrayDeep(promises);
        if (this.definition.variants) {
          this.definition.variants.forEach((variant) => {
            if ("_variants" in content && isObject_default(content._variants) && isObject_default(content._variants[variant.name])) {
              const appliedVariant = this.applyVariantsToContent(content, [variant.name]);
              const validations = this.flatten().map((field) => field.validateContent(appliedVariant[field.fieldName], referenceResolverCallback, this.id + "Variant:" + variant.name));
              promises = promises.concat(flattenArrayDeep(validations));
            }
          });
        }
        let results = [];
        let resolvedPromises;
        try {
          resolvedPromises = yield Promise.all(promises);
        } catch (e) {
          console.error(e);
          throw e;
        }
        resolvedPromises.forEach((r) => {
          results = results.concat(r);
        });
        return results;
      } else {
        throw new Error("Content is not an Object");
      }
    });
  }
  /**
   *
   * @param requestedVariants
   * @returns
   */
  getVariantsCascade(requestedVariants) {
    if (requestedVariants.length === 1 && this.definition.variants) {
      let variant = this.definition.variants.find((v) => v.name === requestedVariants[0]);
      if (variant) {
        const ret = [variant];
        while (variant && variant.parent !== BASE_VARIANT_NAME) {
          variant = this.definition.variants.find((v) => v.name === variant.parent);
          if (variant)
            ret.unshift(variant);
        }
        return [Variant.getBase()].concat(ret);
      }
      return null;
    } else {
      const ret = [];
      requestedVariants.forEach((requestedVariant) => {
        var _a;
        if (requestedVariant === BASE_VARIANT_NAME) {
          ret.push(Variant.getBase());
        } else {
          const foundVariant = (_a = this.definition.variants) == null ? void 0 : _a.find((v) => v.name === requestedVariant);
          if (foundVariant)
            ret.push(foundVariant);
        }
      });
      if (!ret.find((v) => v.name === BASE_VARIANT_NAME)) {
        ret.unshift(Variant.getBase());
      }
      return ret;
    }
  }
  /**
   *
   * @param content
   */
  assignIDToContentVariants(content) {
    if (ContentDataWithVariantsRT.guard(content) && this.definition.variants) {
      const contentVariants = content._variants;
      this.definition.variants.forEach((v) => {
        const contentVariant = contentVariants[v.name];
        if (isObject_default(contentVariant)) {
          contentVariant.id = `${content.id}/${v.name}`;
        }
      });
    }
  }
  /**
   * Given an object containing AT MINIMUM an { id: string } value
   * Returns a new object with the requested variants
   * applied
   *
   * @param content
   * @param requestedVariants
   * @param createVariantsObject forces creation of `_variants { id }` object if not present
   * @returns
   */
  applyVariantsToContent(content, requestedVariants, createVariantsObject = true) {
    const variantRequestValidation = StringArrayRT.validate(requestedVariants);
    if (
      // content model does not define variants
      !this.definition.variants || // user did not request a variant
      !variantRequestValidation.success || // user did not request a variant
      variantRequestValidation.success && variantRequestValidation.value.length === 0 || // user requested base variant (normal content)
      variantRequestValidation.success && variantRequestValidation.value.length === 1 && variantRequestValidation.value[0] === BASE_VARIANT_NAME
    ) {
      const clone2 = JSON.parse(JSON.stringify(content));
      this.assignIDToContentVariants(clone2);
      if (ContentDataWithVariantsRT.guard(clone2))
        clone2._variants.id = clone2.id;
      else if (createVariantsObject)
        clone2._variants = { id: clone2.id };
      return clone2;
    }
    const clone = JSON.parse(JSON.stringify(content));
    const cascade = this.getVariantsCascade(variantRequestValidation.value);
    let ret = {};
    if (cascade) {
      let mergeStrategy = "ASSIGN" /* ASSIGN */;
      const strategyEnv = getEnv2().CMS_FEATURE_VARIANT_STRATEGY;
      if (typeof strategyEnv === "string") {
        mergeStrategy = DeepMergeStrategy[strategyEnv || "ASSIGN"] || "ASSIGN" /* ASSIGN */;
      }
      cascade.forEach((variant) => {
        if (variant.name === BASE_VARIANT_NAME) {
          ret = deepmerge(mergeStrategy, ret, clone);
        } else {
          if (ContentDataWithVariantsRT.guard(clone)) {
            const contentVariant = clone._variants[variant.name];
            if (isObject_default(contentVariant)) {
              ret = deepmerge(mergeStrategy, ret, contentVariant);
            }
          }
        }
      });
    }
    ret.id = `${clone.id}/${variantRequestValidation.value.join("/")}`;
    this.assignIDToContentVariants(ret);
    return ret;
  }
  /**
   *
   */
  getFieldByName(name, includeNested = false) {
    return this.flatten(includeNested).find((f) => f.fieldName === name);
  }
  /**
   *
   */
  findFieldsByType(fieldType, includeNested = false) {
    return this.flatten(includeNested).filter((field) => field instanceof fieldType);
  }
  /**
   * GraphQL definition for the input required to create a content instance based on this model
   */
  getGraphQLCreateInput(fields) {
    return `
      """
        Input fields necessary to Create a ${this.id}
      """
      input ${this.id}CreateInput {
        """
          Optional ID for pre-existing contend (saved as JSON), will be automatically created if field is passed as empty
        """
        id: String,
        """
          Optional fields variants for ${this.id}.
          Variants can be used to create localization or other types of variations of a single content.

          Field Variants always have a "base variant" where values will fallback
          when a field's value for the requested variant is not found.
        """
        ${hasEnabledFlag5("CMS_FEATURE_EDITABLE_CONTENT_SLUG") ? "_slug: String" : ""}
        _variants: ${this.id}VariantsInput

        ${fields}
      }
      `;
  }
  /**
   * GraphQL definition for the input required to update a content instance based on this model
   */
  getGraphQLUpdateInput(fields) {
    return `
      """
        Input fields necessary to Update a ${this.id}
      """
      input ${this.id}UpdateInput {
        """
          Optional fields variants for ${this.id}.
          Variants can be used to create localization or other types of variations of a single content.

          Field Variants always have a "base variant" where values will fallback
          when a field's value for the requested variant is not found.
        """
        ${hasEnabledFlag5("CMS_FEATURE_EDITABLE_CONTENT_SLUG") ? "_slug: String" : ""}
        _variants: ${this.id}VariantsInput

        ${fields}
      }
      `;
  }
  /**
   * GraphQL definition for content based on this model
   */
  getGraphQLType(fields) {
    return `
      """
        Definition of ${this.id} as specified by the Content Model

        This Type has the following Access Control Policy:

        Create: ${aclToString_default(this.definition.createACL)}
        Delete: ${aclToString_default(this.definition.deleteACL)}
        Update: ${aclToString_default(this.definition.updateACL)}
        Get DRAFT: ${aclToString_default(this.definition.draftGetACL)}
        Get PUBLISHED: ${aclToString_default(this.definition.publishedGetACL)}
        List DRAFT: ${aclToString_default(this.definition.draftListACL)}
        List PUBLISHED: ${aclToString_default(this.definition.publishedListACL)}
        Publish: ${aclToString_default(this.definition.publishACL)}
        Unpublish: ${aclToString_default(this.definition.unpublishACL)}
      """
      type ${this.id} {
        """
          Unique ID of the Entry
        """
        id: ID!

        """
          Creation DateTime
        """
        _createdAt: DateTime!

        """
          Last Modification DateTime
        """
        _modifiedAt: DateTime!

        """
          Type of content, one of defined Content Models
        """
        _contentType: String!

        """
          This content is Published, it will remain published
        """
        _isPublished: Boolean!

        """
          This content has an updated version
        """
        _isUpdated: Boolean!
        """
          Originally Created by
        """
        _author: String
        """
          Last Modified by
        """
        _modifiedBy: String
        """
          Slug of the content
        """
        _slug: String
        """
          Hash of the content, to be passed as occHash parameter in mutations
        """
        _hash: String!
        """
          All Fields variants for ${this.id}.
          Variants can be used to create localization or other types of variations of a single content.

          Field Variants always have a "base variant" where values will fallback
          when a field's value for the requested variant is not found.
        """
        _variants: ${this.id}Variants
        """
          An object containing information about who references this Content and/or how many references it has
        """
        _referents: Referents

        ${fields}
      }
      `;
  }
  /**
   * Type definition for creating/updating variants for content
  */
  get graphQLVariantsInput() {
    let variantsInputString = `
    """
      Input fields necessary to Create or Update a Variants for ${this.id}
    """
    input ${this.id}VariantsInput {
      id: ID
    `;
    if (this.definition.variants) {
      this.definition.variants.forEach((variant) => {
        variantsInputString += `
        """
          Input fields necessary to Create or Update the variant ${variant.name} for ${this.id}
        """
        ${variant.name}: ${this.id}VariantInput
        `;
      });
    }
    variantsInputString += `
    }
    `;
    return variantsInputString;
  }
  /**
   * Type definition for listing variants for content
   */
  get graphQLVariantsType() {
    let variantsTypeString = `
    """
      All variants for ${this.id} with their name as key.
    """
    type ${this.id}Variants {
      id: ID
    `;
    if (this.definition.variants) {
      this.definition.variants.forEach((variant) => {
        variantsTypeString += `
        """
          A variant ${variant.name} for ${this.id}
        """
        ${variant.name}: ${this.id}Variant
        `;
      });
    }
    variantsTypeString += `
    }
    `;
    return variantsTypeString;
  }
  getGraphQLVariantType(fields) {
    return `
      """
        Definition of a possible variant for ${this.id}
      """
      type ${this.id}Variant {
        id: ID
        ${fields}
      }
      `;
  }
  getGraphQLVariantInput(fields) {
    return `
      """
        Definition of the input for a possible variant for ${this.id}
      """
      input ${this.id}VariantInput {
        """
          id for this variant
        """
        id: ID
        ${fields}
      }
      `;
  }
  get graphQLSortEnum() {
    let sortOptions = `
    """
      Possible ways to sort ${this.id}
    """
    enum ${this.id}SortOptions {
      id
      _slug
      _modifiedAt
    `;
    if (this.definition.sortFields) {
      for (let i = 0; i < Math.min(3, this.definition.sortFields.length); i++) {
        sortOptions += `
        ${this.definition.sortFields[i]}
        `;
      }
    }
    sortOptions += `
    }
    `;
    return sortOptions;
  }
  get graphQLWhereEnum() {
    let whereOptions = `
    """
      Possible ways to request ${this.id} in a Get query using the where parameter
    """
    enum ${this.id}WhereOptions {
      _modifiedAt
    `;
    if (this.definition.sortFields) {
      for (let i = 0; i < Math.min(3, this.definition.sortFields.length); i++) {
        whereOptions += `
        ${this.definition.sortFields[i]}
        `;
      }
    }
    whereOptions += `
    }
    `;
    return whereOptions;
  }
  get graphQLVariantsSelectionEnum() {
    let variants = `
    """
      Possible fields variants for ${this.id}.

      Content created with this model can have 1 or more "variants" for each of its fields.
      Variants can be used to create localization or other types of variations of a single content.

      Field Variants always have a "base variant" where values will fallback
      when a field's value for the requested variant is not found.
    """
    enum ${this.id}VariantSelection {
      base
    `;
    if (this.definition.variants) {
      for (let i = 0; i < this.definition.variants.length; i++) {
        variants += `
        ${this.definition.variants[i].name}
        `;
      }
    }
    variants += `
    }
    `;
    return variants;
  }
  get graphQLFilterFieldsEnum() {
    let filterFields = `
    """
      Possible fields where a filter can be applied to ${this.id}.
    """
    enum ${this.id}FilterFields {
      id
      _slug
      _modifiedAt
    `;
    if (this.definition.sortFields) {
      for (let i = 0; i < Math.min(3, this.definition.sortFields.length); i++) {
        filterFields += `
      ${this.definition.sortFields[i]}
      `;
      }
    }
    filterFields += `
    }
    `;
    return filterFields;
  }
  get graphQLWhereParameter() {
    return `
    input ${this.id}WhereParameter {
      field: ${this.id}WhereOptions
      value: String!
    }
    `;
  }
  get graphQLFilterOptionsInput() {
    return `
    """
      Options for filtering ${this.id}.
    """
    input ${this.id}FilterOptions {
      field: ${this.id}FilterFields
      operator: FilterOperator
      operand: String
    }`;
  }
  get graphQLListResultType() {
    return `
    """
      List result of a ${this.id} list.
    """
    type List${this.id}Result {
      """
        Id of this result
      """
      id: ID!
      """
        List of ${this.id} items
      """
      items: [${this.id}]!
      """
        Cursor, pass this as parameter to List${this.id} in order to advance pagination, null if there is no next page.
      """
      cursor: String
      """
        Total count of type ${this.id} in storage, with no limits.
      """
      totalCount: Int!
    }
    `;
  }
  get graphQLQuery() {
    return `
    extend type Query {
      """
        Lists all ${this.id}.
        Status is PUBLISHED by default if no explicit status is specified.
        Variant is "base" by default if no explicit variant cascade is specified.
      """
      List${this.id}(status: ContentStatus, sortOn: ${this.id}SortOptions, descending: Boolean, limit: Int, cursor: String, filter: ${this.id}FilterOptions, variants: [${this.id}VariantSelection]): List${this.id}Result
      """
        Gets specified ${this.id} using either slug or id (one of the two erguments must be passed).
        Status is PUBLISHED by default if no explicit status is specified.
        Variant is "base" by default if no explicit variant cascade is specified.
      """
      Get${this.id}(slug:String, id: String, status: ContentStatus, variants: [${this.id}VariantSelection], where: ${this.id}WhereParameter): ${this.id}
    }
    `;
  }
  get graphQLMutations() {
    let mutations = "extend type Mutation {";
    if (this.definition.createACL < 5 /* NOONE */) {
      mutations += `
      """
        Creates a new ${this.id}.

        Status of the content will be set to DRAFT
      """
      Create${this.id}(input: ${this.id}CreateInput!): ${this.id}
      `;
    }
    if (this.definition.updateACL < 5 /* NOONE */) {
      mutations += `
      """
        Updates a ${this.id}.

        Status of the content will be set to DRAFT.

        UpdateStrategy (default REPLACE) specifies the update strategy will be used. REPLACE will completely replace the content with the new one, MERGE will merge the new values with the old ones and ASSIGN will replace the old values with the new ones
      """
      Update${this.id}(id: String!, input: ${this.id}UpdateInput!, updateStrategy: UpdateStrategy, occHash: String): ${this.id}
      `;
    }
    if (this.definition.deleteACL < 5 /* NOONE */) {
      mutations += `
      """
        Deletes a ${this.id}.
      """
      Delete${this.id}(id: String!, occHash: String): ${this.id}
      `;
    }
    if (this.definition.publishACL < 5 /* NOONE */) {
      mutations += `
      """
        Publishes a ${this.id}.
      """
      Publish${this.id}(id: String!, occHash: String): ${this.id}
      `;
    }
    if (this.definition.unpublishACL < 5 /* NOONE */) {
      mutations += `
      """
        Unpublishes a ${this.id}.
      """
      Unpublish${this.id}(id: String!, occHash: String): ${this.id}
      `;
    }
    mutations += `
  }
  `;
    return mutations;
  }
  addFieldToType(field, rootType, ignoreRequired) {
    const required = !ignoreRequired && field.fieldRequired ? "!" : "";
    const fieldArguments = field.graphQLArguments;
    return `
      """
        ${field.fieldPlaceholder}
        ${field.validationExpressions && field.validationExpressions.length > 0 ? field.validationExpressions.map((ve) => ve.toString()).join("\n") : ""}
      """
      ${field.fieldName}${fieldArguments}: ${field.toGraphQLType(rootType)}${required},
    `;
  }
  addFieldToCreateInputType(field, rootType) {
    return `
      """
        ${field.fieldPlaceholder}

        ${field.validationExpressions && field.validationExpressions.length > 0 ? field.validationExpressions.map((ve) => ve.toString()).join("\n") : ""}
        """
        ${field.fieldName}: ${field.toGraphQLCreateInputType(rootType)}${field.fieldRequired ? "!" : ""}
        `;
  }
  addFieldToUpdateInputType(field, rootType) {
    return `
        """
        ${field.fieldPlaceholder}

        ${field.validationExpressions && field.validationExpressions.length > 0 ? field.validationExpressions.map((ve) => ve.toString()).join("\n") : ""}
      """
      ${field.fieldName}: ${field.toGraphQLUpdateInputType(rootType)}
    `;
  }
  /**
   *
   * @param param0
   * @returns
   */
  getGraphQLSchema({ gql }) {
    let rootTypes = "";
    let typeFields = "";
    let createInputFields = "";
    let updateInputFields = "";
    let variantTypeFields = "";
    let variantInputFields = "";
    const fields = this.flatten();
    fields.forEach((field) => {
      field.traverse((f) => {
        const field2 = f;
        if (field2.producesGraphQLRootTypes) {
          rootTypes += field2.getGraphQLRootTypes(this.id);
          rootTypes += field2.getGraphQLRootTypes(this.id + "Variant", true);
        }
      });
      typeFields += this.addFieldToType(field, this.id);
      createInputFields += this.addFieldToCreateInputType(field, this.id);
      updateInputFields += this.addFieldToUpdateInputType(field, this.id);
      variantTypeFields += this.addFieldToType(field, this.id + "Variant", true);
      variantInputFields += this.addFieldToUpdateInputType(field, this.id + "Variant");
    });
    if (this.id === MEDIA_FILE_CONTENT_MODEL_ID) {
      typeFields += `
        """
          An object containing information for how to upload the image using a multipart post upload.
          Requester must have appropriate MediaFile create access level
        """
        uploadSignedRequest: JSON
      `;
    }
    const graphQLType = this.getGraphQLType(typeFields);
    const graphQLCreateInput = this.getGraphQLCreateInput(createInputFields);
    const graphQLUpdateInput = this.getGraphQLUpdateInput(updateInputFields);
    const graphQLVariantType = this.getGraphQLVariantType(variantTypeFields);
    const graphQLVariantInput = this.getGraphQLVariantInput(variantInputFields);
    return gql(
      rootTypes + this.graphQLVariantsInput + this.graphQLVariantsType + graphQLType + graphQLCreateInput + graphQLUpdateInput + graphQLVariantType + graphQLVariantInput + this.graphQLSortEnum + this.graphQLWhereEnum + this.graphQLVariantsSelectionEnum + this.graphQLFilterFieldsEnum + this.graphQLWhereParameter + this.graphQLFilterOptionsInput + this.graphQLListResultType + this.graphQLQuery + this.graphQLMutations
    );
  }
  static fromJSON(json) {
    const validation = ContentModelRT.validate(json);
    if (validation.success) {
      const contentModel = new ContentModel2();
      contentModel.id = validation.value.id;
      contentModel._author = validation.value._author;
      contentModel._modifiedBy = validation.value._modifiedBy;
      contentModel._createdAt = validation.value._createdAt !== void 0 ? new Date(validation.value._createdAt) : /* @__PURE__ */ new Date();
      contentModel._modifiedAt = validation.value._modifiedAt !== void 0 ? new Date(validation.value._modifiedAt) : /* @__PURE__ */ new Date();
      if (validation.value.definition instanceof ContentModelDefinition) {
        contentModel.definition = validation.value.definition;
      } else {
        contentModel.definition = ContentModelDefinition.fromJSON(validation.value.definition);
      }
      contentModel._hash = hash(contentModel);
      return contentModel;
    } else {
      throw new MalformedContentModelError(json, validation.code, validation.details);
    }
  }
};

// src/Automation.ts
import { getEnv as getEnv3 } from "@monogrid/env";

// src/AutomationDefinition.ts
var AutomationDefinition = class {
  /**
   *
   * @param json
   * @returns
   */
  static fromJSON(json) {
    const validation = AutomationDefinitionRT.validate(json);
    if (validation.success) {
      const definition = new AutomationDefinition();
      definition.action = validation.value.action;
      definition.target = validation.value.target;
      definition.targetType = validation.value.targetType;
      return definition;
    } else {
      throw new MalformedAutomationDefinitionError(json, validation.code, validation.details);
    }
  }
};

// src/Automation.ts
var getAutomationBotUser = () => {
  var _a;
  return {
    email: "automation-bot@mono-grid.com",
    enabled: true,
    groups: [((_a = getEnv3()) == null ? void 0 : _a.EDITORS_GROUP_NAME) || "Editors"]
  };
};
var Automation = class {
  /**
   *
   */
  static validate(data) {
    if (!isObject_default(data))
      throw new Error("data is not an Object");
    try {
      const definition = AutomationDefinition.fromJSON(data);
      return {
        success: !!definition,
        definition
      };
    } catch (e) {
      return {
        success: false,
        message: e
      };
    }
  }
  static fromJSON(json) {
    const validation = AutomationRT.validate(json);
    if (validation.success) {
      const automation = new Automation();
      automation.id = validation.value.id;
      automation.automationStatus = validation.value.automationStatus;
      automation.automationExecutionTime = new Date(validation.value.automationExecutionTime);
      automation.statusMessage = validation.value.statusMessage;
      automation._author = validation.value._author;
      automation._modifiedBy = validation.value._modifiedBy;
      automation._createdAt = validation.value._createdAt !== void 0 ? new Date(validation.value._createdAt) : /* @__PURE__ */ new Date();
      automation._modifiedAt = validation.value._modifiedAt !== void 0 ? new Date(validation.value._modifiedAt) : /* @__PURE__ */ new Date();
      if (validation.value.definition instanceof AutomationDefinition) {
        automation.definition = validation.value.definition;
      } else {
        automation.definition = AutomationDefinition.fromJSON(validation.value.definition);
      }
      return automation;
    } else {
      throw new MalformedAutomationError(json, validation.code, validation.details);
    }
  }
};

// src/DefaultUserDefinition.ts
var DefaultUserDefinition_default = {
  sortFields: [],
  statusUnmanaged: true,
  createACL: 4 /* ADMIN */,
  deleteACL: 4 /* ADMIN */,
  draftGetACL: 5 /* NOONE */,
  publishedGetACL: 2 /* CREATOR */,
  draftListACL: 5 /* NOONE */,
  publishedListACL: 3 /* EDITOR */,
  updateACL: 2 /* CREATOR */,
  publishACL: 5 /* NOONE */,
  unpublishACL: 5 /* NOONE */,
  areas: [
    {
      name: "System",
      fields: [
        {
          fieldType: TitleField.SCHEMA_TYPE,
          fieldName: "email",
          fieldDescription: "Email used to register the User",
          fieldPlaceholder: "example@mono-grid.com",
          fieldLabel: "Email",
          useAsSlug: true,
          fieldRequired: true,
          readACL: 0 /* PUBLIC */,
          writeACL: 2 /* CREATOR */
        },
        {
          fieldType: BoolField.SCHEMA_TYPE,
          fieldName: "enabled",
          fieldDescription: "Setting this to false will disable user from login and query, effective immediately",
          fieldPlaceholder: "",
          fieldLabel: "Enabled",
          fieldRequired: false,
          fieldExcludedFromLists: false,
          validationExpressions: [],
          readACL: 2 /* CREATOR */,
          writeACL: 4 /* ADMIN */
        },
        {
          fieldType: BoolField.SCHEMA_TYPE,
          fieldName: "disableInvitationEmail",
          fieldDescription: "Setting this to true will disable the invitation email",
          fieldPlaceholder: "",
          fieldLabel: "Disable invitation email",
          fieldRequired: false,
          fieldExcludedFromLists: false,
          validationExpressions: [],
          readACL: 2 /* CREATOR */,
          writeACL: 4 /* ADMIN */
        },
        {
          fieldType: SelectField.SCHEMA_TYPE,
          fieldName: "userStatus",
          fieldDescription: "User Status in Cognito User Pool, can only be viewed",
          fieldPlaceholder: "",
          fieldLabel: "User Status",
          fieldRequired: false,
          selectValues: [
            "UNCONFIRMED",
            "CONFIRMED",
            "EXTERNAL_PROVIDER",
            "ARCHIVED",
            "COMPROMISED",
            "UNKNOWN",
            "RESET_REQUIRED",
            "FORCE_CHANGE_PASSWORD"
          ],
          readACL: 4 /* ADMIN */,
          writeACL: 5 /* NOONE */
        },
        {
          fieldType: BoolField.SCHEMA_TYPE,
          fieldName: "emailVerified",
          fieldDescription: "Email of this user is verified, can only be viewed",
          fieldPlaceholder: "",
          fieldLabel: "Email Verified",
          fieldRequired: false,
          fieldExcludedFromLists: false,
          validationExpressions: [],
          readACL: 4 /* ADMIN */,
          writeACL: 5 /* NOONE */
        },
        {
          fieldType: ArrayField.SCHEMA_TYPE,
          fieldName: "groups",
          fieldDescription: "Add or remove User from Groups to grant access to Admin Capabilities. IMPORTANT: Changing this requires the user to sign out and then sign in again",
          fieldPlaceholder: "",
          fieldLabel: "User Groups",
          fieldRequired: false,
          readACL: 2 /* CREATOR */,
          writeACL: 4 /* ADMIN */,
          arrayValueType: {
            fieldType: SelectField.SCHEMA_TYPE,
            selectValues: [
              "Admins",
              "Editors"
            ],
            fieldName: "group",
            fieldDescription: "The group which can be assigned",
            fieldPlaceholder: "",
            fieldLabel: "Group",
            fieldRequired: false,
            fieldExcludedFromLists: false,
            validationExpressions: [],
            readACL: 2 /* CREATOR */,
            writeACL: 4 /* ADMIN */
          }
        }
      ]
    },
    {
      name: "Signup",
      fields: []
    }
  ]
};

// src/DefaultSettings.ts
var DefaultSettings_default = {
  adminCreateEmailMessage: {
    subject: "Invitation to https://{{env.SERVICE_TARGET_DOMAIN}}/{{env.ADMIN_INTERFACE_PATH}}",
    body: `
<mjml>
  <mj-head>
    <mj-font name="Titillium Web" href="https://fonts.googleapis.com/css2?family=Titillium+Web"></mj-font>
    <mj-attributes>
      <mj-class name="body-1" color="#000000" font-size="16px" font-family="Titillium Web, sans-serif" line-height="24px"/>
      <mj-class name="caption" color="#000000" font-size="12px" font-family="Titillium Web, sans-serif" line-height="18px"/>
      <mj-class name="divider" color="#000000" border-width="1px"/>
    </mj-attributes>
  </mj-head>
  <mj-body>
    <mj-section text-align="center">
      <mj-column >
       <mj-image width="150px" src="https://monogrid-deliveries.s3.eu-central-1.amazonaws.com/public-assets/cms-logo.png"></mj-image>
       <mj-divider mj-class="divider"></mj-divider>
       <mj-text align="center" mj-class="body-1">You have been invited to <b>{{env.SERVICE_NAME}} ({{env.SERVICE_STAGE}})</b></mj-text>
       <mj-button border-radius="8px" mj-class="body-1" background-color="#3161f6" color="white" href="https://{{env.SERVICE_TARGET_DOMAIN}}/{{env.ADMIN_INTERFACE_PATH}}/#/login/{username}/{####}">Click here to login</mj-button>
       <mj-text align="center" mj-class="body-1">You will be asked to change the temporary password we have assigned you (<b>{####}</b>) with a new password of your choosing.</mj-text>
       <mj-text align="center" mj-class="body-1">This invitation will expire in <b>7 days</b>. If you do not login and change your password by then, ask the administrator to send a new invitation.</mj-text>
       <mj-text align="center" mj-class="caption">If you did not request an invitation or you believe you were invited by mistake, please let us know at <a href="mailto:hello@mono-grid.com">hello@mono-grid.com</a> </mj-text>
       <mj-divider mj-class="divider"></mj-divider>
       <mj-text align="center" mj-class="caption">If you are having trouble clicking the button, copy and paste the url below into your browser and use this email <b>{username}</b> and this password <b>{####}</b> when asked.</mj-text>
       <mj-text align="center" mj-class="caption">https://{{env.SERVICE_TARGET_DOMAIN}}/{{env.ADMIN_INTERFACE_PATH}}/</mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`
  },
  adminCreateSmsMessage: "UNUSED Welcome to the service. Your username is {username} and temporary password is {####}.",
  signupEmailMessage: {
    subject: "Welcome to https://{{env.SERVICE_TARGET_DOMAIN}}/{{env.ADMIN_INTERFACE_PATH}}",
    body: `
<mjml>
  <mj-head>
    <mj-font name="Titillium Web" href="https://fonts.googleapis.com/css2?family=Titillium+Web"></mj-font>
    <mj-attributes>
      <mj-class name="body-1" color="#000000" font-size="16px" font-family="Titillium Web, sans-serif" line-height="24px"/>
      <mj-class name="caption" color="#000000" font-size="12px" font-family="Titillium Web, sans-serif" line-height="18px"/>
      <mj-class name="divider" color="#000000" border-width="1px"/>
    </mj-attributes>
  </mj-head>
  <mj-body>
    <mj-section>
      <mj-column>
       <mj-image width="150px" src="https://monogrid-deliveries.s3.eu-central-1.amazonaws.com/public-assets/cms-logo.png"></mj-image>
       <mj-divider mj-class="divider"></mj-divider>
       <mj-text align="center" mj-class="body-1">Welcome to <b>{{env.SERVICE_NAME}} ({{env.SERVICE_STAGE}})</b>, you need to verify your email before accessing.</mj-text>
       <mj-button border-radius="8px" mj-class="body-1" background-color="#3161f6" color="white" href="https://{{env.SERVICE_TARGET_DOMAIN}}/{{env.ADMIN_INTERFACE_PATH}}/#/verify/{{attrs.email}}/{####}">Verify your email</mj-button>
       <mj-divider mj-class="divider"></mj-divider>
       <mj-text align="center" mj-class="caption">If you are having trouble clicking the button, copy and paste the url below into your browser and use this email <b>{{attrs.email}}</b> and this code <b>{####}</b> when asked.</mj-text>
       <mj-text align="center" mj-class="caption">https://{{env.SERVICE_TARGET_DOMAIN}}/{{env.ADMIN_INTERFACE_PATH}}/#/verify/</mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`
  },
  signupSmsMessage: "UNUSED Welcome to the service. {####} is your verification code.",
  postConfirmationEmailMessage: null,
  forgotPasswordEmailMessage: {
    subject: "Password Reset for https://{{env.SERVICE_TARGET_DOMAIN}}/{{env.ADMIN_INTERFACE_PATH}}",
    body: `
<mjml>
  <mj-head>
    <mj-font name="Titillium Web" href="https://fonts.googleapis.com/css2?family=Titillium+Web"></mj-font>
    <mj-attributes>
      <mj-class name="body-1" color="#000000" font-size="16px" font-family="Titillium Web, sans-serif" line-height="24px"/>
      <mj-class name="caption" color="#000000" font-size="12px" font-family="Titillium Web, sans-serif" line-height="18px"/>
      <mj-class name="divider" color="#000000" border-width="1px"/>
    </mj-attributes>
  </mj-head>
  <mj-body>
    <mj-section>
      <mj-column>
       <mj-image width="150px" src="https://monogrid-deliveries.s3.eu-central-1.amazonaws.com/public-assets/cms-logo.png"></mj-image>
       <mj-divider mj-class="divider"></mj-divider>
       <mj-text align="center" mj-class="body-1">A request has been received to reset the password for your account at <b>{{env.SERVICE_NAME}} ({{env.SERVICE_STAGE}})</b>.</mj-text>
        <mj-button border-radius="8px" mj-class="body-1" background-color="#3161f6" color="white" href="https://{{env.SERVICE_TARGET_DOMAIN}}/{{env.ADMIN_INTERFACE_PATH}}/#/password-reset/{{attrs.email}}/{####}">Reset your password</mj-button>
       <mj-text align="center"mj-class="body-1">If you did not request a password reset, please ignore this email.</mj-text>
       <mj-divider mj-class="divider"></mj-divider>
       <mj-text align="center" mj-class="caption">If you are having trouble clicking the password reset button, copy and paste the url below into your browser and use this code <b>{####}</b> when asked.</mj-text>
       <mj-text align="center" mj-class="caption">https://{{env.SERVICE_TARGET_DOMAIN}}/{{env.ADMIN_INTERFACE_PATH}}/#/password-reset/</mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`
  },
  magicLinkEmailMessage: {
    subject: "Login link for https://{{env.SERVICE_TARGET_DOMAIN}}/{{env.ADMIN_INTERFACE_PATH}}",
    body: `
<mjml>
  <mj-head>
    <mj-font name="Titillium Web" href="https://fonts.googleapis.com/css2?family=Titillium+Web"></mj-font>
    <mj-attributes>
      <mj-class name="body-1" color="#000000" font-size="16px" font-family="Titillium Web, sans-serif" line-height="24px"/>
      <mj-class name="caption" color="#000000" font-size="12px" font-family="Titillium Web, sans-serif" line-height="18px"/>
      <mj-class name="divider" color="#000000" border-width="1px"/>
    </mj-attributes>
  </mj-head>
  <mj-body>
    <mj-section text-align="center">
      <mj-column >
        <mj-image width="150px" src="https://monogrid-deliveries.s3.eu-central-1.amazonaws.com/public-assets/cms-logo.png"></mj-image>
        <mj-divider mj-class="divider"></mj-divider>
        <mj-text align="center" mj-class="body-1">A request has been received to create a login link for your account at <b>{{env.SERVICE_NAME}} ({{env.SERVICE_STAGE}})</b></mj-text>
        <mj-button border-radius="8px" mj-class="body-1" background-color="#3161f6" color="white" href="https://{{env.SERVICE_TARGET_DOMAIN}}/{{env.ADMIN_INTERFACE_PATH}}/#/magic-link/{email}/{####}">Click here to login</mj-button>
        <mj-text align="center" mj-class="body-1">This link will expire in <b>{minutes} minutes</b>.</mj-text>
        <mj-text align="center" mj-class="caption">If you did not request a login link or you believe you were invited by mistake, please let us know at <a href="mailto:hello@mono-grid.com">hello@mono-grid.com</a> </mj-text>
        <mj-divider mj-class="divider"></mj-divider>
        <mj-text align="center" mj-class="caption">If you are having trouble clicking the button, copy and paste the url below into your browser and use this email <b>{email}</b> and this code <b>{####}</b> when asked.</mj-text>
        <mj-text align="center" mj-class="caption">https://{{env.SERVICE_TARGET_DOMAIN}}/{{env.ADMIN_INTERFACE_PATH}}/#/magic-link</mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`
  }
};

// src/DefaultMediaFileDefinition.ts
var DefaultMediaFileDefinition_default = {
  sortFields: [
    "fileSize",
    "mimeType"
  ],
  statusUnmanaged: true,
  createACL: 3 /* EDITOR */,
  deleteACL: 3 /* EDITOR */,
  draftGetACL: 5 /* NOONE */,
  publishedGetACL: 0 /* PUBLIC */,
  draftListACL: 5 /* NOONE */,
  publishedListACL: 0 /* PUBLIC */,
  updateACL: 5 /* NOONE */,
  publishACL: 5 /* NOONE */,
  unpublishACL: 5 /* NOONE */,
  areas: [
    {
      name: "System",
      fields: [
        {
          fieldType: TitleField.SCHEMA_TYPE,
          fieldName: "originalName",
          fieldDescription: "The original name of the file",
          fieldPlaceholder: "example.jpg",
          fieldLabel: "Original Name",
          useAsSlug: true,
          fieldRequired: true,
          readACL: 0 /* PUBLIC */,
          writeACL: 3 /* EDITOR */
        },
        {
          fieldType: NumberField.SCHEMA_TYPE,
          fieldName: "fileSize",
          fieldDescription: "The size (in bytes) of the file",
          fieldPlaceholder: "",
          fieldLabel: "File Size",
          fieldRequired: true,
          fieldExcludedFromLists: false,
          validationExpressions: [],
          readACL: 0 /* PUBLIC */,
          writeACL: 3 /* EDITOR */
        },
        {
          fieldType: TextField.SCHEMA_TYPE,
          fieldName: "mimeType",
          fieldDescription: "The type of file",
          fieldPlaceholder: "",
          fieldLabel: "Mimetype",
          fieldRequired: true,
          fieldExcludedFromLists: false,
          validationExpressions: [],
          readACL: 0 /* PUBLIC */,
          writeACL: 3 /* EDITOR */
        },
        {
          fieldType: JSONField.SCHEMA_TYPE,
          fieldName: "metaData",
          fieldDescription: "Additional Metadata, generated at the moment of creation",
          fieldPlaceholder: "",
          fieldLabel: "Metadata",
          fieldRequired: false,
          fieldExcludedFromLists: false,
          validationExpressions: [],
          readACL: 0 /* PUBLIC */,
          writeACL: 3 /* EDITOR */
        },
        {
          fieldType: BoolField.SCHEMA_TYPE,
          fieldName: "isUploaded",
          fieldDescription: "This is an indication if the file is actually present on S3",
          fieldPlaceholder: "",
          fieldLabel: "Uploaded to S3",
          fieldRequired: false,
          fieldExcludedFromLists: false,
          validationExpressions: [],
          readACL: 3 /* EDITOR */,
          writeACL: 5 /* NOONE */
        }
      ]
    }
  ]
};

// src/validation/validationRules.ts
var validationRules_exports = {};
__export(validationRules_exports, {
  arrayValidation: () => arrayValidation,
  boolValueValidation: () => boolValueValidation,
  dateValidation: () => dateValidation,
  errorMessages: () => errorMessages,
  getValidations: () => getValidations,
  imageValidation: () => imageValidation,
  jexlRule: () => jexlRule,
  mediaValidation: () => mediaValidation,
  numberValidation: () => numberValidation,
  stringValidation: () => stringValidation,
  stringValueValidation: () => stringValueValidation
});
var import_uri_js2 = __toESM(require_uri_all());
import jexl3 from "jexl";

// src/validation/mime-types.json
var mime_types_default = {
  ez: "application/andrew-inset",
  aw: "application/applixware",
  atom: "application/atom+xml",
  atomcat: "application/atomcat+xml",
  atomsvc: "application/atomsvc+xml",
  ccxml: "application/ccxml+xml",
  cdmia: "application/cdmi-capability",
  cdmic: "application/cdmi-container",
  cdmid: "application/cdmi-domain",
  cdmio: "application/cdmi-object",
  cdmiq: "application/cdmi-queue",
  cu: "application/cu-seeme",
  davmount: "application/davmount+xml",
  dbk: "application/docbook+xml",
  dssc: "application/dssc+der",
  xdssc: "application/dssc+xml",
  ecma: "application/ecmascript",
  emma: "application/emma+xml",
  epub: "application/epub+zip",
  exi: "application/exi",
  pfr: "application/font-tdpfr",
  gml: "application/gml+xml",
  gpx: "application/gpx+xml",
  gxf: "application/gxf",
  stk: "application/hyperstudio",
  ink: "application/inkml+xml",
  inkml: "application/inkml+xml",
  ipfix: "application/ipfix",
  jar: "application/java-archive",
  ser: "application/java-serialized-object",
  class: "application/java-vm",
  js: "application/javascript",
  json: "application/json",
  jsonml: "application/jsonml+json",
  lostxml: "application/lost+xml",
  hqx: "application/mac-binhex40",
  cpt: "application/mac-compactpro",
  mads: "application/mads+xml",
  mrc: "application/marc",
  mrcx: "application/marcxml+xml",
  ma: "application/mathematica",
  nb: "application/mathematica",
  mb: "application/mathematica",
  mathml: "application/mathml+xml",
  mbox: "application/mbox",
  mscml: "application/mediaservercontrol+xml",
  metalink: "application/metalink+xml",
  meta4: "application/metalink4+xml",
  mets: "application/mets+xml",
  mods: "application/mods+xml",
  m21: "application/mp21",
  mp21: "application/mp21",
  mp4s: "application/mp4",
  doc: "application/msword",
  dot: "application/msword",
  mxf: "application/mxf",
  bin: "application/octet-stream",
  dms: "application/octet-stream",
  lrf: "application/octet-stream",
  mar: "application/octet-stream",
  so: "application/octet-stream",
  dist: "application/octet-stream",
  distz: "application/octet-stream",
  pkg: "application/octet-stream",
  bpk: "application/octet-stream",
  dump: "application/octet-stream",
  elc: "application/octet-stream",
  deploy: "application/octet-stream",
  oda: "application/oda",
  opf: "application/oebps-package+xml",
  ogx: "application/ogg",
  omdoc: "application/omdoc+xml",
  onetoc: "application/onenote",
  onetoc2: "application/onenote",
  onetmp: "application/onenote",
  onepkg: "application/onenote",
  oxps: "application/oxps",
  xer: "application/patch-ops-error+xml",
  pdf: "application/pdf",
  pgp: "application/pgp-encrypted",
  asc: "application/pgp-signature",
  sig: "application/pgp-signature",
  prf: "application/pics-rules",
  p10: "application/pkcs10",
  p7m: "application/pkcs7-mime",
  p7c: "application/pkcs7-mime",
  p7s: "application/pkcs7-signature",
  p8: "application/pkcs8",
  ac: "application/pkix-attr-cert",
  cer: "application/pkix-cert",
  crl: "application/pkix-crl",
  pkipath: "application/pkix-pkipath",
  pki: "application/pkixcmp",
  pls: "application/pls+xml",
  ai: "application/postscript",
  eps: "application/postscript",
  ps: "application/postscript",
  cww: "application/prs.cww",
  pskcxml: "application/pskc+xml",
  rdf: "application/rdf+xml",
  rif: "application/reginfo+xml",
  rnc: "application/relax-ng-compact-syntax",
  rl: "application/resource-lists+xml",
  rld: "application/resource-lists-diff+xml",
  rs: "application/rls-services+xml",
  gbr: "application/rpki-ghostbusters",
  mft: "application/rpki-manifest",
  roa: "application/rpki-roa",
  rsd: "application/rsd+xml",
  rss: "application/rss+xml",
  rtf: "application/rtf",
  sbml: "application/sbml+xml",
  scq: "application/scvp-cv-request",
  scs: "application/scvp-cv-response",
  spq: "application/scvp-vp-request",
  spp: "application/scvp-vp-response",
  sdp: "application/sdp",
  setpay: "application/set-payment-initiation",
  setreg: "application/set-registration-initiation",
  shf: "application/shf+xml",
  smi: "application/smil+xml",
  smil: "application/smil+xml",
  rq: "application/sparql-query",
  srx: "application/sparql-results+xml",
  gram: "application/srgs",
  grxml: "application/srgs+xml",
  sru: "application/sru+xml",
  ssdl: "application/ssdl+xml",
  ssml: "application/ssml+xml",
  tei: "application/tei+xml",
  teicorpus: "application/tei+xml",
  tfi: "application/thraud+xml",
  tsd: "application/timestamped-data",
  plb: "application/vnd.3gpp.pic-bw-large",
  psb: "application/vnd.3gpp.pic-bw-small",
  pvb: "application/vnd.3gpp.pic-bw-var",
  tcap: "application/vnd.3gpp2.tcap",
  pwn: "application/vnd.3m.post-it-notes",
  aso: "application/vnd.accpac.simply.aso",
  imp: "application/vnd.accpac.simply.imp",
  acu: "application/vnd.acucobol",
  atc: "application/vnd.acucorp",
  acutc: "application/vnd.acucorp",
  air: "application/vnd.adobe.air-application-installer-package+zip",
  fcdt: "application/vnd.adobe.formscentral.fcdt",
  fxp: "application/vnd.adobe.fxp",
  fxpl: "application/vnd.adobe.fxp",
  xdp: "application/vnd.adobe.xdp+xml",
  xfdf: "application/vnd.adobe.xfdf",
  ahead: "application/vnd.ahead.space",
  azf: "application/vnd.airzip.filesecure.azf",
  azs: "application/vnd.airzip.filesecure.azs",
  azw: "application/vnd.amazon.ebook",
  acc: "application/vnd.americandynamics.acc",
  ami: "application/vnd.amiga.ami",
  apk: "application/vnd.android.package-archive",
  cii: "application/vnd.anser-web-certificate-issue-initiation",
  fti: "application/vnd.anser-web-funds-transfer-initiation",
  atx: "application/vnd.antix.game-component",
  mpkg: "application/vnd.apple.installer+xml",
  m3u8: "application/vnd.apple.mpegurl",
  swi: "application/vnd.aristanetworks.swi",
  iota: "application/vnd.astraea-software.iota",
  aep: "application/vnd.audiograph",
  mpm: "application/vnd.blueice.multipass",
  bmi: "application/vnd.bmi",
  rep: "application/vnd.businessobjects",
  cdxml: "application/vnd.chemdraw+xml",
  mmd: "application/vnd.chipnuts.karaoke-mmd",
  cdy: "application/vnd.cinderella",
  cla: "application/vnd.claymore",
  rp9: "application/vnd.cloanto.rp9",
  c4g: "application/vnd.clonk.c4group",
  c4d: "application/vnd.clonk.c4group",
  c4f: "application/vnd.clonk.c4group",
  c4p: "application/vnd.clonk.c4group",
  c4u: "application/vnd.clonk.c4group",
  c11amc: "application/vnd.cluetrust.cartomobile-config",
  c11amz: "application/vnd.cluetrust.cartomobile-config-pkg",
  csp: "application/vnd.commonspace",
  cdbcmsg: "application/vnd.contact.cmsg",
  cmc: "application/vnd.cosmocaller",
  clkx: "application/vnd.crick.clicker",
  clkk: "application/vnd.crick.clicker.keyboard",
  clkp: "application/vnd.crick.clicker.palette",
  clkt: "application/vnd.crick.clicker.template",
  clkw: "application/vnd.crick.clicker.wordbank",
  wbs: "application/vnd.criticaltools.wbs+xml",
  pml: "application/vnd.ctc-posml",
  ppd: "application/vnd.cups-ppd",
  car: "application/vnd.curl.car",
  pcurl: "application/vnd.curl.pcurl",
  dart: "application/vnd.dart",
  rdz: "application/vnd.data-vision.rdz",
  uvf: "application/vnd.dece.data",
  uvvf: "application/vnd.dece.data",
  uvd: "application/vnd.dece.data",
  uvvd: "application/vnd.dece.data",
  uvt: "application/vnd.dece.ttml+xml",
  uvvt: "application/vnd.dece.ttml+xml",
  uvx: "application/vnd.dece.unspecified",
  uvvx: "application/vnd.dece.unspecified",
  uvz: "application/vnd.dece.zip",
  uvvz: "application/vnd.dece.zip",
  fe_launch: "application/vnd.denovo.fcselayout-link",
  dna: "application/vnd.dna",
  mlp: "application/vnd.dolby.mlp",
  dpg: "application/vnd.dpgraph",
  dfac: "application/vnd.dreamfactory",
  kpxx: "application/vnd.ds-keypoint",
  ait: "application/vnd.dvb.ait",
  svc: "application/vnd.dvb.service",
  geo: "application/vnd.dynageo",
  mag: "application/vnd.ecowin.chart",
  nml: "application/vnd.enliven",
  esf: "application/vnd.epson.esf",
  msf: "application/vnd.epson.msf",
  qam: "application/vnd.epson.quickanime",
  slt: "application/vnd.epson.salt",
  ssf: "application/vnd.epson.ssf",
  es3: "application/vnd.eszigno3+xml",
  et3: "application/vnd.eszigno3+xml",
  ez2: "application/vnd.ezpix-album",
  ez3: "application/vnd.ezpix-package",
  fdf: "application/vnd.fdf",
  mseed: "application/vnd.fdsn.mseed",
  seed: "application/vnd.fdsn.seed",
  dataless: "application/vnd.fdsn.seed",
  gph: "application/vnd.flographit",
  ftc: "application/vnd.fluxtime.clip",
  fm: "application/vnd.framemaker",
  frame: "application/vnd.framemaker",
  maker: "application/vnd.framemaker",
  book: "application/vnd.framemaker",
  fnc: "application/vnd.frogans.fnc",
  ltf: "application/vnd.frogans.ltf",
  fsc: "application/vnd.fsc.weblaunch",
  oas: "application/vnd.fujitsu.oasys",
  oa2: "application/vnd.fujitsu.oasys2",
  oa3: "application/vnd.fujitsu.oasys3",
  fg5: "application/vnd.fujitsu.oasysgp",
  bh2: "application/vnd.fujitsu.oasysprs",
  ddd: "application/vnd.fujixerox.ddd",
  xdw: "application/vnd.fujixerox.docuworks",
  xbd: "application/vnd.fujixerox.docuworks.binder",
  fzs: "application/vnd.fuzzysheet",
  txd: "application/vnd.genomatix.tuxedo",
  ggb: "application/vnd.geogebra.file",
  ggt: "application/vnd.geogebra.tool",
  gex: "application/vnd.geometry-explorer",
  gre: "application/vnd.geometry-explorer",
  gxt: "application/vnd.geonext",
  g2w: "application/vnd.geoplan",
  g3w: "application/vnd.geospace",
  gmx: "application/vnd.gmx",
  kml: "application/vnd.google-earth.kml+xml",
  kmz: "application/vnd.google-earth.kmz",
  gqf: "application/vnd.grafeq",
  gqs: "application/vnd.grafeq",
  gac: "application/vnd.groove-account",
  ghf: "application/vnd.groove-help",
  gim: "application/vnd.groove-identity-message",
  grv: "application/vnd.groove-injector",
  gtm: "application/vnd.groove-tool-message",
  tpl: "application/vnd.groove-tool-template",
  vcg: "application/vnd.groove-vcard",
  hal: "application/vnd.hal+xml",
  zmm: "application/vnd.handheld-entertainment+xml",
  hbci: "application/vnd.hbci",
  les: "application/vnd.hhe.lesson-player",
  hpgl: "application/vnd.hp-hpgl",
  hpid: "application/vnd.hp-hpid",
  hps: "application/vnd.hp-hps",
  jlt: "application/vnd.hp-jlyt",
  pcl: "application/vnd.hp-pcl",
  pclxl: "application/vnd.hp-pclxl",
  "sfd-hdstx": "application/vnd.hydrostatix.sof-data",
  mpy: "application/vnd.ibm.minipay",
  afp: "application/vnd.ibm.modcap",
  listafp: "application/vnd.ibm.modcap",
  list3820: "application/vnd.ibm.modcap",
  irm: "application/vnd.ibm.rights-management",
  sc: "application/vnd.ibm.secure-container",
  icc: "application/vnd.iccprofile",
  icm: "application/vnd.iccprofile",
  igl: "application/vnd.igloader",
  ivp: "application/vnd.immervision-ivp",
  ivu: "application/vnd.immervision-ivu",
  igm: "application/vnd.insors.igm",
  xpw: "application/vnd.intercon.formnet",
  xpx: "application/vnd.intercon.formnet",
  i2g: "application/vnd.intergeo",
  qbo: "application/vnd.intu.qbo",
  qfx: "application/vnd.intu.qfx",
  rcprofile: "application/vnd.ipunplugged.rcprofile",
  irp: "application/vnd.irepository.package+xml",
  xpr: "application/vnd.is-xpr",
  fcs: "application/vnd.isac.fcs",
  jam: "application/vnd.jam",
  rms: "application/vnd.jcp.javame.midlet-rms",
  jisp: "application/vnd.jisp",
  joda: "application/vnd.joost.joda-archive",
  ktz: "application/vnd.kahootz",
  ktr: "application/vnd.kahootz",
  karbon: "application/vnd.kde.karbon",
  chrt: "application/vnd.kde.kchart",
  kfo: "application/vnd.kde.kformula",
  flw: "application/vnd.kde.kivio",
  kon: "application/vnd.kde.kontour",
  kpr: "application/vnd.kde.kpresenter",
  kpt: "application/vnd.kde.kpresenter",
  ksp: "application/vnd.kde.kspread",
  kwd: "application/vnd.kde.kword",
  kwt: "application/vnd.kde.kword",
  htke: "application/vnd.kenameaapp",
  kia: "application/vnd.kidspiration",
  kne: "application/vnd.kinar",
  knp: "application/vnd.kinar",
  skp: "application/vnd.koan",
  skd: "application/vnd.koan",
  skt: "application/vnd.koan",
  skm: "application/vnd.koan",
  sse: "application/vnd.kodak-descriptor",
  lasxml: "application/vnd.las.las+xml",
  lbd: "application/vnd.llamagraphics.life-balance.desktop",
  lbe: "application/vnd.llamagraphics.life-balance.exchange+xml",
  "123": "application/vnd.lotus-1-2-3",
  apr: "application/vnd.lotus-approach",
  pre: "application/vnd.lotus-freelance",
  nsf: "application/vnd.lotus-notes",
  org: "application/vnd.lotus-organizer",
  scm: "application/vnd.lotus-screencam",
  lwp: "application/vnd.lotus-wordpro",
  portpkg: "application/vnd.macports.portpkg",
  mcd: "application/vnd.mcd",
  mc1: "application/vnd.medcalcdata",
  cdkey: "application/vnd.mediastation.cdkey",
  mwf: "application/vnd.mfer",
  mfm: "application/vnd.mfmp",
  flo: "application/vnd.micrografx.flo",
  igx: "application/vnd.micrografx.igx",
  mif: "application/vnd.mif",
  daf: "application/vnd.mobius.daf",
  dis: "application/vnd.mobius.dis",
  mbk: "application/vnd.mobius.mbk",
  mqy: "application/vnd.mobius.mqy",
  msl: "application/vnd.mobius.msl",
  plc: "application/vnd.mobius.plc",
  txf: "application/vnd.mobius.txf",
  mpn: "application/vnd.mophun.application",
  mpc: "application/vnd.mophun.certificate",
  xul: "application/vnd.mozilla.xul+xml",
  cil: "application/vnd.ms-artgalry",
  cab: "application/vnd.ms-cab-compressed",
  xls: "application/vnd.ms-excel",
  xlm: "application/vnd.ms-excel",
  xla: "application/vnd.ms-excel",
  xlc: "application/vnd.ms-excel",
  xlt: "application/vnd.ms-excel",
  xlw: "application/vnd.ms-excel",
  xlam: "application/vnd.ms-excel.addin.macroenabled.12",
  xlsb: "application/vnd.ms-excel.sheet.binary.macroenabled.12",
  xlsm: "application/vnd.ms-excel.sheet.macroenabled.12",
  xltm: "application/vnd.ms-excel.template.macroenabled.12",
  eot: "application/vnd.ms-fontobject",
  chm: "application/vnd.ms-htmlhelp",
  ims: "application/vnd.ms-ims",
  lrm: "application/vnd.ms-lrm",
  thmx: "application/vnd.ms-officetheme",
  cat: "application/vnd.ms-pki.seccat",
  stl: "application/vnd.ms-pki.stl",
  ppt: "application/vnd.ms-powerpoint",
  pps: "application/vnd.ms-powerpoint",
  pot: "application/vnd.ms-powerpoint",
  ppam: "application/vnd.ms-powerpoint.addin.macroenabled.12",
  pptm: "application/vnd.ms-powerpoint.presentation.macroenabled.12",
  sldm: "application/vnd.ms-powerpoint.slide.macroenabled.12",
  ppsm: "application/vnd.ms-powerpoint.slideshow.macroenabled.12",
  potm: "application/vnd.ms-powerpoint.template.macroenabled.12",
  mpp: "application/vnd.ms-project",
  mpt: "application/vnd.ms-project",
  docm: "application/vnd.ms-word.document.macroenabled.12",
  dotm: "application/vnd.ms-word.template.macroenabled.12",
  wps: "application/vnd.ms-works",
  wks: "application/vnd.ms-works",
  wcm: "application/vnd.ms-works",
  wdb: "application/vnd.ms-works",
  wpl: "application/vnd.ms-wpl",
  xps: "application/vnd.ms-xpsdocument",
  mseq: "application/vnd.mseq",
  mus: "application/vnd.musician",
  msty: "application/vnd.muvee.style",
  taglet: "application/vnd.mynfc",
  nlu: "application/vnd.neurolanguage.nlu",
  ntf: "application/vnd.nitf",
  nitf: "application/vnd.nitf",
  nnd: "application/vnd.noblenet-directory",
  nns: "application/vnd.noblenet-sealer",
  nnw: "application/vnd.noblenet-web",
  ngdat: "application/vnd.nokia.n-gage.data",
  "n-gage": "application/vnd.nokia.n-gage.symbian.install",
  rpst: "application/vnd.nokia.radio-preset",
  rpss: "application/vnd.nokia.radio-presets",
  edm: "application/vnd.novadigm.edm",
  edx: "application/vnd.novadigm.edx",
  ext: "application/vnd.novadigm.ext",
  odc: "application/vnd.oasis.opendocument.chart",
  otc: "application/vnd.oasis.opendocument.chart-template",
  odb: "application/vnd.oasis.opendocument.database",
  odf: "application/vnd.oasis.opendocument.formula",
  odft: "application/vnd.oasis.opendocument.formula-template",
  odg: "application/vnd.oasis.opendocument.graphics",
  otg: "application/vnd.oasis.opendocument.graphics-template",
  odi: "application/vnd.oasis.opendocument.image",
  oti: "application/vnd.oasis.opendocument.image-template",
  odp: "application/vnd.oasis.opendocument.presentation",
  otp: "application/vnd.oasis.opendocument.presentation-template",
  ods: "application/vnd.oasis.opendocument.spreadsheet",
  ots: "application/vnd.oasis.opendocument.spreadsheet-template",
  odt: "application/vnd.oasis.opendocument.text",
  odm: "application/vnd.oasis.opendocument.text-master",
  ott: "application/vnd.oasis.opendocument.text-template",
  oth: "application/vnd.oasis.opendocument.text-web",
  xo: "application/vnd.olpc-sugar",
  dd2: "application/vnd.oma.dd2+xml",
  oxt: "application/vnd.openofficeorg.extension",
  pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  sldx: "application/vnd.openxmlformats-officedocument.presentationml.slide",
  ppsx: "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
  potx: "application/vnd.openxmlformats-officedocument.presentationml.template",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  dotx: "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
  mgp: "application/vnd.osgeo.mapguide.package",
  dp: "application/vnd.osgi.dp",
  esa: "application/vnd.osgi.subsystem",
  pdb: "application/vnd.palm",
  pqa: "application/vnd.palm",
  oprc: "application/vnd.palm",
  paw: "application/vnd.pawaafile",
  str: "application/vnd.pg.format",
  ei6: "application/vnd.pg.osasli",
  efif: "application/vnd.picsel",
  wg: "application/vnd.pmi.widget",
  plf: "application/vnd.pocketlearn",
  pbd: "application/vnd.powerbuilder6",
  box: "application/vnd.previewsystems.box",
  mgz: "application/vnd.proteus.magazine",
  qps: "application/vnd.publishare-delta-tree",
  ptid: "application/vnd.pvi.ptid1",
  qxd: "application/vnd.quark.quarkxpress",
  qxt: "application/vnd.quark.quarkxpress",
  qwd: "application/vnd.quark.quarkxpress",
  qwt: "application/vnd.quark.quarkxpress",
  qxl: "application/vnd.quark.quarkxpress",
  qxb: "application/vnd.quark.quarkxpress",
  bed: "application/vnd.realvnc.bed",
  mxl: "application/vnd.recordare.musicxml",
  musicxml: "application/vnd.recordare.musicxml+xml",
  cryptonote: "application/vnd.rig.cryptonote",
  cod: "application/vnd.rim.cod",
  rm: "application/vnd.rn-realmedia",
  rmvb: "application/vnd.rn-realmedia-vbr",
  link66: "application/vnd.route66.link66+xml",
  st: "application/vnd.sailingtracker.track",
  see: "application/vnd.seemail",
  sema: "application/vnd.sema",
  semd: "application/vnd.semd",
  semf: "application/vnd.semf",
  ifm: "application/vnd.shana.informed.formdata",
  itp: "application/vnd.shana.informed.formtemplate",
  iif: "application/vnd.shana.informed.interchange",
  ipk: "application/vnd.shana.informed.package",
  twd: "application/vnd.simtech-mindmapper",
  twds: "application/vnd.simtech-mindmapper",
  mmf: "application/vnd.smaf",
  teacher: "application/vnd.smart.teacher",
  sdkm: "application/vnd.solent.sdkm+xml",
  sdkd: "application/vnd.solent.sdkm+xml",
  dxp: "application/vnd.spotfire.dxp",
  sfs: "application/vnd.spotfire.sfs",
  sdc: "application/vnd.stardivision.calc",
  sda: "application/vnd.stardivision.draw",
  sdd: "application/vnd.stardivision.impress",
  smf: "application/vnd.stardivision.math",
  sdw: "application/vnd.stardivision.writer",
  vor: "application/vnd.stardivision.writer",
  sgl: "application/vnd.stardivision.writer-global",
  smzip: "application/vnd.stepmania.package",
  sm: "application/vnd.stepmania.stepchart",
  sxc: "application/vnd.sun.xml.calc",
  stc: "application/vnd.sun.xml.calc.template",
  sxd: "application/vnd.sun.xml.draw",
  std: "application/vnd.sun.xml.draw.template",
  sxi: "application/vnd.sun.xml.impress",
  sti: "application/vnd.sun.xml.impress.template",
  sxm: "application/vnd.sun.xml.math",
  sxw: "application/vnd.sun.xml.writer",
  sxg: "application/vnd.sun.xml.writer.global",
  stw: "application/vnd.sun.xml.writer.template",
  sus: "application/vnd.sus-calendar",
  susp: "application/vnd.sus-calendar",
  svd: "application/vnd.svd",
  sis: "application/vnd.symbian.install",
  sisx: "application/vnd.symbian.install",
  xsm: "application/vnd.syncml+xml",
  bdm: "application/vnd.syncml.dm+wbxml",
  xdm: "application/vnd.syncml.dm+xml",
  tao: "application/vnd.tao.intent-module-archive",
  pcap: "application/vnd.tcpdump.pcap",
  cap: "application/vnd.tcpdump.pcap",
  dmp: "application/vnd.tcpdump.pcap",
  tmo: "application/vnd.tmobile-livetv",
  tpt: "application/vnd.trid.tpt",
  mxs: "application/vnd.triscape.mxs",
  tra: "application/vnd.trueapp",
  ufd: "application/vnd.ufdl",
  ufdl: "application/vnd.ufdl",
  utz: "application/vnd.uiq.theme",
  umj: "application/vnd.umajin",
  unityweb: "application/vnd.unity",
  uoml: "application/vnd.uoml+xml",
  vcx: "application/vnd.vcx",
  vsd: "application/vnd.visio",
  vst: "application/vnd.visio",
  vss: "application/vnd.visio",
  vsw: "application/vnd.visio",
  vis: "application/vnd.visionary",
  vsf: "application/vnd.vsf",
  wbxml: "application/vnd.wap.wbxml",
  wmlc: "application/vnd.wap.wmlc",
  wmlsc: "application/vnd.wap.wmlscriptc",
  wtb: "application/vnd.webturbo",
  nbp: "application/vnd.wolfram.player",
  wpd: "application/vnd.wordperfect",
  wqd: "application/vnd.wqd",
  stf: "application/vnd.wt.stf",
  xar: "application/vnd.xara",
  xfdl: "application/vnd.xfdl",
  hvd: "application/vnd.yamaha.hv-dic",
  hvs: "application/vnd.yamaha.hv-script",
  hvp: "application/vnd.yamaha.hv-voice",
  osf: "application/vnd.yamaha.openscoreformat",
  osfpvg: "application/vnd.yamaha.openscoreformat.osfpvg+xml",
  saf: "application/vnd.yamaha.smaf-audio",
  spf: "application/vnd.yamaha.smaf-phrase",
  cmp: "application/vnd.yellowriver-custom-menu",
  zir: "application/vnd.zul",
  zirz: "application/vnd.zul",
  zaz: "application/vnd.zzazz.deck+xml",
  vxml: "application/voicexml+xml",
  wgt: "application/widget",
  hlp: "application/winhlp",
  wsdl: "application/wsdl+xml",
  wspolicy: "application/wspolicy+xml",
  "7z": "application/x-7z-compressed",
  abw: "application/x-abiword",
  ace: "application/x-ace-compressed",
  dmg: "application/x-apple-diskimage",
  aab: "application/x-authorware-bin",
  x32: "application/x-authorware-bin",
  u32: "application/x-authorware-bin",
  vox: "application/x-authorware-bin",
  aam: "application/x-authorware-map",
  aas: "application/x-authorware-seg",
  bcpio: "application/x-bcpio",
  torrent: "application/x-bittorrent",
  blb: "application/x-blorb",
  blorb: "application/x-blorb",
  bz: "application/x-bzip",
  bz2: "application/x-bzip2",
  boz: "application/x-bzip2",
  cbr: "application/x-cbr",
  cba: "application/x-cbr",
  cbt: "application/x-cbr",
  cbz: "application/x-cbr",
  cb7: "application/x-cbr",
  vcd: "application/x-cdlink",
  cfs: "application/x-cfs-compressed",
  chat: "application/x-chat",
  pgn: "application/x-chess-pgn",
  nsc: "application/x-conference",
  cpio: "application/x-cpio",
  csh: "application/x-csh",
  deb: "application/x-debian-package",
  udeb: "application/x-debian-package",
  dgc: "application/x-dgc-compressed",
  dir: "application/x-director",
  dcr: "application/x-director",
  dxr: "application/x-director",
  cst: "application/x-director",
  cct: "application/x-director",
  cxt: "application/x-director",
  w3d: "application/x-director",
  fgd: "application/x-director",
  swa: "application/x-director",
  wad: "application/x-doom",
  ncx: "application/x-dtbncx+xml",
  dtb: "application/x-dtbook+xml",
  res: "application/x-dtbresource+xml",
  dvi: "application/x-dvi",
  evy: "application/x-envoy",
  eva: "application/x-eva",
  bdf: "application/x-font-bdf",
  gsf: "application/x-font-ghostscript",
  psf: "application/x-font-linux-psf",
  pcf: "application/x-font-pcf",
  snf: "application/x-font-snf",
  pfa: "application/x-font-type1",
  pfb: "application/x-font-type1",
  pfm: "application/x-font-type1",
  afm: "application/x-font-type1",
  arc: "application/x-freearc",
  spl: "application/x-futuresplash",
  gca: "application/x-gca-compressed",
  ulx: "application/x-glulx",
  gnumeric: "application/x-gnumeric",
  gramps: "application/x-gramps-xml",
  gtar: "application/x-gtar",
  hdf: "application/x-hdf",
  install: "application/x-install-instructions",
  iso: "application/x-iso9660-image",
  jnlp: "application/x-java-jnlp-file",
  latex: "application/x-latex",
  lzh: "application/x-lzh-compressed",
  lha: "application/x-lzh-compressed",
  mie: "application/x-mie",
  prc: "application/x-mobipocket-ebook",
  mobi: "application/x-mobipocket-ebook",
  application: "application/x-ms-application",
  lnk: "application/x-ms-shortcut",
  wmd: "application/x-ms-wmd",
  wmz: "application/x-ms-wmz",
  xbap: "application/x-ms-xbap",
  mdb: "application/x-msaccess",
  obd: "application/x-msbinder",
  crd: "application/x-mscardfile",
  clp: "application/x-msclip",
  exe: "application/x-msdownload",
  dll: "application/x-msdownload",
  com: "application/x-msdownload",
  bat: "application/x-msdownload",
  msi: "application/x-msdownload",
  mvb: "application/x-msmediaview",
  m13: "application/x-msmediaview",
  m14: "application/x-msmediaview",
  wmf: "application/x-msmetafile",
  emf: "application/x-msmetafile",
  emz: "application/x-msmetafile",
  mny: "application/x-msmoney",
  pub: "application/x-mspublisher",
  scd: "application/x-msschedule",
  trm: "application/x-msterminal",
  wri: "application/x-mswrite",
  nc: "application/x-netcdf",
  cdf: "application/x-netcdf",
  nzb: "application/x-nzb",
  p12: "application/x-pkcs12",
  pfx: "application/x-pkcs12",
  p7b: "application/x-pkcs7-certificates",
  spc: "application/x-pkcs7-certificates",
  p7r: "application/x-pkcs7-certreqresp",
  rar: "application/x-rar-compressed",
  ris: "application/x-research-info-systems",
  sh: "application/x-sh",
  shar: "application/x-shar",
  swf: "application/x-shockwave-flash",
  xap: "application/x-silverlight-app",
  sql: "application/x-sql",
  sit: "application/x-stuffit",
  sitx: "application/x-stuffitx",
  srt: "application/x-subrip",
  sv4cpio: "application/x-sv4cpio",
  sv4crc: "application/x-sv4crc",
  t3: "application/x-t3vm-image",
  gam: "application/x-tads",
  tar: "application/x-tar",
  tcl: "application/x-tcl",
  tex: "application/x-tex",
  tfm: "application/x-tex-tfm",
  texinfo: "application/x-texinfo",
  texi: "application/x-texinfo",
  obj: "application/x-tgif",
  ustar: "application/x-ustar",
  src: "application/x-wais-source",
  der: "application/x-x509-ca-cert",
  crt: "application/x-x509-ca-cert",
  fig: "application/x-xfig",
  xlf: "application/x-xliff+xml",
  xpi: "application/x-xpinstall",
  xz: "application/x-xz",
  z1: "application/x-zmachine",
  z2: "application/x-zmachine",
  z3: "application/x-zmachine",
  z4: "application/x-zmachine",
  z5: "application/x-zmachine",
  z6: "application/x-zmachine",
  z7: "application/x-zmachine",
  z8: "application/x-zmachine",
  xaml: "application/xaml+xml",
  xdf: "application/xcap-diff+xml",
  xenc: "application/xenc+xml",
  xhtml: "application/xhtml+xml",
  xht: "application/xhtml+xml",
  xml: "application/xml",
  xsl: "application/xml",
  dtd: "application/xml-dtd",
  xop: "application/xop+xml",
  xpl: "application/xproc+xml",
  xslt: "application/xslt+xml",
  xspf: "application/xspf+xml",
  mxml: "application/xv+xml",
  xhvml: "application/xv+xml",
  xvml: "application/xv+xml",
  xvm: "application/xv+xml",
  yang: "application/yang",
  yin: "application/yin+xml",
  zip: "application/zip",
  adp: "audio/adpcm",
  au: "audio/basic",
  snd: "audio/basic",
  mid: "audio/midi",
  midi: "audio/midi",
  kar: "audio/midi",
  rmi: "audio/midi",
  m4a: "audio/mp4",
  mp4a: "audio/mp4",
  mpga: "audio/mpeg",
  mp2: "audio/mpeg",
  mp2a: "audio/mpeg",
  mp3: "audio/mpeg",
  m2a: "audio/mpeg",
  m3a: "audio/mpeg",
  oga: "audio/ogg",
  ogg: "audio/ogg",
  spx: "audio/ogg",
  s3m: "audio/s3m",
  sil: "audio/silk",
  uva: "audio/vnd.dece.audio",
  uvva: "audio/vnd.dece.audio",
  eol: "audio/vnd.digital-winds",
  dra: "audio/vnd.dra",
  dts: "audio/vnd.dts",
  dtshd: "audio/vnd.dts.hd",
  lvp: "audio/vnd.lucent.voice",
  pya: "audio/vnd.ms-playready.media.pya",
  ecelp4800: "audio/vnd.nuera.ecelp4800",
  ecelp7470: "audio/vnd.nuera.ecelp7470",
  ecelp9600: "audio/vnd.nuera.ecelp9600",
  rip: "audio/vnd.rip",
  weba: "audio/webm",
  aac: "audio/x-aac",
  aif: "audio/x-aiff",
  aiff: "audio/x-aiff",
  aifc: "audio/x-aiff",
  caf: "audio/x-caf",
  flac: "audio/x-flac",
  mka: "audio/x-matroska",
  m3u: "audio/x-mpegurl",
  wax: "audio/x-ms-wax",
  wma: "audio/x-ms-wma",
  ram: "audio/x-pn-realaudio",
  ra: "audio/x-pn-realaudio",
  rmp: "audio/x-pn-realaudio-plugin",
  wav: "audio/x-wav",
  xm: "audio/xm",
  glb: "binary/octet-stream",
  cdx: "chemical/x-cdx",
  cif: "chemical/x-cif",
  cmdf: "chemical/x-cmdf",
  cml: "chemical/x-cml",
  csml: "chemical/x-csml",
  xyz: "chemical/x-xyz",
  ttc: "font/collection",
  otf: "font/otf",
  ttf: "font/ttf",
  woff: "font/woff",
  woff2: "font/woff2",
  bmp: "image/bmp",
  cgm: "image/cgm",
  g3: "image/g3fax",
  gif: "image/gif",
  heic: "image/heic",
  heif: "image/heif",
  ief: "image/ief",
  jpeg: "image/jpeg",
  jpg: "image/jpeg",
  jpe: "image/jpeg",
  ktx: "image/ktx",
  png: "image/png",
  btif: "image/prs.btif",
  sgi: "image/sgi",
  svg: "image/svg+xml",
  svgz: "image/svg+xml",
  tiff: "image/tiff",
  tif: "image/tiff",
  psd: "image/vnd.adobe.photoshop",
  uvi: "image/vnd.dece.graphic",
  uvvi: "image/vnd.dece.graphic",
  uvg: "image/vnd.dece.graphic",
  uvvg: "image/vnd.dece.graphic",
  djvu: "image/vnd.djvu",
  djv: "image/vnd.djvu",
  dwg: "image/vnd.dwg",
  dxf: "image/vnd.dxf",
  fbs: "image/vnd.fastbidsheet",
  fpx: "image/vnd.fpx",
  fst: "image/vnd.fst",
  mmr: "image/vnd.fujixerox.edmics-mmr",
  rlc: "image/vnd.fujixerox.edmics-rlc",
  mdi: "image/vnd.ms-modi",
  wdp: "image/vnd.ms-photo",
  npx: "image/vnd.net-fpx",
  wbmp: "image/vnd.wap.wbmp",
  xif: "image/vnd.xiff",
  webp: "image/webp",
  "3ds": "image/x-3ds",
  ras: "image/x-cmu-raster",
  cmx: "image/x-cmx",
  fh: "image/x-freehand",
  fhc: "image/x-freehand",
  fh4: "image/x-freehand",
  fh5: "image/x-freehand",
  fh7: "image/x-freehand",
  ico: "image/x-icon",
  sid: "image/x-mrsid-image",
  pcx: "image/x-pcx",
  pic: "image/x-pict",
  pct: "image/x-pict",
  pnm: "image/x-portable-anymap",
  pbm: "image/x-portable-bitmap",
  pgm: "image/x-portable-graymap",
  ppm: "image/x-portable-pixmap",
  rgb: "image/x-rgb",
  tga: "image/x-tga",
  xbm: "image/x-xbitmap",
  xpm: "image/x-xpixmap",
  xwd: "image/x-xwindowdump",
  eml: "message/rfc822",
  mime: "message/rfc822",
  igs: "model/iges",
  iges: "model/iges",
  msh: "model/mesh",
  mesh: "model/mesh",
  silo: "model/mesh",
  dae: "model/vnd.collada+xml",
  dwf: "model/vnd.dwf",
  gdl: "model/vnd.gdl",
  gtw: "model/vnd.gtw",
  mts: "model/vnd.mts",
  vtu: "model/vnd.vtu",
  wrl: "model/vrml",
  vrml: "model/vrml",
  x3db: "model/x3d+binary",
  x3dbz: "model/x3d+binary",
  x3dv: "model/x3d+vrml",
  x3dvz: "model/x3d+vrml",
  x3d: "model/x3d+xml",
  x3dz: "model/x3d+xml",
  appcache: "text/cache-manifest",
  ics: "text/calendar",
  ifb: "text/calendar",
  css: "text/css",
  csv: "text/csv",
  html: "text/html",
  htm: "text/html",
  n3: "text/n3",
  txt: "text/plain",
  text: "text/plain",
  conf: "text/plain",
  def: "text/plain",
  list: "text/plain",
  log: "text/plain",
  in: "text/plain",
  dsc: "text/prs.lines.tag",
  rtx: "text/richtext",
  sgml: "text/sgml",
  sgm: "text/sgml",
  tsv: "text/tab-separated-values",
  t: "text/troff",
  tr: "text/troff",
  roff: "text/troff",
  man: "text/troff",
  me: "text/troff",
  ms: "text/troff",
  ttl: "text/turtle",
  uri: "text/uri-list",
  uris: "text/uri-list",
  urls: "text/uri-list",
  vcard: "text/vcard",
  curl: "text/vnd.curl",
  dcurl: "text/vnd.curl.dcurl",
  mcurl: "text/vnd.curl.mcurl",
  scurl: "text/vnd.curl.scurl",
  sub: "text/vnd.dvb.subtitle",
  fly: "text/vnd.fly",
  flx: "text/vnd.fmi.flexstor",
  gv: "text/vnd.graphviz",
  "3dml": "text/vnd.in3d.3dml",
  spot: "text/vnd.in3d.spot",
  jad: "text/vnd.sun.j2me.app-descriptor",
  wml: "text/vnd.wap.wml",
  wmls: "text/vnd.wap.wmlscript",
  s: "text/x-asm",
  asm: "text/x-asm",
  c: "text/x-c",
  cc: "text/x-c",
  cxx: "text/x-c",
  cpp: "text/x-c",
  h: "text/x-c",
  hh: "text/x-c",
  dic: "text/x-c",
  f: "text/x-fortran",
  for: "text/x-fortran",
  f77: "text/x-fortran",
  f90: "text/x-fortran",
  java: "text/x-java-source",
  nfo: "text/x-nfo",
  opml: "text/x-opml",
  p: "text/x-pascal",
  pas: "text/x-pascal",
  etx: "text/x-setext",
  sfv: "text/x-sfv",
  uu: "text/x-uuencode",
  vcs: "text/x-vcalendar",
  vcf: "text/x-vcard",
  "3gp": "video/3gpp",
  "3g2": "video/3gpp2",
  h261: "video/h261",
  h263: "video/h263",
  h264: "video/h264",
  jpgv: "video/jpeg",
  jpm: "video/jpm",
  jpgm: "video/jpm",
  mj2: "video/mj2",
  mjp2: "video/mj2",
  mp4: "video/mp4",
  mp4v: "video/mp4",
  mpg4: "video/mp4",
  mpeg: "video/mpeg",
  mpg: "video/mpeg",
  mpe: "video/mpeg",
  m1v: "video/mpeg",
  m2v: "video/mpeg",
  ogv: "video/ogg",
  qt: "video/quicktime",
  mov: "video/quicktime",
  uvh: "video/vnd.dece.hd",
  uvvh: "video/vnd.dece.hd",
  uvm: "video/vnd.dece.mobile",
  uvvm: "video/vnd.dece.mobile",
  uvp: "video/vnd.dece.pd",
  uvvp: "video/vnd.dece.pd",
  uvs: "video/vnd.dece.sd",
  uvvs: "video/vnd.dece.sd",
  uvv: "video/vnd.dece.video",
  uvvv: "video/vnd.dece.video",
  dvb: "video/vnd.dvb.file",
  fvt: "video/vnd.fvt",
  mxu: "video/vnd.mpegurl",
  m4u: "video/vnd.mpegurl",
  pyv: "video/vnd.ms-playready.media.pyv",
  uvu: "video/vnd.uvvu.mp4",
  uvvu: "video/vnd.uvvu.mp4",
  viv: "video/vnd.vivo",
  webm: "video/webm",
  f4v: "video/x-f4v",
  fli: "video/x-fli",
  flv: "video/x-flv",
  m4v: "video/x-m4v",
  mkv: "video/x-matroska",
  mk3d: "video/x-matroska",
  mks: "video/x-matroska",
  mng: "video/x-mng",
  asf: "video/x-ms-asf",
  asx: "video/x-ms-asf",
  vob: "video/x-ms-vob",
  wm: "video/x-ms-wm",
  wmv: "video/x-ms-wmv",
  wmx: "video/x-ms-wmx",
  wvx: "video/x-ms-wvx",
  avi: "video/x-msvideo",
  movie: "video/x-sgi-movie",
  smv: "video/x-smv",
  ice: "x-conference/x-cooltalk"
};

// src/validation/validationRules.ts
var mimeTypesOptions = [
  "application/*",
  "image/*",
  "video/*",
  "text/*",
  "model/*",
  "font/*",
  "audio/*",
  ...new Set(Object.values(mime_types_default))
];
var errorMessages = {
  date: "Date must be {comparator} {operand}",
  regexp: "Value must match pattern {operand}",
  imageDimensions: "{widthOrHeight} must be {comparator} {operand}px",
  fileSize: "File Size must be {comparator} {operand} bytes",
  length: "Value length must be {comparator} {operand}",
  mimeType: "File Type must match one of {operand}",
  arrayUnique: "Array values must be unique"
};
function requiredRule(v) {
  if (typeof v === "string" || Array.isArray(v)) {
    return !isNil_default(v) && v.length > 0 || "Field is Required";
  }
  return !isNil_default(v) || "Field is Required";
}
function urlRule(v) {
  if (!isNil_default(v) && typeof v === "string" && v.length > 0) {
    return !!(0, import_uri_js2.parse)(v).scheme || "Value must be a valid URL";
  }
  return true;
}
function jexlRule({ expression, errorMessage }) {
  return function(v) {
    return (v ? jexl3.evalSync(expression, { value: v }) : true) || errorMessage;
  };
}
function getValidations(field, arrayValidation2 = false, required = false) {
  const rules = [];
  if (required) {
    rules.push(requiredRule);
  }
  if (field.fieldType === "URL") {
    rules.push(urlRule);
  }
  if (field.validationExpressions) {
    field.validationExpressions.forEach((expr) => rules.push(jexlRule(expr)));
  }
  return rules;
}
function standardComparators() {
  return {
    name: "comparator",
    label: "Must Be",
    type: "select",
    items: ["==", "!=", ">", ">=", "<", "<="]
  };
}
function stringComparators() {
  return {
    name: "comparator",
    label: "Must Be",
    type: "select",
    items: ["==", "!="]
  };
}
function stringOperand() {
  return {
    name: "operand",
    type: "text",
    label: "Value"
  };
}
function numberOperand() {
  return {
    name: "operand",
    type: "number",
    label: "Value"
  };
}
function boolOperand() {
  return {
    name: "operand",
    type: "select",
    label: "Value",
    items: ["false", "true"]
  };
}
function dateOperand() {
  return {
    name: "operand",
    type: "date",
    label: "Date"
  };
}
function length() {
  return {
    value: "length",
    label: "Length",
    input: [
      standardComparators(),
      numberOperand()
    ],
    getExpression({ comparator = "==", operand = "" } = {}) {
      return {
        expression: `value|length ${comparator} ${operand}`,
        errorMessage: "length",
        errorParams: { comparator, operand }
      };
    }
  };
}
function numberConstraints() {
  return {
    value: "number-constraints",
    label: "Constraints",
    input: [
      standardComparators(),
      numberOperand()
    ],
    getExpression({ comparator = "==", operand = "" } = {}) {
      return {
        expression: `value ${comparator} ${operand}`,
        errorMessage: "number-constraints",
        errorParams: { comparator, operand }
      };
    }
  };
}
function arrayValidation() {
  return [
    length(),
    {
      value: "arrayUnique",
      label: "Unique Values",
      input: [],
      getExpression() {
        return {
          expression: "value|uniq|length == value|length",
          errorMessage: "arrayUnique"
        };
      }
    }
  ];
}
function stringValidation() {
  return [
    length(),
    {
      value: "regexp",
      label: "Regexp Match",
      input: [
        {
          name: "operand",
          type: "text",
          label: "RegExp"
        }
      ],
      getExpression({ operand = "" } = {}) {
        return {
          expression: `value ~= "${operand}"`,
          errorMessage: "regexp",
          errorParams: { operand }
        };
      }
    }
  ];
}
function stringValueValidation() {
  return {
    value: "string-value",
    label: "Value comparation",
    input: [
      stringComparators(),
      stringOperand()
    ],
    getExpression({ comparator = "==", operand = "" } = {}) {
      return {
        expression: `value ${comparator} "${operand}"`,
        errorMessage: "string-value",
        errorParams: { comparator, operand }
      };
    }
  };
}
function numberValidation() {
  return [
    numberConstraints(),
    {
      value: "regexp",
      label: "Regexp Match",
      input: [
        {
          name: "operand",
          type: "text",
          label: "RegExp"
        }
      ],
      getExpression({ operand = "" } = {}) {
        return {
          expression: `value ~= "${operand}"`,
          errorMessage: "regexp",
          errorParams: { operand }
        };
      }
    }
  ];
}
function boolValueValidation() {
  return {
    value: "bool-value",
    label: "Value comparation",
    input: [
      stringComparators(),
      boolOperand()
    ],
    getExpression({ comparator = "==", operand = "false" } = {}) {
      return {
        expression: `value ${comparator} ${operand}`,
        errorMessage: "bool-value",
        errorParams: { comparator, operand }
      };
    }
  };
}
function mediaValidation(typeFilter) {
  return [
    {
      value: "fileSize",
      label: "File Size",
      input: [
        standardComparators(),
        numberOperand()
      ],
      getExpression({ comparator = "==", operand = "" } = {}) {
        return {
          expression: `value.fileSize ${comparator} ${operand}`,
          errorMessage: "fileSize",
          errorParams: { comparator, operand }
        };
      }
    },
    {
      value: "mimeType",
      label: "File Type",
      input: [
        {
          name: "operand",
          label: "File Type",
          type: "select",
          items: mimeTypesOptions.filter((entry) => !typeFilter || typeFilter.test(entry)),
          multiple: true,
          stringify: true
        }
      ],
      getExpression({ operand = "" } = {}) {
        return {
          expression: `value.mimeType mime= "${operand}"`,
          errorMessage: "mimeType",
          errorParams: { operand }
        };
      }
    }
  ];
}
function imageValidation() {
  return [
    ...mediaValidation(/^image\//),
    {
      value: "imageDimensions",
      label: "Image Dimensions",
      input: [
        {
          name: "widthOrHeight",
          label: "Width or Height",
          type: "select",
          items: ["Width", "Height"]
        },
        standardComparators(),
        numberOperand()
      ],
      getExpression({ widthOrHeight = "Width", comparator = "==", operand = "" } = {}) {
        return {
          expression: `value.metaData|jsonparse["image-${widthOrHeight.toLowerCase()}"]|toInt ${comparator} ${operand}`,
          errorMessage: "imageDimensions",
          errorParams: { widthOrHeight, comparator, operand }
        };
      }
    }
  ];
}
function dateValidation() {
  return [
    {
      value: "date",
      label: "Date",
      input: [
        standardComparators(),
        dateOperand()
      ],
      getExpression({ comparator = "==", operand = "" } = {}) {
        return {
          expression: `value|getTime ${comparator} "${operand}"|getTime`,
          errorMessage: "date",
          errorParams: { comparator, operand }
        };
      }
    }
  ];
}

// src/OptimizedImageHandler.ts
var OptimizedImageHandler_exports = {};
__export(OptimizedImageHandler_exports, {
  cropModes: () => cropModes,
  defaultParamaters: () => defaultParamaters,
  fitModes: () => fitModes,
  genericSchema: () => genericSchema,
  literalSchema: () => literalSchema,
  supportedFormats: () => supportedFormats
});
var schema = {
  version: "11.2.0",
  parameters: {
    /**
     * Resizes and crops the original image to match a specified aspect ratio.
     *
     * This parameter will work only when either fit=crop or fit=fill is set.
     *
     * Values for ar are expressed as W:H.
     */
    ar: {
      display_name: "aspect ratio",
      category: "size",
      available_in: [
        "url"
      ],
      expects: [
        {
          type: "ratio",
          strict_range: {
            min: 0
          }
        }
      ],
      depends: [
        "fit=crop",
        "fit=fill"
      ],
      short_description: "Specifies an aspect ratio to maintain when resizing and cropping the image"
    },
    /**
    * The auto parameter helps you automate a baseline level of optimization across your entire image catalog. Currently, it has three different methods:
    *
    * * Compression
    * * Visual enhancement
    * * File format conversion
    *
    * auto values can be combined with comma separation, e.g. `auto=compress,enhance`. Additionally, it is the only parameter that can be combined by reiteration, e.g. `auto=compress&auto=enhance&auto=format`.
    *
    * ## auto=compress
    * When `auto=compress` is set, the service will apply best-effort techniques to reduce the size of the image. This includes altering our normal processing algorithm to apply more aggressive image compression.
    *
    * If `auto=format` is included in the query, it will be respected. In this case, images will be served in AVIF format whenever possible while still applying compression. When AVIF is not supported, the image will be served as a WebP. If the WebP format is not supported, images that contain transparency will be served in a PNG8 format (if supported) and all others will be served as JPEG. The quality standard (q) is set to 45.
    *
    * Note: We strive to reduce file size while maintaining as much visual information as possible, so the operations applied are subject to change. Adding cs=srgb will resolve color issues by adding the color space back. Additionally, the default quality standard can be overridden by using the q parameter.
    *
    * ## auto=enhance
    * When `auto=enhance` is set, the image is adjusted using the distribution of highlights, midtones, and shadows across all three channels—red, green, and blue (RGB). Overall, the enhancement gives images a more vibrant appearance.
    *
    * The adjustment affects individual images differently, and works best with editorial photography, stock photography, and user-generated content for social media applications.
    *
    * ## auto=format
    * When `auto=format` is set, the service determines whether the image can be served in a better format by a process called automatic content negotiation. It compiles the various signals available to us—including headers, user agents, and image analytics—to select the optimal image format for your user. This format is served back and the image is correctly cached.
    *
    * The `auto=format` logic will attempt to serve images in AVIF when supported. When AVIF is not supported, the image will be served as WebP. If the WebP format is not supported, it will serve the file as JPG or PNG.
    *
    * The fallback logic can be modified by adding `auto=compress` and/or specifying a fallback format with fm. When used in conjunction with each other, fm takes priority over `auto=compress`.
    */
    auto: {
      display_name: "automatic",
      category: "auto",
      available_in: [
        "url"
      ],
      expects: [
        {
          type: "list",
          possible_values: [
            "enhance",
            "format",
            // 'redeye',
            "compress"
            // 'true'
          ]
        }
      ],
      disallow_base64: true,
      url: "https://docs.imgix.com/apis/url/auto",
      short_description: "Applies automatic enhancements to images."
    },
    // bg: {
    //   display_name: 'background color',
    //   category: 'fill',
    //   available_in: [
    //     'url',
    //     'graph'
    //   ],
    //   expects: [
    //     {
    //       type: 'hex_color'
    //     },
    //     {
    //       type: 'color_keyword'
    //     }
    //   ],
    //   default: '#fff',
    //   url: 'https://docs.imgix.com/apis/url/bg',
    //   short_description: 'Colors the background of padded and partially-transparent images.'
    // },
    // 'blend-align': {
    //   display_name: 'blend align',
    //   category: 'blending',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'list',
    //       possible_values: [
    //         'top',
    //         'bottom',
    //         'middle',
    //         'left',
    //         'right',
    //         'center'
    //       ]
    //     }
    //   ],
    //   aliases: [
    //     'blendalign',
    //     'ba'
    //   ],
    //   depends: [
    //     'blend'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/blending/blend-align',
    //   short_description: 'Changes the blend alignment relative to the parent image.'
    // },
    // 'blend-alpha': {
    //   display_name: 'blend alpha',
    //   category: 'blending',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       strict_range: {
    //         min: 0,
    //         max: 100
    //       }
    //     }
    //   ],
    //   aliases: [
    //     'blendalpha',
    //     'balph'
    //   ],
    //   default: 100,
    //   depends: [
    //     'blend'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/blending/blend-alpha',
    //   short_description: 'Changes the alpha of the blend image.'
    // },
    // 'blend-crop': {
    //   display_name: 'blend crop',
    //   category: 'blending',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'list',
    //       possible_values: [
    //         'top',
    //         'bottom',
    //         'left',
    //         'right',
    //         'faces'
    //       ]
    //     }
    //   ],
    //   aliases: [
    //     'blendcrop',
    //     'bc'
    //   ],
    //   depends: [
    //     'blend'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/blending/blend-crop',
    //   short_description: 'Specifies the type of crop for blend images.'
    // },
    // 'blend-fit': {
    //   display_name: 'blend fit',
    //   category: 'blending',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'string',
    //       possible_values: [
    //         'clamp',
    //         'clip',
    //         'crop',
    //         'scale',
    //         'max'
    //       ]
    //     }
    //   ],
    //   aliases: [
    //     'blendfit',
    //     'bf'
    //   ],
    //   default: 'clip',
    //   depends: [
    //     'blend'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/blending/blend-fit',
    //   short_description: 'Specifies the fit mode for blend images.'
    // },
    // 'blend-h': {
    //   display_name: 'blend height',
    //   category: 'blending',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       strict_range: {
    //         min: 2,
    //         max: 134201344
    //       }
    //     },
    //     {
    //       type: 'unit_scalar',
    //       strict_range: {
    //         min: 0,
    //         max: 1
    //       }
    //     }
    //   ],
    //   aliases: [
    //     'blendh',
    //     'bh'
    //   ],
    //   depends: [
    //     'blend'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/blending/blend-h',
    //   short_description: 'Adjusts the height of the blend image.'
    // },
    // 'blend-mode': {
    //   display_name: 'blend mode',
    //   category: 'blending',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'string',
    //       possible_values: [
    //         'color',
    //         'burn',
    //         'dodge',
    //         'darken',
    //         'difference',
    //         'exclusion',
    //         'hardlight',
    //         'hue',
    //         'lighten',
    //         'luminosity',
    //         'multiply',
    //         'overlay',
    //         'saturation',
    //         'screen',
    //         'softlight',
    //         'normal'
    //       ]
    //     }
    //   ],
    //   aliases: [
    //     'blendmode',
    //     'bm'
    //   ],
    //   default: 'overlay',
    //   depends: [
    //     'blend'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/blending/blend-mode',
    //   short_description: 'Sets the blend mode for a blend image.'
    // },
    // 'blend-pad': {
    //   display_name: 'blend padding',
    //   category: 'blending',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       suggested_range: {
    //         min: 0
    //       }
    //     }
    //   ],
    //   aliases: [
    //     'blendpad',
    //     'bp'
    //   ],
    //   default: 0,
    //   depends: [
    //     'blend'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/blending/blend-pad',
    //   short_description: 'Applies padding to the blend image.'
    // },
    // 'blend-size': {
    //   display_name: 'blend size',
    //   category: 'blending',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'string',
    //       possible_values: [
    //         'inherit'
    //       ]
    //     }
    //   ],
    //   aliases: [
    //     'blendsize',
    //     'bs'
    //   ],
    //   depends: [
    //     'blend'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/blending/blend-size',
    //   short_description: 'Adjusts the size of the blend image.'
    // },
    // 'blend-w': {
    //   display_name: 'blend width',
    //   category: 'blending',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       strict_range: {
    //         min: 2,
    //         max: 134201344
    //       }
    //     },
    //     {
    //       type: 'unit_scalar',
    //       strict_range: {
    //         min: 0,
    //         max: 1
    //       }
    //     }
    //   ],
    //   aliases: [
    //     'blendw',
    //     'bw'
    //   ],
    //   depends: [
    //     'blend'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/blending/blend-w',
    //   short_description: 'Adjusts the width of the blend image.'
    // },
    // 'blend-x': {
    //   display_name: 'blend x position',
    //   category: 'blending',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       suggested_range: {
    //         min: 0
    //       }
    //     }
    //   ],
    //   aliases: [
    //     'blendx',
    //     'bx'
    //   ],
    //   default: 0,
    //   depends: [
    //     'blend'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/blending/blend-x',
    //   short_description: 'Adjusts the x-offset of the blend image relative to its parent.'
    // },
    // 'blend-y': {
    //   display_name: 'blend y position',
    //   category: 'blending',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       suggested_range: {
    //         min: 0
    //       }
    //     }
    //   ],
    //   aliases: [
    //     'blendy',
    //     'by'
    //   ],
    //   default: 0,
    //   depends: [
    //     'blend'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/blending/blend-y',
    //   short_description: 'Adjusts the y-offset of the blend image relative to its parent.'
    // },
    // blend: {
    //   display_name: 'blend',
    //   category: 'blending',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'hex_color'
    //     },
    //     {
    //       type: 'color_keyword'
    //     },
    //     {
    //       type: 'url'
    //     },
    //     {
    //       type: 'path'
    //     }
    //   ],
    //   aliases: [
    //     'b'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/blending/blend',
    //   short_description: 'Specifies the location of the blend image.'
    // },
    /**
     * Applies a [Gaussian style blur](https://en.wikipedia.org/wiki/Gaussian_blur) to your image, smoothing out image noise.
     *
     * Valid values are in the range from 0 – 2000. The default value is 0, which leaves the image unchanged.
     */
    blur: {
      display_name: "gaussian blur",
      category: "stylize",
      available_in: [
        "url",
        "graph"
      ],
      expects: [
        {
          type: "integer",
          suggested_range: {
            min: 0,
            max: 2e3
          }
        }
      ],
      default: 0,
      url: "https://docs.imgix.com/apis/url/stylize/blur",
      short_description: "Applies a gaussian blur to an image."
    },
    // 'border-radius-inner': {
    //   display_name: 'inner border radius',
    //   category: 'border-and-padding',
    //   available_in: [
    //     'url',
    //     'graph'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       strict_range: {
    //         min: 0
    //       }
    //     },
    //     {
    //       0: [
    //         {
    //           type: 'integer',
    //           strict_range: {
    //             min: 0
    //           }
    //         }
    //       ],
    //       1: [
    //         {
    //           type: 'integer',
    //           strict_range: {
    //             min: 0
    //           }
    //         }
    //       ],
    //       2: [
    //         {
    //           type: 'integer',
    //           strict_range: {
    //             min: 0
    //           }
    //         }
    //       ],
    //       3: [
    //         {
    //           type: 'integer',
    //           strict_range: {
    //             min: 0
    //           }
    //         }
    //       ],
    //       type: 'list',
    //       length: 4
    //     }
    //   ],
    //   depends: [
    //     'border'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/border-and-padding/border-radius-inner',
    //   short_description: "Sets the inner radius of the image's border in pixels."
    // },
    // 'border-radius': {
    //   display_name: 'outer border radius',
    //   category: 'border-and-padding',
    //   available_in: [
    //     'url',
    //     'graph'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       strict_range: {
    //         min: 0
    //       }
    //     },
    //     {
    //       0: [
    //         {
    //           type: 'integer',
    //           strict_range: {
    //             min: 0
    //           }
    //         }
    //       ],
    //       1: [
    //         {
    //           type: 'integer',
    //           strict_range: {
    //             min: 0
    //           }
    //         }
    //       ],
    //       2: [
    //         {
    //           type: 'integer',
    //           strict_range: {
    //             min: 0
    //           }
    //         }
    //       ],
    //       3: [
    //         {
    //           type: 'integer',
    //           strict_range: {
    //             min: 0
    //           }
    //         }
    //       ],
    //       type: 'list',
    //       length: 4
    //     }
    //   ],
    //   depends: [
    //     'border'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/border-and-padding/border-radius',
    //   short_description: "Sets the outer radius of the image's border in pixels."
    // },
    // border: {
    //   display_name: 'border size & color',
    //   category: 'border-and-padding',
    //   available_in: [
    //     'url',
    //     'graph'
    //   ],
    //   expects: [
    //     {
    //       0: [
    //         {
    //           type: 'integer',
    //           suggested_range: {
    //             min: 1,
    //             max: 100
    //           }
    //         }
    //       ],
    //       1: [
    //         {
    //           type: 'hex_color'
    //         },
    //         {
    //           type: 'color_keyword'
    //         }
    //       ],
    //       type: 'list',
    //       length: 2
    //     }
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/border-and-padding/border',
    //   short_description: 'Applies a border to an image.'
    // },
    /**
     * Adjusts the overall brightness of the image.
     *
     * Valid values are in the range -100 – 100. The default value is 0, which leaves the image unchanged.
     */
    bri: {
      display_name: "brightness",
      category: "adjustment",
      available_in: [
        "url",
        "graph"
      ],
      expects: [
        {
          type: "integer",
          suggested_range: {
            min: -100,
            max: 100
          }
        }
      ],
      default: 0,
      url: "https://docs.imgix.com/apis/url/adjustment/bri",
      short_description: "Adjusts the brightness of the source image."
    },
    // ch: {
    //   display_name: 'client hints',
    //   category: 'format',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'list',
    //       possible_values: [
    //         'width',
    //         'dpr',
    //         'save-data'
    //       ]
    //     }
    //   ],
    //   disallow_base64: true,
    //   url: 'https://docs.imgix.com/apis/url/format/ch',
    //   short_description: 'Sets one or more Client-Hints headers'
    // },
    // chromasub: {
    //   display_name: 'chroma subsampling',
    //   category: 'format',
    //   available_in: [
    //     'url',
    //     'graph',
    //     'output'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       possible_values: [
    //         444,
    //         422,
    //         420
    //       ]
    //     }
    //   ],
    //   default: 420,
    //   url: 'https://docs.imgix.com/apis/url/format/chromasub',
    //   short_description: 'Specifies the output chroma subsampling rate.'
    // },
    // colorquant: {
    //   display_name: 'color quantization',
    //   category: 'format',
    //   available_in: [
    //     'url',
    //     'graph',
    //     'output'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       suggested_range: {
    //         min: 2,
    //         max: 256
    //       }
    //     }
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/format/colorquant',
    //   short_description: 'Limits the number of unique colors in an image.'
    // },
    // colors: {
    //   display_name: 'palette color count',
    //   category: 'color-palette',
    //   available_in: [
    //     'url',
    //     'output'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       suggested_range: {
    //         min: 0,
    //         max: 16
    //       }
    //     }
    //   ],
    //   default: 6,
    //   depends: [
    //     'palette'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/color-palette/colors',
    //   short_description: 'Specifies how many colors to include in a palette-extraction response.'
    // },
    // con: {
    //   display_name: 'contrast',
    //   category: 'adjustment',
    //   available_in: [
    //     'url',
    //     'graph'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       suggested_range: {
    //         min: -100,
    //         max: 100
    //       }
    //     }
    //   ],
    //   default: 0,
    //   url: 'https://docs.imgix.com/apis/url/adjustment/con',
    //   short_description: 'Adjusts the contrast of the source image.'
    // },
    // 'corner-radius': {
    //   display_name: 'mask corner radius',
    //   category: 'mask',
    //   available_in: [
    //     'url',
    //     'graph'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       strict_range: {
    //         min: 0
    //       }
    //     },
    //     {
    //       0: [
    //         {
    //           type: 'integer',
    //           strict_range: {
    //             min: 0
    //           }
    //         }
    //       ],
    //       1: [
    //         {
    //           type: 'integer',
    //           strict_range: {
    //             min: 0
    //           }
    //         }
    //       ],
    //       2: [
    //         {
    //           type: 'integer',
    //           strict_range: {
    //             min: 0
    //           }
    //         }
    //       ],
    //       3: [
    //         {
    //           type: 'integer',
    //           strict_range: {
    //             min: 0
    //           }
    //         }
    //       ],
    //       type: 'list',
    //       length: 4
    //     }
    //   ],
    //   depends: [
    //     'mask=corners'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/mask/corner-radius',
    //   short_description: 'Specifies the radius value for a rounded corner mask.'
    // },
    /**
     * Crop mode controls how the image is aligned when `fit=crop` is set. The `w` and `h` parameters should also be set, so that the crop behavior is defined within specific image dimensions.
     *
     * Valid values are `top`, `bottom`, `left`, `right`, `focalpoint` and entropy. Multiple values can be used by separating them with a comma `,`. If no value is explicitly set, the default behavior is to crop from the center of the image.
     *
     * ## Directional Cropping
     * The `top`, `bottom`, `left`, and `right` values allow you to specify the starting location of the crop. Image dimensions will be calculated from this starting point outward. These values can be combined by separating with commas, e.g. `crop=top,left`.
     *
     * * `top`: Crop from the top of the image, down.
     * * `bottom`: Crop from the bottom of the image, up.
     * * `left`: Crop from the left of the image, right.
     * * `right`: Crop from the right of the image, left.
     *
     * ## Focal Point Cropping
     * [This example](https://docs.imgix.com/apis/rendering/size/crop#focalpoint) illustrates the difference between the default centered crop and one made with focal point parameters to target and zoom to a portion of the image.
     * The source image in [this example](https://docs.imgix.com/apis/rendering/size/crop#focalpoint) is being cropped to a square.
     * When set in combination with a relative horizontal (`fp-x`), vertical (`fp-y`), and/or zoom (`fp-z`) value, will center the image on those coordinates and crop from there.
     *
     *
     */
    crop: {
      display_name: "crop mode",
      category: "size",
      available_in: [
        "url",
        "graph"
      ],
      expects: [
        {
          type: "list",
          possible_values: [
            "top",
            "bottom",
            "left",
            "right",
            // 'faces',
            "entropy",
            "attention",
            // 'edges',
            "focalpoint"
          ]
        }
      ],
      depends: [
        "fit=crop"
      ],
      url: "https://docs.imgix.com/apis/url/size/crop",
      short_description: "Specifies how to crop an image."
    },
    // cs: {
    //   display_name: 'color space',
    //   category: 'format',
    //   available_in: [
    //     'url',
    //     'graph',
    //     'output'
    //   ],
    //   expects: [
    //     {
    //       type: 'string',
    //       possible_values: [
    //         'srgb',
    //         'adobergb1998',
    //         'tinysrgb',
    //         'strip'
    //       ]
    //     }
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/format/cs',
    //   short_description: 'Specifies the color space of the output image.'
    // },
    // dl: {
    //   display_name: 'download',
    //   category: 'format',
    //   available_in: [
    //     'url',
    //     'output'
    //   ],
    //   expects: [
    //     {
    //       type: 'string'
    //     }
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/format/dl',
    //   short_description: 'Forces a URL to use send-file in its response.'
    // },
    // dpi: {
    //   display_name: 'dots per inch',
    //   category: 'format',
    //   available_in: [
    //     'url',
    //     'graph',
    //     'output'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       suggested_range: {
    //         min: 0
    //       }
    //     }
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/format/dpi',
    //   short_description: 'Sets the DPI value in the EXIF header.'
    // },
    /**
     * Controls the output density of your image, so you can serve images at the correct density for every user's device from a single image.
     *
     * You must specify a width, a height, or both for this parameter to work. The default is 1 and the maximum value is 5.
     *
     * Device pixel ratio (DPR) is an easy way to convert between [device-independent pixels](https://en.wikipedia.org/wiki/Device-independent_pixel) and device pixels (also called "CSS pixels"), so that high-DPR images are only delivered to devices that can support them. This makes images faster and saves bandwidth for users with lower-DPR devices, while delivering the expected crispness of high-DPR imagery to those devices.
     *
     * The `dpr` parameter is best used with techniques such as `srcset`, so that you can define when you want high-DPR images to be served and at what ratios. For example, the code below will serve the following image sizes to a 500×300-pixel container, based on the specified value of `dpr`:
     *
     * ```html
     * <img srcset="/api/optimized-image/image.jpg?fit=crop&h=300&w=500&auto=enhance&dpr=1 1x,
     *              /api/optimized-image/image.jpg?fit=crop&h=300&w=500&auto=enhance&dpr=2 2x,
     *              /api/optimized-image/image.jpg?fit=crop&h=300&w=500&auto=enhance&dpr=3 3x"
     *      src="/api/optimized-image/image.jpg?fit=crop&h=300&w=500&auto=enhance"
     * />
     * ```
     *
     * | Value | Image Dimensions | Image Size |
     * |:-----:|:----------------:|:----------:|
     * | dpr=1 | 500×300          | 40.36kB    |
     * | dpr=2 | 1000×600         | 108.86kB   |
     * | dpr=3 | 1500×900         | 206.56kB   |
     *
     * For this image on a low-DPR device, setting `dpr=1` saves 60KB over `dpr=2`, resulting in a much faster load speed for that device. At the same time, setting `dpr=2` for high-DPR devices ensures that the image is as sharp as possible for those screens. You can see the difference below.
     */
    dpr: {
      display_name: "device pixel ratio",
      category: "pixel-density",
      available_in: [
        "url",
        "graph",
        "output"
      ],
      expects: [
        {
          type: "number",
          suggested_range: {
            min: 0.75,
            max: 5
          },
          strict_range: {
            min: 0,
            max: 5
          }
        }
      ],
      default: 1,
      url: "https://docs.imgix.com/apis/url/dpr",
      short_description: "Adjusts the device-pixel ratio of the output image."
    },
    // 'duotone-alpha': {
    //   display_name: 'duotone alpha',
    //   category: 'stylize',
    //   available_in: [
    //     'url',
    //     'graph'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       strict_range: {
    //         min: 0,
    //         max: 100
    //       }
    //     }
    //   ],
    //   default: 100,
    //   depends: [
    //     'duotone'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/stylize/duotone-alpha',
    //   short_description: 'Changes the alpha of the duotone effect atop the source image.'
    // },
    // duotone: {
    //   display_name: 'duotone',
    //   category: 'stylize',
    //   available_in: [
    //     'url',
    //     'graph'
    //   ],
    //   expects: [
    //     {
    //       0: [
    //         {
    //           type: 'hex_color'
    //         },
    //         {
    //           type: 'color_keyword'
    //         }
    //       ],
    //       1: [
    //         {
    //           type: 'hex_color'
    //         },
    //         {
    //           type: 'color_keyword'
    //         }
    //       ],
    //       type: 'list',
    //       length: 2
    //     }
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/stylize/duotone',
    //   short_description: 'Applies a duotone effect to the source image.'
    // },
    // exp: {
    //   display_name: 'exposure',
    //   category: 'adjustment',
    //   available_in: [
    //     'url',
    //     'graph'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       suggested_range: {
    //         min: -100,
    //         max: 100
    //       }
    //     }
    //   ],
    //   default: 0,
    //   url: 'https://docs.imgix.com/apis/url/adjustment/exp',
    //   short_description: 'Adjusts the exposure of the output image.'
    // },
    // expires: {
    //   display_name: 'URL expiration timestamp',
    //   category: 'expiration',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'timestamp'
    //     }
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/expires',
    //   short_description: 'A Unix timestamp specifying a UTC time. Requests made to this URL after that time will output a 404 status code.'
    // },
    // faceindex: {
    //   display_name: 'face index',
    //   category: 'face-detection',
    //   available_in: [
    //     'url',
    //     'graph'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       suggested_range: {
    //         min: 1
    //       }
    //     }
    //   ],
    //   depends: [
    //     'fit=facearea'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/face-detection/faceindex',
    //   short_description: 'Selects a face to crop to.'
    // },
    // facepad: {
    //   display_name: 'face padding',
    //   category: 'face-detection',
    //   available_in: [
    //     'url',
    //     'graph'
    //   ],
    //   expects: [
    //     {
    //       type: 'number',
    //       suggested_range: {
    //         min: 1,
    //         max: 10
    //       }
    //     }
    //   ],
    //   default: 1,
    //   depends: [
    //     'fit=facearea'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/face-detection/facepad',
    //   short_description: 'Adjusts padding around a selected face.'
    // },
    // faces: {
    //   display_name: 'json face data',
    //   category: 'face-detection',
    //   available_in: [
    //     'url',
    //     'graph'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       possible_values: [
    //         1
    //       ]
    //     }
    //   ],
    //   depends: [
    //     'fm=json'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/face-detection/faces',
    //   short_description: 'Specifies that face data should be included in output when combined with `fm=json`.'
    // },
    /**
     * The `fill-color` parameter specifies the solid color applied to the excess space of an image resized with `fit=fill` or `fit=fillmax`.
     * The parameter is dependent on the `fill=solid` mode.
     *
     * Valid color values are either a [color keyword](https://drafts.csswg.org/css-color/#named-colors) or 3- (RGB), 4- (ARGB) 6- (RRGGBB) or 8-digit (AARRGGBB) hexadecimal values.
     * The "A" in a 4- or 8-digit hex value represents the color's alpha transparency. The default is transparent white, `0FFF`.
     * When outputting image formats that do not support transparency (such as JPEG), set this value to a non-transparent color.
     */
    "fill-color": {
      display_name: "fill color",
      category: "fill",
      available_in: [
        "url"
      ],
      expects: [
        {
          type: "hex_color"
        },
        {
          type: "color_keyword"
        }
      ],
      aliases: [
        "fillcolor"
      ],
      default: "#fff",
      depends: [
        "fill=solid"
      ],
      url: "https://docs.imgix.com/apis/url/fill/fill-color",
      short_description: "Sets the fill color for images with additional space created by the fit setting"
    },
    /**
     * The `fill` parameter determines how the excess space in an image resized with `fit=fill` or `fit=fillmax` should be filled.
     *
     * Valid values are `solid`.
     *
     * ## fill=solid
     * Fills the excess space with the solid color specified by the `fill-color` parameter.
     * If no `fill-color` is specified, the excess space will be white or transparent, depending on whether the image output format supports transparency.
     */
    fill: {
      display_name: "fill mode",
      category: "fill",
      available_in: [
        "url"
      ],
      expects: [
        {
          type: "string",
          possible_values: [
            "solid"
            // 'blur'
          ]
        }
      ],
      depends: [
        "fit"
      ],
      url: "https://docs.imgix.com/apis/url/fill/fill",
      short_description: "Determines how to fill in additional space created by the fit setting"
    },
    /**
     *
     */
    fit: {
      display_name: "resize fit mode",
      category: "size",
      available_in: [
        "url",
        "graph"
      ],
      expects: [
        {
          type: "string",
          possible_values: [
            // 'clamp',
            "clip",
            "crop",
            // 'facearea',
            "fill",
            // 'fillmax',
            "max",
            "min",
            "scale"
          ]
        }
      ],
      default: "clip",
      aliases: [
        "f"
      ],
      url: "https://docs.imgix.com/apis/url/size/fit",
      short_description: "Specifies how to map the source image to the output image dimensions."
    },
    flip: {
      display_name: "flip axis",
      category: "rotation",
      available_in: [
        "url",
        "graph"
      ],
      expects: [
        {
          type: "string",
          possible_values: [
            "h",
            "v",
            "hv"
          ]
        }
      ],
      url: "https://docs.imgix.com/apis/url/rotation/flip",
      short_description: "Flips an image on a specified axis."
    },
    fm: {
      display_name: "output format",
      category: "format",
      available_in: [
        "url",
        "graph",
        "output"
      ],
      expects: [
        {
          type: "string",
          possible_values: [
            "gif",
            "jpg",
            "jpeg",
            // 'jp2',
            "json",
            // 'jxr',
            // 'pjpg',
            // 'mp4',
            "png",
            // 'png8',
            // 'png32',
            "webp",
            // 'svg',
            // 'webm',
            "tiff",
            "tif",
            "avif"
            // 'heif',
            // 'pdf'
          ]
        }
      ],
      url: "https://docs.imgix.com/apis/url/format/fm",
      short_description: "Changes the format of the output image."
    },
    // 'fp-debug': {
    //   display_name: 'focal point debug',
    //   category: 'focalpoint-crop',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'boolean'
    //     }
    //   ],
    //   default: false,
    //   depends: [
    //     'fit=crop',
    //     'crop=focalpoint'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/focalpoint-crop/fp-debug',
    //   short_description: 'Displays crosshairs identifying the location of the set focal point'
    // },
    "fp-x": {
      display_name: "focal point x position",
      category: "focalpoint-crop",
      available_in: [
        "url"
      ],
      expects: [
        {
          type: "unit_scalar",
          default: 0.5,
          strict_range: {
            min: 0,
            max: 1
          }
        }
      ],
      depends: [
        "fit=crop",
        "crop=focalpoint"
      ],
      url: "https://docs.imgix.com/apis/url/focalpoint-crop/fp-x",
      short_description: "Sets the relative horizontal value for the focal point of an image"
    },
    "fp-y": {
      display_name: "focal point y position",
      category: "focalpoint-crop",
      available_in: [
        "url"
      ],
      expects: [
        {
          type: "unit_scalar",
          default: 0.5,
          strict_range: {
            min: 0,
            max: 1
          }
        }
      ],
      depends: [
        "fit=crop",
        "crop=focalpoint"
      ],
      url: "https://docs.imgix.com/apis/url/focalpoint-crop/fp-y",
      short_description: "Sets the relative vertical value for the focal point of an image"
    },
    "fp-z": {
      display_name: "focal point zoom",
      category: "focalpoint-crop",
      available_in: [
        "url"
      ],
      expects: [
        {
          type: "integer",
          default: 1,
          suggested_range: {
            min: 1,
            max: 10
          },
          strict_range: {
            min: 1,
            max: 100
          }
        }
      ],
      depends: [
        "fit=crop",
        "crop=focalpoint"
      ],
      url: "https://docs.imgix.com/apis/url/focalpoint-crop/fp-z",
      short_description: "Sets the relative zoom value for the focal point of an image"
    },
    gam: {
      display_name: "gamma",
      category: "adjustment",
      available_in: [
        "url",
        "graph"
      ],
      expects: [
        {
          type: "integer",
          suggested_range: {
            min: -100,
            max: 100
          }
        }
      ],
      default: 0,
      url: "https://docs.imgix.com/apis/url/adjustment/gam",
      short_description: "Adjusts the gamma of the source image."
    },
    h: {
      display_name: "image height",
      category: "size",
      available_in: [
        "url",
        "graph"
      ],
      expects: [
        {
          type: "integer",
          strict_range: {
            min: 2,
            max: 134201344
          }
        },
        {
          type: "unit_scalar",
          strict_range: {
            min: 0,
            max: 1
          }
        }
      ],
      url: "https://docs.imgix.com/apis/url/size/h",
      short_description: "Adjusts the height of the output image."
    },
    // high: {
    //   display_name: 'highlight',
    //   category: 'adjustment',
    //   available_in: [
    //     'url',
    //     'graph'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       suggested_range: {
    //         min: -100,
    //         max: 0
    //       }
    //     }
    //   ],
    //   default: 0,
    //   url: 'https://docs.imgix.com/apis/url/adjustment/high',
    //   short_description: 'Adjusts the highlights of the source image.'
    // },
    // htn: {
    //   display_name: 'halftone',
    //   category: 'stylize',
    //   available_in: [
    //     'url',
    //     'graph'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       suggested_range: {
    //         min: 0,
    //         max: 100
    //       }
    //     }
    //   ],
    //   default: 0,
    //   url: 'https://docs.imgix.com/apis/url/stylize/htn',
    //   short_description: 'Applies a half-tone effect to the source image.'
    // },
    hue: {
      display_name: "hue shift",
      category: "adjustment",
      available_in: [
        "url",
        "graph"
      ],
      expects: [
        {
          type: "integer",
          suggested_range: {
            min: 0,
            max: 360
          }
        }
      ],
      default: 0,
      url: "https://docs.imgix.com/apis/url/adjustment/hue",
      short_description: "Adjusts the hue of the source image."
    },
    invert: {
      display_name: "invert",
      category: "adjustment",
      available_in: [
        "url",
        "graph"
      ],
      expects: [
        {
          type: "boolean"
        }
      ],
      aliases: [
        "inv"
      ],
      default: false,
      url: "https://docs.imgix.com/apis/url/adjustment/invert",
      short_description: "Inverts the colors on the source image."
    },
    lossless: {
      display_name: "lossless compression",
      category: "format",
      available_in: [
        "url",
        "graph",
        "output"
      ],
      expects: [
        {
          type: "boolean"
        }
      ],
      default: false,
      depends: [
        "auto=format",
        "fm=tif",
        "fm=tiff",
        "fm=jpg",
        "fm=jpeg",
        "fm=png",
        "fm=webp",
        "fm=avif"
      ],
      url: "https://docs.imgix.com/apis/url/format/lossless",
      short_description: "Specifies that the output image should be a lossless variant."
    },
    // 'mark-align': {
    //   display_name: 'watermark alignment mode',
    //   category: 'watermark',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'list',
    //       possible_values: [
    //         'top',
    //         'middle',
    //         'bottom',
    //         'left',
    //         'center',
    //         'right'
    //       ]
    //     }
    //   ],
    //   aliases: [
    //     'ma',
    //     'markalign'
    //   ],
    //   depends: [
    //     'mark'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/watermark/mark-align',
    //   short_description: 'Changes the watermark alignment relative to the parent image.'
    // },
    // 'mark-alpha': {
    //   display_name: 'watermark alpha',
    //   category: 'watermark',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       suggested_range: {
    //         min: 1,
    //         max: 100
    //       }
    //     }
    //   ],
    //   default: 100,
    //   aliases: [
    //     'markalpha',
    //     'malph'
    //   ],
    //   depends: [
    //     'mark'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/watermark/mark-alpha',
    //   short_description: 'Changes the alpha of the watermark image.'
    // },
    // 'mark-base': {
    //   display_name: 'watermark base url',
    //   category: 'watermark',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'url'
    //     },
    //     {
    //       type: 'path'
    //     }
    //   ],
    //   aliases: [
    //     'mb',
    //     'markbase'
    //   ],
    //   depends: [
    //     'mark'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/watermark/mark-base',
    //   short_description: 'Changes base URL of the watermark image.'
    // },
    // 'mark-fit': {
    //   display_name: 'watermark fit mode',
    //   category: 'watermark',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'string',
    //       possible_values: [
    //         'clip',
    //         'crop',
    //         'fill',
    //         'max',
    //         'scale'
    //       ]
    //     }
    //   ],
    //   default: 'clip',
    //   aliases: [
    //     'mf',
    //     'markfit'
    //   ],
    //   depends: [
    //     'mark',
    //     'markw',
    //     'markh'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/watermark/mark-fit',
    //   short_description: 'Specifies the fit mode for watermark images.'
    // },
    // 'mark-h': {
    //   display_name: 'watermark height',
    //   category: 'watermark',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       strict_range: {
    //         min: 2,
    //         max: 134201344
    //       }
    //     },
    //     {
    //       type: 'unit_scalar',
    //       strict_range: {
    //         min: 0,
    //         max: 1
    //       }
    //     }
    //   ],
    //   aliases: [
    //     'mh',
    //     'markh'
    //   ],
    //   depends: [
    //     'mark'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/watermark/mark-h',
    //   short_description: 'Adjusts the height of the watermark image.'
    // },
    // 'mark-pad': {
    //   display_name: 'watermark padding',
    //   category: 'watermark',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       suggested_range: {
    //         min: 0
    //       }
    //     }
    //   ],
    //   default: 10,
    //   aliases: [
    //     'mp',
    //     'markpad'
    //   ],
    //   depends: [
    //     'mark'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/watermark/mark-pad',
    //   short_description: 'Applies padding to the watermark image.'
    // },
    // 'mark-scale': {
    //   display_name: 'watermark scale',
    //   category: 'watermark',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       suggested_range: {
    //         min: 0,
    //         max: 100
    //       }
    //     }
    //   ],
    //   aliases: [
    //     'ms',
    //     'markscale'
    //   ],
    //   depends: [
    //     'mark'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/watermark/mark-scale',
    //   short_description: 'Adjusts the scale of the watermark image.'
    // },
    // 'mark-w': {
    //   display_name: 'watermark width',
    //   category: 'watermark',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       strict_range: {
    //         min: 2,
    //         max: 134201344
    //       }
    //     },
    //     {
    //       type: 'unit_scalar',
    //       strict_range: {
    //         min: 0,
    //         max: 1
    //       }
    //     }
    //   ],
    //   aliases: [
    //     'mw',
    //     'markw'
    //   ],
    //   depends: [
    //     'mark'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/watermark/mark-w',
    //   short_description: 'Adjusts the width of the watermark image.'
    // },
    // 'mark-x': {
    //   display_name: 'watermark x position',
    //   category: 'watermark',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       suggested_range: {
    //         min: 0
    //       }
    //     }
    //   ],
    //   aliases: [
    //     'mx',
    //     'markx'
    //   ],
    //   depends: [
    //     'mark'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/watermark/mark-x',
    //   short_description: 'Adjusts the x-offset of the watermark image relative to its parent.'
    // },
    // 'mark-y': {
    //   display_name: 'watermark y position',
    //   category: 'watermark',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       strict_range: {
    //         min: 0
    //       }
    //     }
    //   ],
    //   aliases: [
    //     'my',
    //     'marky'
    //   ],
    //   depends: [
    //     'mark'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/watermark/mark-y',
    //   short_description: 'Adjusts the y-offset of the watermark image relative to its parent.'
    // },
    // mark: {
    //   display_name: 'watermark image url',
    //   category: 'watermark',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'url'
    //     },
    //     {
    //       type: 'path'
    //     }
    //   ],
    //   aliases: [
    //     'm'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/watermark/mark',
    //   short_description: 'Specifies the location of the watermark image.'
    // },
    // mask: {
    //   display_name: 'mask type',
    //   category: 'mask',
    //   available_in: [
    //     'url',
    //     'graph'
    //   ],
    //   expects: [
    //     {
    //       type: 'string',
    //       possible_values: [
    //         'ellipse',
    //         'corners'
    //       ]
    //     },
    //     {
    //       type: 'url'
    //     },
    //     {
    //       type: 'path'
    //     }
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/mask',
    //   short_description: 'Defines the type of mask and specifies the URL if that type is selected.'
    // },
    // maskbg: {
    //   display_name: 'mask background color',
    //   category: 'mask',
    //   available_in: [
    //     'url',
    //     'graph'
    //   ],
    //   expects: [
    //     {
    //       type: 'hex_color'
    //     },
    //     {
    //       type: 'color_keyword'
    //     }
    //   ],
    //   default: '#fff',
    //   depends: [
    //     'mask'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/mask/mask-bg',
    //   short_description: 'Colors the background of the transparent mask area of images'
    // },
    "max-h": {
      display_name: "maximum height",
      category: "size",
      available_in: [
        "url"
      ],
      expects: [
        {
          type: "integer",
          strict_range: {
            min: 1,
            max: 134201344
          }
        }
      ],
      aliases: [
        "max-height"
      ],
      // depends: [
      //   'fit=crop'
      // ],
      url: "https://docs.imgix.com/apis/url/size/max-height",
      short_description: "Specifies the maximum height of the output image in pixels."
    },
    "max-w": {
      display_name: "maximum width",
      category: "size",
      available_in: [
        "url"
      ],
      expects: [
        {
          type: "integer",
          strict_range: {
            min: 1,
            max: 134201344
          }
        }
      ],
      aliases: [
        "max-width"
      ],
      // depends: [
      //   'fit=crop'
      // ],
      url: "https://docs.imgix.com/apis/url/size/max-width",
      short_description: "Specifies the maximum width of the output image in pixels."
    },
    "min-h": {
      display_name: "minimum height",
      category: "size",
      available_in: [
        "url"
      ],
      expects: [
        {
          type: "integer",
          strict_range: {
            min: 1,
            max: 134201344
          }
        }
      ],
      aliases: [
        "min-height"
      ],
      // depends: [
      //   'fit=crop'
      // ],
      url: "https://docs.imgix.com/apis/url/size/min-height",
      short_description: "Specifies the minimum height of the output image in pixels."
    },
    "min-w": {
      display_name: "minimum width",
      category: "size",
      available_in: [
        "url"
      ],
      expects: [
        {
          type: "integer",
          strict_range: {
            min: 1,
            max: 134201344
          }
        }
      ],
      aliases: [
        "min-width"
      ],
      // depends: [
      //   'fit=crop'
      // ],
      url: "https://docs.imgix.com/apis/url/size/min-width",
      short_description: "Specifies the minimum width of the output image in pixels."
    },
    monochrome: {
      display_name: "monochrome",
      category: "stylize",
      available_in: [
        "url",
        "graph"
      ],
      expects: [
        {
          type: "hex_color"
        },
        {
          type: "color_keyword"
        }
      ],
      aliases: [
        "mono"
      ],
      url: "https://docs.imgix.com/apis/url/stylize/monochrome",
      short_description: "Applies a monochrome effect to the source image."
    },
    // nr: {
    //   display_name: 'noise reduction bound',
    //   category: 'noise-reduction',
    //   available_in: [
    //     'url',
    //     'graph'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       suggested_range: {
    //         min: -100,
    //         max: 100
    //       }
    //     }
    //   ],
    //   default: 20,
    //   url: 'https://docs.imgix.com/apis/url/noise-reduction/nr',
    //   short_description: 'Reduces the noise in an image.'
    // },
    // nrs: {
    //   display_name: 'noise reduction sharpen',
    //   category: 'noise-reduction',
    //   available_in: [
    //     'url',
    //     'graph'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       suggested_range: {
    //         min: -100,
    //         max: 100
    //       }
    //     }
    //   ],
    //   default: 20,
    //   url: 'https://docs.imgix.com/apis/url/noise-reduction/nrs',
    //   short_description: 'Provides a threshold by which to sharpen an image.'
    // },
    // orient: {
    //   display_name: 'orientation',
    //   category: 'rotation',
    //   available_in: [
    //     'url',
    //     'graph'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       possible_values: [
    //         0,
    //         1,
    //         2,
    //         3,
    //         4,
    //         5,
    //         6,
    //         7,
    //         8,
    //         90,
    //         180,
    //         270
    //       ]
    //     }
    //   ],
    //   aliases: [
    //     'or'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/rotation/orient',
    //   short_description: 'Changes the image orientation.'
    // },
    // pad: {
    //   display_name: 'padding',
    //   category: 'border-and-padding',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       suggested_range: {
    //         min: 0
    //       }
    //     }
    //   ],
    //   default: 0,
    //   url: 'https://docs.imgix.com/apis/url/border-and-padding/pad',
    //   short_description: 'Pads an image.'
    // },
    // page: {
    //   display_name: 'pdf page number',
    //   category: 'pdf',
    //   available_in: [
    //     'url',
    //     'graph'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       suggested_range: {
    //         min: 1
    //       }
    //     }
    //   ],
    //   default: 1,
    //   url: 'https://docs.imgix.com/apis/url/pdf-page-number',
    //   short_description: 'Selects a page from a PDF for display.'
    // },
    // palette: {
    //   display_name: 'color palette extraction',
    //   category: 'color-palette',
    //   available_in: [
    //     'url',
    //     'output'
    //   ],
    //   expects: [
    //     {
    //       type: 'string',
    //       possible_values: [
    //         'css',
    //         'json'
    //       ]
    //     }
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/color-palette/palette',
    //   short_description: 'Specifies an output format for palette-extraction.'
    // },
    // prefix: {
    //   display_name: 'css prefix',
    //   category: 'color-palette',
    //   available_in: [
    //     'url',
    //     'output'
    //   ],
    //   expects: [
    //     {
    //       type: 'string'
    //     }
    //   ],
    //   default: 'image',
    //   depends: [
    //     'palette=css'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/color-palette/prefix',
    //   short_description: 'Specifies a CSS prefix for all classes in palette-extraction.'
    // },
    // px: {
    //   display_name: 'pixellate',
    //   category: 'stylize',
    //   available_in: [
    //     'url',
    //     'graph'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       suggested_range: {
    //         min: 0,
    //         max: 100
    //       }
    //     }
    //   ],
    //   default: 0,
    //   url: 'https://docs.imgix.com/apis/url/stylize/px',
    //   short_description: 'Applies a pixelation effect to an image.'
    // },
    q: {
      display_name: "output quality",
      category: "format",
      available_in: [
        "url",
        "graph",
        "output"
      ],
      expects: [
        {
          type: "integer",
          suggested_range: {
            min: 0,
            max: 100
          }
        }
      ],
      default: 75,
      depends: [
        "auto=format",
        "fm=jpg",
        "fm=jpeg",
        "fm=tif",
        "fm=tiff",
        "fm=avif",
        "fm=webp",
        "fm=png"
      ],
      url: "https://docs.imgix.com/apis/url/format/q",
      short_description: "Adjusts the quality of an output image."
    },
    // rect: {
    //   display_name: 'source rectangle region',
    //   category: 'size',
    //   available_in: [
    //     'url',
    //     'graph'
    //   ],
    //   expects: [
    //     {
    //       0: [
    //         {
    //           type: 'integer',
    //           strict_range: {
    //             min: 0
    //           }
    //         },
    //         {
    //           type: 'string',
    //           possible_values: [
    //             'left',
    //             'center',
    //             'right'
    //           ]
    //         }
    //       ],
    //       1: [
    //         {
    //           type: 'integer',
    //           strict_range: {
    //             min: 0
    //           }
    //         },
    //         {
    //           type: 'string',
    //           possible_values: [
    //             'top',
    //             'middle',
    //             'bottom'
    //           ]
    //         }
    //       ],
    //       2: [
    //         {
    //           type: 'integer',
    //           strict_range: {
    //             min: 1
    //           }
    //         }
    //       ],
    //       3: [
    //         {
    //           type: 'integer',
    //           strict_range: {
    //             min: 1
    //           }
    //         }
    //       ],
    //       type: 'list'
    //     }
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/size/rect',
    //   short_description: 'Crops an image to a specified rectangle.'
    // },
    rot: {
      display_name: "rotation",
      category: "rotation",
      available_in: [
        "url",
        "graph"
      ],
      expects: [
        {
          type: "number",
          suggested_range: {
            min: 0,
            max: 359
          }
        }
      ],
      default: 0,
      url: "https://docs.imgix.com/apis/url/rotation/rot",
      short_description: "Rotates an image by a specified number of degrees."
    },
    sat: {
      display_name: "saturation",
      category: "adjustment",
      available_in: [
        "url",
        "graph"
      ],
      expects: [
        {
          type: "integer",
          suggested_range: {
            min: -100,
            max: 100
          }
        }
      ],
      default: 0,
      url: "https://docs.imgix.com/apis/url/adjustment/sat",
      short_description: "Adjusts the saturation of an image."
    },
    sepia: {
      display_name: "sepia tone",
      category: "stylize",
      available_in: [
        "url",
        "graph"
      ],
      expects: [
        {
          type: "integer",
          suggested_range: {
            min: 0,
            max: 100
          }
        }
      ],
      default: 0,
      url: "https://docs.imgix.com/apis/url/stylize/sepia",
      short_description: "Applies a sepia effect to an image."
    },
    // shad: {
    //   display_name: 'shadow',
    //   category: 'adjustment',
    //   available_in: [
    //     'url',
    //     'graph'
    //   ],
    //   expects: [
    //     {
    //       type: 'number',
    //       suggested_range: {
    //         min: 0,
    //         max: 100
    //       }
    //     }
    //   ],
    //   default: 0,
    //   url: 'https://docs.imgix.com/apis/url/adjustment/shad',
    //   short_description: 'Adjusts the highlights of the source image.'
    // },
    sharp: {
      display_name: "sharpen",
      category: "adjustment",
      available_in: [
        "url",
        "graph"
      ],
      expects: [
        {
          type: "number",
          suggested_range: {
            min: 0,
            max: 100
          }
        }
      ],
      default: 0,
      url: "https://docs.imgix.com/apis/url/adjustment/sharp",
      short_description: "Adjusts the sharpness of the source image."
    },
    // 'trim-color': {
    //   display_name: 'trim color',
    //   category: 'trim',
    //   available_in: [
    //     'url',
    //     'graph'
    //   ],
    //   expects: [
    //     {
    //       type: 'hex_color'
    //     },
    //     {
    //       type: 'color_keyword'
    //     }
    //   ],
    //   aliases: [
    //     'trimcolor'
    //   ],
    //   depends: [
    //     'trim=color'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/trim/trim-color',
    //   short_description: 'Specifies a trim color on a trim operation.'
    // },
    // 'trim-md': {
    //   display_name: 'trim mean difference',
    //   category: 'trim',
    //   available_in: [
    //     'url',
    //     'graph'
    //   ],
    //   expects: [
    //     {
    //       type: 'number',
    //       suggested_range: {
    //         min: 0
    //       }
    //     }
    //   ],
    //   aliases: [
    //     'trimmd'
    //   ],
    //   default: 11,
    //   depends: [
    //     'trim=auto'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/trim/trim-md',
    //   short_description: 'Specifies the mean difference on a trim operation.'
    // },
    // 'trim-pad': {
    //   display_name: 'trim padding',
    //   category: 'trim',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       suggested_range: {
    //         min: 0
    //       }
    //     }
    //   ],
    //   default: 0,
    //   aliases: [
    //     'trimpad'
    //   ],
    //   depends: [
    //     'trim'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/trim/trim-pad',
    //   short_description: 'Pads the area of the source image before trimming.'
    // },
    // 'trim-sd': {
    //   display_name: 'trim standard deviation',
    //   category: 'trim',
    //   available_in: [
    //     'url',
    //     'graph'
    //   ],
    //   expects: [
    //     {
    //       type: 'number',
    //       suggested_range: {
    //         min: 0
    //       }
    //     }
    //   ],
    //   aliases: [
    //     'trimsd'
    //   ],
    //   default: 10,
    //   depends: [
    //     'trim=auto'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/trim/trim-sd',
    //   short_description: 'Specifies the standard deviation on a trim operation.'
    // },
    // 'trim-tol': {
    //   display_name: 'trim tolerance',
    //   category: 'trim',
    //   available_in: [
    //     'url',
    //     'graph'
    //   ],
    //   expects: [
    //     {
    //       type: 'number',
    //       suggested_range: {
    //         min: 0
    //       }
    //     }
    //   ],
    //   aliases: [
    //     'trimtol'
    //   ],
    //   default: 0,
    //   depends: [
    //     'trim=color'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/trim/trim-tol',
    //   short_description: 'Specifies the tolerance on a trim operation.'
    // },
    // trim: {
    //   display_name: 'trim image',
    //   category: 'trim',
    //   available_in: [
    //     'url',
    //     'graph'
    //   ],
    //   expects: [
    //     {
    //       type: 'string',
    //       possible_values: [
    //         'auto',
    //         'color'
    //       ]
    //     }
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/trim/trim',
    //   short_description: 'Trims the source image.'
    // },
    // 'txt-align': {
    //   display_name: 'text align',
    //   category: 'text',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'list',
    //       possible_values: [
    //         'top',
    //         'middle',
    //         'bottom',
    //         'left',
    //         'center',
    //         'right'
    //       ]
    //     }
    //   ],
    //   aliases: [
    //     'txtalign',
    //     'ta'
    //   ],
    //   depends: [
    //     'txt'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/text/txt-align',
    //   short_description: 'Sets the vertical and horizontal alignment of rendered text relative to the base image.'
    // },
    // 'txt-clip': {
    //   display_name: 'text clipping mode',
    //   category: 'text',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'list',
    //       possible_values: [
    //         'start',
    //         'middle',
    //         'end',
    //         'ellipsis'
    //       ]
    //     }
    //   ],
    //   default: 'end',
    //   aliases: [
    //     'txtclip',
    //     'tcl'
    //   ],
    //   depends: [
    //     'txt'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/text/txt-clip',
    //   short_description: 'Sets the clipping properties of rendered text.'
    // },
    // 'txt-color': {
    //   display_name: 'text color',
    //   category: 'text',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'hex_color'
    //     },
    //     {
    //       type: 'color_keyword'
    //     }
    //   ],
    //   aliases: [
    //     'txtcolor',
    //     'txt-clr',
    //     'txtclr',
    //     'tc'
    //   ],
    //   depends: [
    //     'txt'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/text/txt-color',
    //   short_description: 'Specifies the color of rendered text.'
    // },
    // 'txt-fit': {
    //   display_name: 'text fit mode',
    //   category: 'text',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'string',
    //       possible_values: [
    //         'max'
    //       ]
    //     }
    //   ],
    //   aliases: [
    //     'txtfit'
    //   ],
    //   depends: [
    //     'txt'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/text/txt-fit',
    //   short_description: 'Specifies the fit approach for rendered text.'
    // },
    // 'txt-font': {
    //   display_name: 'text font',
    //   category: 'text',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'font'
    //     }
    //   ],
    //   aliases: [
    //     'tf',
    //     'txtfont'
    //   ],
    //   depends: [
    //     'txt'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/text/txt-font',
    //   short_description: 'Selects a font for rendered text.'
    // },
    // 'txt-lead': {
    //   display_name: 'text leading',
    //   category: 'typesetting',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       suggested_range: {
    //         min: 0
    //       }
    //     }
    //   ],
    //   aliases: [
    //     'txtlead'
    //   ],
    //   default: 0,
    //   depends: [
    //     'txt'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/typesetting/txt-lead',
    //   short_description: 'Sets the leading (line spacing) for rendered text. Only works on the multi-line text endpoint.'
    // },
    // 'txt-lig': {
    //   display_name: 'text ligatures',
    //   category: 'text',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       possible_values: [
    //         0,
    //         1,
    //         2
    //       ]
    //     }
    //   ],
    //   aliases: [
    //     'txtlig'
    //   ],
    //   depends: [
    //     'txt'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/text/txt-lig',
    //   short_description: 'Controls the level of ligature substitution'
    // },
    // 'txt-line-color': {
    //   display_name: 'text outline color',
    //   category: 'text',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'hex_color'
    //     },
    //     {
    //       type: 'color_keyword'
    //     }
    //   ],
    //   default: '#fff',
    //   aliases: [
    //     'txtlinecolor',
    //     'txt-line-clr',
    //     'txtlineclr'
    //   ],
    //   depends: [
    //     'txt',
    //     'txtline'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/text/txt-line-color',
    //   short_description: 'Specifies a text outline color.'
    // },
    // 'txt-line': {
    //   display_name: 'text outline',
    //   category: 'text',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       suggested_range: {
    //         min: 0
    //       }
    //     }
    //   ],
    //   default: 0,
    //   aliases: [
    //     'txtline',
    //     'tl'
    //   ],
    //   depends: [
    //     'txt'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/text/txt-line',
    //   short_description: 'Outlines the rendered text with a specified color.'
    // },
    // 'txt-pad': {
    //   display_name: 'text padding',
    //   category: 'text',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       default: 10,
    //       suggested_range: {
    //         min: 0
    //       }
    //     }
    //   ],
    //   aliases: [
    //     'txtpad',
    //     'tp'
    //   ],
    //   depends: [
    //     'txt'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/text/txt-pad',
    //   short_description: 'Specifies the padding (in device-independent pixels) between a textbox and the edges of the base image.'
    // },
    // 'txt-shad': {
    //   display_name: 'text shadow',
    //   category: 'text',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'number',
    //       suggested_range: {
    //         min: 0,
    //         max: 10
    //       }
    //     }
    //   ],
    //   default: 0,
    //   aliases: [
    //     'txtshad',
    //     'tsh'
    //   ],
    //   depends: [
    //     'txt'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/text/txt-shad',
    //   short_description: 'Applies a shadow to rendered text.'
    // },
    // 'txt-size': {
    //   display_name: 'text font size',
    //   category: 'text',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       suggested_range: {
    //         min: 0
    //       }
    //     }
    //   ],
    //   default: 12,
    //   aliases: [
    //     'tsz',
    //     'txtsize'
    //   ],
    //   depends: [
    //     'txt'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/text/txt-size',
    //   short_description: 'Sets the font size of rendered text.'
    // },
    // 'txt-track': {
    //   display_name: 'text tracking',
    //   category: 'typesetting',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       suggested_range: {
    //         min: -4
    //       }
    //     }
    //   ],
    //   default: 0,
    //   aliases: [
    //     'txttrack',
    //     'tt'
    //   ],
    //   depends: [
    //     'txt'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/typesetting/txt-track',
    //   short_description: 'Sets the tracking (letter spacing) for rendered text. Only works on the multi-line text endpoint.'
    // },
    // 'txt-width': {
    //   display_name: 'text width',
    //   category: 'text',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       suggested_range: {
    //         min: 0
    //       }
    //     }
    //   ],
    //   aliases: [
    //     'txtwidth'
    //   ],
    //   depends: [
    //     'txt'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/text/txt-width',
    //   short_description: 'Sets the width of rendered text.'
    // },
    // txt: {
    //   display_name: 'text string',
    //   category: 'text',
    //   available_in: [
    //     'url'
    //   ],
    //   expects: [
    //     {
    //       type: 'string'
    //     }
    //   ],
    //   aliases: [
    //     't'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/text/txt',
    //   short_description: 'Sets the text string to render.'
    // },
    // usm: {
    //   display_name: 'unsharp mask',
    //   category: 'adjustment',
    //   available_in: [
    //     'url',
    //     'graph'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       suggested_range: {
    //         min: -100,
    //         max: 100
    //       }
    //     }
    //   ],
    //   default: 0,
    //   url: 'https://docs.imgix.com/apis/url/adjustment/usm',
    //   short_description: 'Sharpens the source image using an unsharp mask.'
    // },
    // usmrad: {
    //   display_name: 'unsharp mask radius',
    //   category: 'adjustment',
    //   available_in: [
    //     'url',
    //     'graph'
    //   ],
    //   expects: [
    //     {
    //       type: 'number',
    //       suggested_range: {
    //         min: 0
    //       }
    //     }
    //   ],
    //   default: 2.5,
    //   depends: [
    //     'usm'
    //   ],
    //   url: 'https://docs.imgix.com/apis/url/adjustment/usmrad',
    //   short_description: 'Specifies the radius for an unsharp mask operation.'
    // },
    // vib: {
    //   display_name: 'vibrance',
    //   category: 'adjustment',
    //   available_in: [
    //     'url',
    //     'graph'
    //   ],
    //   expects: [
    //     {
    //       type: 'integer',
    //       suggested_range: {
    //         min: -100,
    //         max: 100
    //       }
    //     }
    //   ],
    //   default: 0,
    //   url: 'https://docs.imgix.com/apis/url/adjustment/vib',
    //   short_description: 'Adjusts the vibrance of an image.'
    // },
    w: {
      display_name: "image width",
      category: "size",
      available_in: [
        "url",
        "graph"
      ],
      expects: [
        {
          type: "integer",
          strict_range: {
            min: 2,
            max: 134201344
          }
        },
        {
          type: "unit_scalar",
          strict_range: {
            min: 0,
            max: 1
          }
        }
      ],
      url: "https://docs.imgix.com/apis/url/size/w",
      short_description: "Adjusts the width of the output image."
    }
  },
  aliases: {
    blendalign: "blend-align",
    ba: "blend-align",
    blendalpha: "blend-alpha",
    balph: "blend-alpha",
    blendcrop: "blend-crop",
    bc: "blend-crop",
    blendfit: "blend-fit",
    bf: "blend-fit",
    blendh: "blend-h",
    bh: "blend-h",
    blendmode: "blend-mode",
    bm: "blend-mode",
    blendpad: "blend-pad",
    bp: "blend-pad",
    blendsize: "blend-size",
    bs: "blend-size",
    blendw: "blend-w",
    bw: "blend-w",
    blendx: "blend-x",
    bx: "blend-x",
    blendy: "blend-y",
    by: "blend-y",
    b: "blend",
    fillcolor: "fill-color",
    f: "fit",
    inv: "invert",
    ma: "mark-align",
    markalign: "mark-align",
    markalpha: "mark-alpha",
    malph: "mark-alpha",
    mb: "mark-base",
    markbase: "mark-base",
    mf: "mark-fit",
    markfit: "mark-fit",
    mh: "mark-h",
    markh: "mark-h",
    mp: "mark-pad",
    markpad: "mark-pad",
    ms: "mark-scale",
    markscale: "mark-scale",
    mw: "mark-w",
    markw: "mark-w",
    mx: "mark-x",
    markx: "mark-x",
    my: "mark-y",
    marky: "mark-y",
    m: "mark",
    "max-height": "max-h",
    "max-width": "max-w",
    "min-height": "min-h",
    "min-width": "min-w",
    mono: "monochrome",
    or: "orient",
    trimcolor: "trim-color",
    trimmd: "trim-md",
    trimpad: "trim-pad",
    trimsd: "trim-sd",
    trimtol: "trim-tol",
    txtalign: "txt-align",
    ta: "txt-align",
    txtclip: "txt-clip",
    tcl: "txt-clip",
    txtcolor: "txt-color",
    "txt-clr": "txt-color",
    txtclr: "txt-color",
    tc: "txt-color",
    txtfit: "txt-fit",
    tf: "txt-font",
    txtfont: "txt-font",
    txtlead: "txt-lead",
    txtlig: "txt-lig",
    txtlinecolor: "txt-line-color",
    "txt-line-clr": "txt-line-color",
    txtlineclr: "txt-line-color",
    txtline: "txt-line",
    tl: "txt-line",
    txtpad: "txt-pad",
    tp: "txt-pad",
    txtshad: "txt-shad",
    tsh: "txt-shad",
    tsz: "txt-size",
    txtsize: "txt-size",
    txttrack: "txt-track",
    tt: "txt-track",
    txtwidth: "txt-width",
    t: "txt"
  },
  categoryValues: [
    "adjustment",
    "animation",
    "auto",
    "blending",
    "border-and-padding",
    "color-palette",
    "expiration",
    "face-detection",
    "fill",
    "focalpoint-crop",
    "format",
    "mask",
    "misc",
    "noise-reduction",
    "pdf",
    "pixel-density",
    "rotation",
    "size",
    "stylize",
    "text",
    "typesetting",
    "trim",
    "watermark"
  ],
  colorKeywordValues: [
    "aliceblue",
    "antiquewhite",
    "aqua",
    "aquamarine",
    "azure",
    "beige",
    "bisque",
    "black",
    "blanchedalmond",
    "blue",
    "blueviolet",
    "brown",
    "burlywood",
    "cadetblue",
    "chartreuse",
    "chocolate",
    "coral",
    "cornflowerblue",
    "cornsilk",
    "crimson",
    "cyan",
    "darkblue",
    "darkcyan",
    "darkgoldenrod",
    "darkgray",
    "darkgreen",
    "darkgrey",
    "darkkhaki",
    "darkmagenta",
    "darkolivegreen",
    "darkorange",
    "darkorchid",
    "darkred",
    "darksalmon",
    "darkseagreen",
    "darkslateblue",
    "darkslategray",
    "darkslategrey",
    "darkturquoise",
    "darkviolet",
    "deeppink",
    "deepskyblue",
    "dimgray",
    "dimgrey",
    "dodgerblue",
    "firebrick",
    "floralwhite",
    "forestgreen",
    "fuchsia",
    "gainsboro",
    "ghostwhite",
    "gold",
    "goldenrod",
    "gray",
    "green",
    "greenyellow",
    "grey",
    "honeydew",
    "hotpink",
    "imgixorange",
    "imgixblue",
    "indianred",
    "indigo",
    "ivory",
    "khaki",
    "lavender",
    "lavenderblush",
    "lawngreen",
    "lemonchiffon",
    "lightblue",
    "lightcoral",
    "lightcyan",
    "lightgoldenrodyellow",
    "lightgray",
    "lightgreen",
    "lightgrey",
    "lightpink",
    "lightsalmon",
    "lightseagreen",
    "lightskyblue",
    "lightslategray",
    "lightslategrey",
    "lightsteelblue",
    "lightyellow",
    "lime",
    "limegreen",
    "linen",
    "magenta",
    "maroon",
    "mediumaquamarine",
    "mediumblue",
    "mediumorchid",
    "mediumpurple",
    "mediumseagreen",
    "mediumslateblue",
    "mediumspringgreen",
    "mediumturquoise",
    "mediumvioletred",
    "midnightblue",
    "mintcream",
    "mistyrose",
    "moccasin",
    "navajowhite",
    "navy",
    "oldlace",
    "olive",
    "olivedrab",
    "orange",
    "orangered",
    "orchid",
    "palegoldenrod",
    "palegreen",
    "paleturquoise",
    "palevioletred",
    "papayawhip",
    "peachpuff",
    "peru",
    "pink",
    "plum",
    "powderblue",
    "purple",
    "rebeccapurple",
    "red",
    "rosybrown",
    "royalblue",
    "saddlebrown",
    "salmon",
    "sandybrown",
    "seagreen",
    "seashell",
    "sienna",
    "silver",
    "skyblue",
    "slateblue",
    "slategray",
    "slategrey",
    "snow",
    "springgreen",
    "steelblue",
    "tan",
    "teal",
    "thistle",
    "tomato",
    "turquoise",
    "violet",
    "wheat",
    "white",
    "whitesmoke",
    "yellow",
    "yellowgreen"
  ],
  fontValues: [
    "serif",
    "sans-serif",
    "monospace",
    "cursive",
    "fantasy",
    "serif,bold",
    "sans-serif,bold",
    "monospace,bold",
    "fantasy,bold",
    "serif,italic",
    "sans-serif,italic",
    "monospace,italic",
    "serif,bold,italic",
    "sans-serif,bold,italic",
    "monospace,bold,italic",
    "American Typewriter",
    "American Typewriter Condensed",
    "American Typewriter Condensed Light",
    "American Typewriter Condensed,Bold",
    "American Typewriter Light",
    "American Typewriter,Bold",
    "AndaleMono",
    "Arial Narrow",
    "Arial Narrow,Bold",
    "Arial Narrow,BoldItalic",
    "Arial Narrow,Italic",
    "Arial Rounded MT,Bold",
    "Arial UnicodeMS",
    "Arial,BoldItalicMT",
    "Arial,BoldMT",
    "Arial,ItalicMT",
    "Arial-Black",
    "ArialMT",
    "Athelas,Bold",
    "Athelas,BoldItalic",
    "Athelas,Italic",
    "Athelas-Regular",
    "Avenir Next Condensed Demi,Bold",
    "Avenir Next Condensed Demi,BoldItalic",
    "Avenir Next Condensed Heavy",
    "Avenir Next Condensed Heavy,Italic",
    "Avenir Next Condensed Medium",
    "Avenir Next Condensed Medium,Italic",
    "Avenir Next Condensed Regular",
    "Avenir Next Condensed Ultra Light",
    "Avenir Next Condensed Ultra Light,Italic",
    "Avenir Next Condensed,Bold",
    "Avenir Next Condensed,BoldItalic",
    "Avenir Next Condensed,Italic",
    "Avenir Next Demi,Bold",
    "Avenir Next Demi,BoldItalic",
    "Avenir Next Heavy",
    "Avenir Next Heavy,Italic",
    "Avenir Next Medium",
    "Avenir Next Medium,Italic",
    "Avenir Next Regular",
    "Avenir Next Ultra Light",
    "Avenir Next Ultra Light,Italic",
    "Avenir Next,Bold",
    "Avenir Next,BoldItalic",
    "Avenir Next,Italic",
    "Avenir-Black",
    "Avenir-BlackOblique",
    "Avenir-Book",
    "Avenir-BookOblique",
    "Avenir-Heavy",
    "Avenir-HeavyOblique",
    "Avenir-Light",
    "Avenir-LightOblique",
    "Avenir-Medium",
    "Avenir-MediumOblique",
    "Avenir-Oblique",
    "Avenir-Roman",
    "Baskerville",
    "Baskerville,Bold",
    "Baskerville,BoldItalic",
    "Baskerville,Italic",
    "BigCaslon-Medium",
    "BrushScriptMT",
    "Chalkboard",
    "Chalkboard SE Light",
    "Chalkboard SE Regular",
    "Chalkboard SE,Bold",
    "Chalkboard,Bold",
    "Chalkduster",
    "CharcoalCY",
    "Charter Black,Italic",
    "Charter,Bold",
    "Charter,BoldItalic",
    "Charter,Italic",
    "Charter-Black",
    "Charter-Roman",
    "Cochin",
    "Cochin,Bold",
    "Cochin,BoldItalic",
    "Cochin,Italic",
    "Comic Sans MS,Bold",
    "ComicSansMS",
    "Copperplate",
    "Copperplate,Bold",
    "Copperplate-Light",
    "Courier",
    "Courier New,Bold",
    "Courier New,BoldItalic",
    "Courier New,Italic",
    "Courier,Bold",
    "Courier-Oblique",
    "CourierNewPSMT",
    "DIN Alternate,Bold",
    "DIN Condensed,Bold",
    "Didot",
    "Didot,Bold",
    "Didot,Italic",
    "Futura Medium,Italic",
    "Futura-CondensedMedium",
    "Futura-Medium",
    "Geneva",
    "GenevaCyr",
    "Georgia",
    "Georgia,Bold",
    "Georgia,BoldItalic",
    "Georgia,Italic",
    "Gill Sans",
    "Gill Sans Light,Italic",
    "Gill Sans,Bold",
    "Gill Sans,BoldItalic",
    "Gill Sans,UltraBold",
    "GillSans,Italic",
    "GillSans-Light",
    "Helvetica",
    "Helvetica CY,Bold",
    "Helvetica Neue",
    "Helvetica Neue Condensed Black",
    "Helvetica Neue Condensed,Bold",
    "Helvetica Neue Light",
    "Helvetica Neue Light,Italic",
    "Helvetica Neue Medium",
    "Helvetica Neue Medium,Italic",
    "Helvetica Neue Thin",
    "Helvetica Neue Thin,Italic",
    "Helvetica Neue UltraLight",
    "Helvetica Neue UltraLight,Italic",
    "Helvetica Neue,Bold",
    "Helvetica Neue,BoldItalic",
    "Helvetica Neue,Italic",
    "Helvetica,Bold",
    "Helvetica-Light",
    "Helvetica-LightOblique",
    "Helvetica-Oblique",
    "HelveticaCY-Oblique",
    "HelveticaCY-Plain",
    "Herculanum",
    "Hoefler Text Black,Italic",
    "Hoefler Text,Italic",
    "HoeflerText-Black",
    "HoeflerText-Ornaments",
    "HoeflerText-Regular",
    "Impact",
    "Iowan Old Style Black,Italic",
    "Iowan Old Style,Bold",
    "Iowan Old Style,BoldItalic",
    "Iowan Old Style,Italic",
    "IowanOldStyle-Black",
    "IowanOldStyle-Roman",
    "IowanOldStyle-Titling",
    "Lucida Grande",
    "Lucida Grande,Bold",
    "Marion,Bold",
    "Marion,Italic",
    "Marion-Regular",
    "Marker Felt Thin",
    "Marker Felt Wide",
    "Menlo,Bold",
    "Menlo,BoldItalic",
    "Menlo,Italic",
    "Menlo-Regular",
    "Monaco",
    "Noteworthy,Bold",
    "Noteworthy-Light",
    "Optima,Bold",
    "Optima,BoldItalic",
    "Optima,Italic",
    "Optima-ExtraBlack",
    "Optima-Regular",
    "PT Mono,Bold",
    "PT Sans Caption,Bold",
    "PT Sans Narrow,Bold",
    "PT Sans,Bold",
    "PT Sans,BoldItalic",
    "PT Sans,Italic",
    "PT Serif Caption,Italic",
    "PT Serif,Bold",
    "PT Serif,BoldItalic",
    "PT Serif,Italic",
    "PTMono-Regular",
    "PTSans-Caption",
    "PTSans-Narrow",
    "PTSans-Regular",
    "PTSerif-Caption",
    "PTSerif-Regular",
    "Palatino,Bold",
    "Palatino,BoldItalic",
    "Palatino,Italic",
    "Palatino-Roman",
    "Papyrus",
    "Papyrus-Condensed",
    "PlantagenetCherokee",
    "STBaoli-SC-Regular",
    "STYuanti-SC-Light",
    "STYuanti-SC-Regular",
    "SavoyeLetPlain",
    "Seravek",
    "Seravek ExtraLight, Italic",
    "Seravek Light,Italic",
    "Seravek Medium,Italic",
    "Seravek,Bold",
    "Seravek,BoldItalic",
    "Seravek,Italic",
    "Seravek-ExtraLight",
    "Seravek-Light",
    "Seravek-Medium",
    "Skia-Regular",
    "Skia-Regular_Black",
    "Skia-Regular_Black-Condensed",
    "Skia-Regular_Black-Extended",
    "Skia-Regular_Condensed",
    "Skia-Regular_Extended",
    "Skia-Regular_Light",
    "Skia-Regular_Light-Condensed",
    "Skia-Regular_Light-Extended",
    "Snell Roundhand,Bold",
    "SnellRoundhand",
    "SnellRoundhand-Black",
    "Superclarendon Black,Italic",
    "Superclarendon Light,Italic",
    "Superclarendon,Bold",
    "Superclarendon,BoldItalic",
    "Superclarendon,Italic",
    "Superclarendon-Black",
    "Superclarendon-Light",
    "Superclarendon-Regular",
    "Tahoma",
    "Tahoma,Bold",
    "Times New Roman,Bold",
    "Times New Roman,BoldItalic",
    "Times New Roman,Italic",
    "Times,Bold",
    "Times,BoldItalic",
    "Times,Italic",
    "Times-Roman",
    "TimesNewRomanPSMT",
    "Trebuchet MS,Bold",
    "Trebuchet MS,BoldItalic",
    "Trebuchet MS,Italic",
    "TrebuchetMS",
    "Verdana",
    "Verdana,Bold",
    "Verdana,BoldItalic",
    "Verdana,Italic",
    "Waseem",
    "WaseemLight",
    "Webdings",
    "Wingdings-Regular",
    "Wingdings2",
    "Wingdings3",
    "Yuanti SC,Bold",
    "YuppySC-Regular",
    "Zapf Dingbats",
    "Zapfino"
  ]
};
var literalSchema = schema;
var genericSchema = schema;
var supportedFormats = schema.parameters.fm.expects[0].possible_values;
var fitModes = schema.parameters.fit.expects[0].possible_values;
var cropModes = schema.parameters.crop.expects[0].possible_values;
var defaultParamaters = {
  "fill-color": literalSchema.parameters["fill-color"].default,
  "fp-x": literalSchema.parameters["fp-x"].expects[0].default,
  "fp-y": literalSchema.parameters["fp-y"].expects[0].default,
  "fp-z": literalSchema.parameters["fp-z"].expects[0].default,
  "max-h": void 0,
  "max-w": void 0,
  "min-h": void 0,
  "min-w": void 0,
  ar: void 0,
  auto: ["format"],
  blur: literalSchema.parameters.blur.default,
  bri: literalSchema.parameters.bri.default,
  crop: ["bottom", "left"],
  dpr: literalSchema.parameters.dpr.default,
  fill: void 0,
  fit: literalSchema.parameters.fit.default,
  flip: void 0,
  fm: void 0,
  gam: literalSchema.parameters.gam.default,
  h: void 0,
  hue: literalSchema.parameters.hue.default,
  invert: literalSchema.parameters.invert.default,
  lossless: literalSchema.parameters.lossless.default,
  monochrome: void 0,
  q: literalSchema.parameters.q.default,
  rot: literalSchema.parameters.rot.default,
  sat: literalSchema.parameters.sat.default,
  sepia: literalSchema.parameters.sepia.default,
  sharp: literalSchema.parameters.sharp.default,
  w: void 0
};

// src/index.ts
var version = package_default.version;
export {
  AWS_COGNITO_USER_GROUP,
  Area,
  ArrayField,
  Automation,
  AutomationActions,
  AutomationDefinition,
  AutomationStatus,
  AutomationTargetTypes,
  BASE_VARIANT_NAME,
  BoolField,
  CONTENT_SINGLETON_ID,
  ColorField,
  ColorFormats,
  ContentModel2 as ContentModel,
  ContentModelDefinition,
  ContentStatus,
  ContentUpdateStrategy,
  DateField,
  DateModes,
  DateTimeField,
  DeepMergeStrategy,
  DefaultMediaFileDefinition_default as DefaultMediaFileDefinition,
  DefaultSettings_default as DefaultSettings,
  DefaultUserDefinition_default as DefaultUserDefinition,
  FieldGridSize,
  GLBField,
  GenericMediaField,
  GraphQLGenerator,
  ImageField,
  JSONField,
  MEDIA_FILE_CONTENT_MODEL_ID,
  MapField,
  MinimumACL,
  MutationAction,
  NumberField,
  PUBLIC_USER,
  Panorama360Field,
  ReferenceField,
  RepeaterField,
  RepeaterReferenceResolutionStrategy,
  RichTextField,
  RichTextModes,
  SelectField,
  TextField,
  TitleField,
  UNKNOWN_SCHEMA_HASH,
  URLField,
  USER_CONTENT_MODEL_ID,
  Variant,
  aclToString_default as aclToString,
  capitalize_default as capitalize,
  contentIDField_default as contentIDField,
  deepmerge,
  fieldTypes,
  flattenArray,
  flattenArrayDeep,
  floatToSortableString_default as floatToSortableString,
  getAutomationBotUser,
  getContentBasicFields_default as getContentBasicFields,
  getDefaultDataBySchema,
  getDefaultFieldValue,
  getFieldsBySchema,
  getGlobalQueryStatus_default as getGlobalQueryStatus,
  getGlobalQueryVariants_default as getGlobalQueryVariants,
  getTitleInfoForInput_default as getTitleInfoForInput,
  getUndefinedForField_default as getUndefinedForField,
  graphqlEscape_default as graphqlEscape,
  isMimeType_default as isMimeType,
  isNil_default as isNil,
  isObject_default as isObject,
  OptimizedImageHandler_exports as optimizedImageHandler,
  parseRuntype,
  truncateString_default as truncateString,
  userHasRequestedACL_default as userHasRequestedACL,
  validateEmail_default as validateEmail,
  validationRules_exports as validationRules,
  version
};
/*! Bundled license information:

uri-js/dist/es5/uri.all.js:
  (** @license URI.js v4.4.1 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js *)
*/
